var items = {
  "block.minecraft.acacia_button": "Boton nthànchaꞌa",
  "block.minecraft.acacia_door": "Nthàdijexín nthànchaꞌa",
  "block.minecraft.acacia_fence": "Chjàte nthànchaꞌa",
  "block.minecraft.acacia_fence_gate": "Nthàdijexín chjàte nthànchaꞌa",
  "block.minecraft.acacia_hanging_sign": "Nthàkjìxín nthànchaꞌa kè deriaꞌnda",
  "block.minecraft.acacia_leaves": "Kà nthànchaꞌa",
  "block.minecraft.acacia_log": "Nthàriuꞌu nthànchaꞌa",
  "block.minecraft.acacia_planks": "Nthàchiso nthànchaꞌa",
  "block.minecraft.acacia_pressure_plate": "Palaaka juangachje nthànchaꞌa",
  "block.minecraft.acacia_sapling": "Nthànchaꞌa kè chriꞌin",
  "block.minecraft.acacia_shelf": "Repiisa nthànchaꞌa",
  "block.minecraft.acacia_sign": "Nthàkjìxín nthànchaꞌa",
  "block.minecraft.acacia_slab": "Loosa nthànchaꞌa",
  "block.minecraft.acacia_stairs": "Eskaleera nthànchaꞌa",
  "block.minecraft.acacia_trapdoor": "Nthàdijexínchjàn nthànchaꞌa",
  "block.minecraft.acacia_wall_hanging_sign": "Nthàkjìxín nthànchaꞌa kè deriaꞌnda ngaìn kuubo",
  "block.minecraft.acacia_wall_sign": "Nthàkjìxín nthànchaꞌa ngaìn kuubo",
  "block.minecraft.acacia_wood": "Nthànchaꞌa",
  "block.minecraft.activator_rail": "Nthàchìà kè nchekaun",
  "block.minecraft.air": "Chrinthu",
  "block.minecraft.allium": "Tsjù thùaáju",
  "block.minecraft.amethyst_block": "Kuubo amatiista",
  "block.minecraft.amethyst_cluster": "Juaxratse amatiista",
  "block.minecraft.ancient_debris": "Thuꞌa nthaxii",
  "block.minecraft.andesite": "Andesiita",
  "block.minecraft.andesite_slab": "Loosa andesiita",
  "block.minecraft.andesite_stairs": "Eskaleera andesiita",
  "block.minecraft.andesite_wall": "Thjariuꞌù andesiita",
  "block.minecraft.anvil": "Yuunke",
  "block.minecraft.attached_melon_stem": "Nthaxijì nganitù thùsandia",
  "block.minecraft.attached_pumpkin_stem": "Nthaxijì nganitù chu",
  "block.minecraft.azalea": "Nthàrosadeelfa",
  "block.minecraft.azalea_leaves": "Kà nthàrosadeelfa",
  "block.minecraft.azure_bluet": "Tsjù rua",
  "block.minecraft.bamboo": "Tjì jié",
  "block.minecraft.bamboo_block": "Kuubo tjì jié",
  "block.minecraft.bamboo_button": "Boton tjì jié",
  "block.minecraft.bamboo_door": "Nthàdijexín tjì jié",
  "block.minecraft.bamboo_fence": "Chjàte tjì jié",
  "block.minecraft.bamboo_fence_gate": "Nthàdijexín chjàte tjì jié",
  "block.minecraft.bamboo_hanging_sign": "Nthàkjìxín tjì jié kè deriaꞌnda",
  "block.minecraft.bamboo_mosaic": "Mosaiko tjì jié",
  "block.minecraft.bamboo_mosaic_slab": "Loosa mosaaiko tjì jié",
  "block.minecraft.bamboo_mosaic_stairs": "Eskaleera mosaaiko tjì jié",
  "block.minecraft.bamboo_planks": "Nthàchiso tjì jié",
  "block.minecraft.bamboo_pressure_plate": "Palaaka juangachje tjì jié",
  "block.minecraft.bamboo_sapling": "Tjì jié kè chriꞌin",
  "block.minecraft.bamboo_shelf": "Repiisa tjì",
  "block.minecraft.bamboo_sign": "Nthàkjìxín tjì jié",
  "block.minecraft.bamboo_slab": "Loosa tjì jié",
  "block.minecraft.bamboo_stairs": "Eskaleera tjì jié",
  "block.minecraft.bamboo_trapdoor": "Nthàdijexínchjàn tjì jié",
  "block.minecraft.bamboo_wall_hanging_sign": "Nthàkjìxín tjì jié kè deriaꞌnda ngaìn kuubo",
  "block.minecraft.bamboo_wall_sign": "Nthàkjìxín tjì jié ngaìn kuubo",
  "block.minecraft.banner.base.black": "Thi ndáthié",
  "block.minecraft.banner.base.blue": "Thi ndáyùà",
  "block.minecraft.banner.base.brown": "Thi ndáseen",
  "block.minecraft.banner.base.cyan": "Thi ndáyùà ngajní",
  "block.minecraft.banner.base.gray": "Thi ndáxràtjù",
  "block.minecraft.banner.base.green": "Thi ndáyùà",
  "block.minecraft.banner.base.light_blue": "Thi ndáyùà",
  "block.minecraft.banner.base.light_gray": "Thi ndáxràtjù",
  "block.minecraft.banner.base.lime": "Thi ndáyùà",
  "block.minecraft.banner.base.magenta": "Thi ndájátsè",
  "block.minecraft.banner.base.orange": "Thi ndáthùnsán",
  "block.minecraft.banner.base.pink": "Thi ndátjuáꞌnde",
  "block.minecraft.banner.base.purple": "Thi ndájátsè thié",
  "block.minecraft.banner.base.red": "Thi ndájátsè",
  "block.minecraft.banner.base.white": "Thi ndárua",
  "block.minecraft.banner.base.yellow": "Thi ndásine",
  "block.minecraft.banner.border.black": "Thié ngandeꞌe thi",
  "block.minecraft.banner.border.blue": "Yùà ngandeꞌe thi",
  "block.minecraft.banner.border.brown": "Seen ngandeꞌe thi",
  "block.minecraft.banner.border.cyan": "Yùà ngajní ngandeꞌe thi",
  "block.minecraft.banner.border.gray": "Xràtjù ngandeꞌe thi",
  "block.minecraft.banner.border.green": "Yùà ngandeꞌe thi",
  "block.minecraft.banner.border.light_blue": "Yùà ngandeꞌe thi",
  "block.minecraft.banner.border.light_gray": "Xràtjù ngandeꞌe thi",
  "block.minecraft.banner.border.lime": "Yùà ngandeꞌe thi",
  "block.minecraft.banner.border.magenta": "Játsè ngandeꞌe thi",
  "block.minecraft.banner.border.orange": "Thùnsán ngandeꞌe thi",
  "block.minecraft.banner.border.pink": "Tjuáꞌnde ngandeꞌe thi",
  "block.minecraft.banner.border.purple": "Játsè thié ngandeꞌe thi",
  "block.minecraft.banner.border.red": "Játsè ngandeꞌe thi",
  "block.minecraft.banner.border.white": "Rua ngandeꞌe thi",
  "block.minecraft.banner.border.yellow": "Sine ngandeꞌe thi",
  "block.minecraft.banner.bricks.black": "Masonaado thié",
  "block.minecraft.banner.bricks.blue": "Masonaado yùà",
  "block.minecraft.banner.bricks.brown": "Masonaado seen",
  "block.minecraft.banner.bricks.cyan": "Masonaado yùà ngajní",
  "block.minecraft.banner.bricks.gray": "Masonaado xràtjù",
  "block.minecraft.banner.bricks.green": "Masonaado yùà",
  "block.minecraft.banner.bricks.light_blue": "Masonaado yùà",
  "block.minecraft.banner.bricks.light_gray": "Masonaado xràtjù",
  "block.minecraft.banner.bricks.lime": "Masonaado yùà",
  "block.minecraft.banner.bricks.magenta": "Masonaado játsè",
  "block.minecraft.banner.bricks.orange": "Masonaado thùnsán",
  "block.minecraft.banner.bricks.pink": "Masonaado tjuáꞌnde",
  "block.minecraft.banner.bricks.purple": "Masonaado játsè thié",
  "block.minecraft.banner.bricks.red": "Masonaado játsè",
  "block.minecraft.banner.bricks.white": "Masonaado rua",
  "block.minecraft.banner.bricks.yellow": "Masonaado sine",
  "block.minecraft.banner.circle.black": "Thulu thié",
  "block.minecraft.banner.circle.blue": "Thulu yùà",
  "block.minecraft.banner.circle.brown": "Thulu seen",
  "block.minecraft.banner.circle.cyan": "Thulu yùà ngajní",
  "block.minecraft.banner.circle.gray": "Thulu xràtjù",
  "block.minecraft.banner.circle.green": "Thulu yùà",
  "block.minecraft.banner.circle.light_blue": "Thulu yùà",
  "block.minecraft.banner.circle.light_gray": "Thulu xràtjù",
  "block.minecraft.banner.circle.lime": "Thulu yùà",
  "block.minecraft.banner.circle.magenta": "Thulu játsè",
  "block.minecraft.banner.circle.orange": "Thulu thùnsán",
  "block.minecraft.banner.circle.pink": "Thulu tjuáꞌnde",
  "block.minecraft.banner.circle.purple": "Thulu játsè thié",
  "block.minecraft.banner.circle.red": "Thulu játsè",
  "block.minecraft.banner.circle.white": "Thulu rua",
  "block.minecraft.banner.circle.yellow": "Thulu sine",
  "block.minecraft.banner.creeper.black": "Creeper thié",
  "block.minecraft.banner.creeper.blue": "Creeper yùà",
  "block.minecraft.banner.creeper.brown": "Creeper seen",
  "block.minecraft.banner.creeper.cyan": "Creeper yùà ngajní",
  "block.minecraft.banner.creeper.gray": "Creeper xràtjù",
  "block.minecraft.banner.creeper.green": "Creeper yùà",
  "block.minecraft.banner.creeper.light_blue": "Creeper yùà",
  "block.minecraft.banner.creeper.light_gray": "Creeper xràtjù",
  "block.minecraft.banner.creeper.lime": "Creeper yùà",
  "block.minecraft.banner.creeper.magenta": "Creeper játsè",
  "block.minecraft.banner.creeper.orange": "Creeper thùnsán",
  "block.minecraft.banner.creeper.pink": "Creeper tjuáꞌnde",
  "block.minecraft.banner.creeper.purple": "Creeper játsè thié",
  "block.minecraft.banner.creeper.red": "Creeper játsè",
  "block.minecraft.banner.creeper.white": "Creeper rua",
  "block.minecraft.banner.creeper.yellow": "Creeper sine",
  "block.minecraft.banner.cross.black": "Aaspa thié",
  "block.minecraft.banner.cross.blue": "Aaspa yùà",
  "block.minecraft.banner.cross.brown": "Aaspa seen",
  "block.minecraft.banner.cross.cyan": "Aaspa yùà ngajní",
  "block.minecraft.banner.cross.gray": "Aaspa xràtjù",
  "block.minecraft.banner.cross.green": "Aaspa yùà",
  "block.minecraft.banner.cross.light_blue": "Aaspa yùà",
  "block.minecraft.banner.cross.light_gray": "Aaspa xràtjù",
  "block.minecraft.banner.cross.lime": "Aaspa yùà",
  "block.minecraft.banner.cross.magenta": "Aaspa játsè",
  "block.minecraft.banner.cross.orange": "Aaspa thùnsán",
  "block.minecraft.banner.cross.pink": "Aaspa tjuáꞌnde",
  "block.minecraft.banner.cross.purple": "Aaspa játsè thié",
  "block.minecraft.banner.cross.red": "Aaspa játsè",
  "block.minecraft.banner.cross.white": "Aaspa rua",
  "block.minecraft.banner.cross.yellow": "Aaspa sine",
  "block.minecraft.banner.curly_border.black": "Nenu thié ngandeꞌe thi",
  "block.minecraft.banner.curly_border.blue": "Nenu yùà ngandeꞌe thi",
  "block.minecraft.banner.curly_border.brown": "Nenu seen ngandeꞌe thi",
  "block.minecraft.banner.curly_border.cyan": "Nenu yùà ngajní ngandeꞌe thi",
  "block.minecraft.banner.curly_border.gray": "Nenu xràtjù ngandeꞌe thi",
  "block.minecraft.banner.curly_border.green": "Nenu yùà ngandeꞌe thi",
  "block.minecraft.banner.curly_border.light_blue": "Nenu yùà ngandeꞌe thi",
  "block.minecraft.banner.curly_border.light_gray": "Nenu xràtjù ngandeꞌe thi",
  "block.minecraft.banner.curly_border.lime": "Nenu yùà ngandeꞌe thi",
  "block.minecraft.banner.curly_border.magenta": "Nenu játsè ngandeꞌe thi",
  "block.minecraft.banner.curly_border.orange": "Nenu thùnsán ngandeꞌe thi",
  "block.minecraft.banner.curly_border.pink": "Nenu tjuáꞌnde ngandeꞌe thi",
  "block.minecraft.banner.curly_border.purple": "Nenu játsè thié ngandeꞌe thi",
  "block.minecraft.banner.curly_border.red": "Nenu játsè ngandeꞌe thi",
  "block.minecraft.banner.curly_border.white": "Nenu rua ngandeꞌe thi",
  "block.minecraft.banner.curly_border.yellow": "Nenu sine ngandeꞌe thi",
  "block.minecraft.banner.diagonal_left.black": "Juataade thié",
  "block.minecraft.banner.diagonal_left.blue": "Juataade yùà",
  "block.minecraft.banner.diagonal_left.brown": "Juataade seen",
  "block.minecraft.banner.diagonal_left.cyan": "Juataade yùà ngajní",
  "block.minecraft.banner.diagonal_left.gray": "Juataade xràtjù",
  "block.minecraft.banner.diagonal_left.green": "Juataade yùà",
  "block.minecraft.banner.diagonal_left.light_blue": "Juataade yùà",
  "block.minecraft.banner.diagonal_left.light_gray": "Juataade xràtjù",
  "block.minecraft.banner.diagonal_left.lime": "Juataade yùà",
  "block.minecraft.banner.diagonal_left.magenta": "Juataade játsè",
  "block.minecraft.banner.diagonal_left.orange": "Juataade thùnsán",
  "block.minecraft.banner.diagonal_left.pink": "Juataade tjuáꞌnde",
  "block.minecraft.banner.diagonal_left.purple": "Juataade játsè thié",
  "block.minecraft.banner.diagonal_left.red": "Juataade játsè",
  "block.minecraft.banner.diagonal_left.white": "Juataade rua",
  "block.minecraft.banner.diagonal_left.yellow": "Juataade sine",
  "block.minecraft.banner.diagonal_right.black": "Juatunthai thié",
  "block.minecraft.banner.diagonal_right.blue": "Juatunthai yùà",
  "block.minecraft.banner.diagonal_right.brown": "Juatunthai seen",
  "block.minecraft.banner.diagonal_right.cyan": "Juatunthai yùà ngajní",
  "block.minecraft.banner.diagonal_right.gray": "Juatunthai xràtjù",
  "block.minecraft.banner.diagonal_right.green": "Juatunthai yùà",
  "block.minecraft.banner.diagonal_right.light_blue": "Juatunthai yùà",
  "block.minecraft.banner.diagonal_right.light_gray": "Juatunthai xràtjù",
  "block.minecraft.banner.diagonal_right.lime": "Juatunthai yùà",
  "block.minecraft.banner.diagonal_right.magenta": "Juatunthai játsè",
  "block.minecraft.banner.diagonal_right.orange": "Juatunthai thùnsán",
  "block.minecraft.banner.diagonal_right.pink": "Juatunthai tjuáꞌnde",
  "block.minecraft.banner.diagonal_right.purple": "Juatunthai játsè thié",
  "block.minecraft.banner.diagonal_right.red": "Juatunthai játsè",
  "block.minecraft.banner.diagonal_right.white": "Juatunthai rua",
  "block.minecraft.banner.diagonal_right.yellow": "Juatunthai sine",
  "block.minecraft.banner.diagonal_up_left.black": "Juatunthai thié kè kjamangia",
  "block.minecraft.banner.diagonal_up_left.blue": "Juatunthai yùà kè kjamangia",
  "block.minecraft.banner.diagonal_up_left.brown": "Juatunthai seen kè kjamangia",
  "block.minecraft.banner.diagonal_up_left.cyan": "Juatunthai yùà ngajní kè kjamangia",
  "block.minecraft.banner.diagonal_up_left.gray": "Juatunthai xràtjù kè kjamangia",
  "block.minecraft.banner.diagonal_up_left.green": "Juatunthai yùà kè kjamangia",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Juatunthai yùà kè kjamangia",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Juatunthai xràtjù kè kjamangia",
  "block.minecraft.banner.diagonal_up_left.lime": "Juatunthai yùà kè kjamangia",
  "block.minecraft.banner.diagonal_up_left.magenta": "Juatunthai játsè kè kjamangia",
  "block.minecraft.banner.diagonal_up_left.orange": "Juatunthai thùnsán kè kjamangia",
  "block.minecraft.banner.diagonal_up_left.pink": "Juatunthai tjuáꞌnde kè kjamangia",
  "block.minecraft.banner.diagonal_up_left.purple": "Juatunthai játsè thié kè kjamangia",
  "block.minecraft.banner.diagonal_up_left.red": "Juatunthai játsè kè kjamangia",
  "block.minecraft.banner.diagonal_up_left.white": "Juatunthai rua kè kjamangia",
  "block.minecraft.banner.diagonal_up_left.yellow": "Juatunthai sine kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.black": "Juataade thié kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.blue": "Juataade yùà kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.brown": "Juataade seen kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.cyan": "Juataade yùà ngajní kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.gray": "Juataade xràtjù kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.green": "Juataade yùà kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Juataade yùà kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Juataade xràtjù kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.lime": "Juataade yùà kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.magenta": "Juataade játsè kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.orange": "Juataade thùnsán kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.pink": "Juataade tjuáꞌnde kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.purple": "Juataade játsè thié kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.red": "Juataade játsè kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.white": "Juataade rua kè kjamangia",
  "block.minecraft.banner.diagonal_up_right.yellow": "Juataade sine kè kjamangia",
  "block.minecraft.banner.flow.black": "Espiira thié",
  "block.minecraft.banner.flow.blue": "Espiira yùà",
  "block.minecraft.banner.flow.brown": "Espiira seen",
  "block.minecraft.banner.flow.cyan": "Espiira yùà ngajní",
  "block.minecraft.banner.flow.gray": "Espiira xràtjù",
  "block.minecraft.banner.flow.green": "Espiira yùà",
  "block.minecraft.banner.flow.light_blue": "Espiira yùà",
  "block.minecraft.banner.flow.light_gray": "Espiira xràtjù",
  "block.minecraft.banner.flow.lime": "Espiira yùà",
  "block.minecraft.banner.flow.magenta": "Espiira játsè",
  "block.minecraft.banner.flow.orange": "Espiira thùnsán",
  "block.minecraft.banner.flow.pink": "Espiira tjuáꞌnde",
  "block.minecraft.banner.flow.purple": "Espiira játsè thié",
  "block.minecraft.banner.flow.red": "Espiira játsè",
  "block.minecraft.banner.flow.white": "Espiira rua",
  "block.minecraft.banner.flow.yellow": "Espiira sine",
  "block.minecraft.banner.flower.black": "Tsjù thié",
  "block.minecraft.banner.flower.blue": "Tsjù yùà",
  "block.minecraft.banner.flower.brown": "Tsjù seen",
  "block.minecraft.banner.flower.cyan": "Tsjù yùà ngajní",
  "block.minecraft.banner.flower.gray": "Tsjù xràtjù",
  "block.minecraft.banner.flower.green": "Tsjù yùà",
  "block.minecraft.banner.flower.light_blue": "Tsjù yùà",
  "block.minecraft.banner.flower.light_gray": "Tsjù xràtjù",
  "block.minecraft.banner.flower.lime": "Tsjù yùà",
  "block.minecraft.banner.flower.magenta": "Tsjù játsè",
  "block.minecraft.banner.flower.orange": "Tsjù thùnsán",
  "block.minecraft.banner.flower.pink": "Tsjù tjuáꞌnde",
  "block.minecraft.banner.flower.purple": "Tsjù játsè thié",
  "block.minecraft.banner.flower.red": "Tsjù játsè",
  "block.minecraft.banner.flower.white": "Tsjù rua",
  "block.minecraft.banner.flower.yellow": "Tsjù sine",
  "block.minecraft.banner.globe.black": "Nùnthè thié",
  "block.minecraft.banner.globe.blue": "Nùnthè yùà",
  "block.minecraft.banner.globe.brown": "Nùnthè seen",
  "block.minecraft.banner.globe.cyan": "Nùnthè yùà ngajní",
  "block.minecraft.banner.globe.gray": "Nùnthè xràtjù",
  "block.minecraft.banner.globe.green": "Nùnthè yùà",
  "block.minecraft.banner.globe.light_blue": "Nùnthè yùà",
  "block.minecraft.banner.globe.light_gray": "Nùnthè xràtjù",
  "block.minecraft.banner.globe.lime": "Nùnthè yùà",
  "block.minecraft.banner.globe.magenta": "Nùnthè játsè",
  "block.minecraft.banner.globe.orange": "Nùnthè thùnsán",
  "block.minecraft.banner.globe.pink": "Nùnthè tjuáꞌnde",
  "block.minecraft.banner.globe.purple": "Nùnthè játsè thié",
  "block.minecraft.banner.globe.red": "Nùnthè játsè",
  "block.minecraft.banner.globe.white": "Nùnthè rua",
  "block.minecraft.banner.globe.yellow": "Nùnthè sine",
  "block.minecraft.banner.gradient.black": "Gradieente thié",
  "block.minecraft.banner.gradient.blue": "Gradieente yùà",
  "block.minecraft.banner.gradient.brown": "Gradieente seen",
  "block.minecraft.banner.gradient.cyan": "Gradieente yùà ngajní",
  "block.minecraft.banner.gradient.gray": "Garadieente xràtjù",
  "block.minecraft.banner.gradient.green": "Gradieente yùà",
  "block.minecraft.banner.gradient.light_blue": "Gradieente yùà",
  "block.minecraft.banner.gradient.light_gray": "Garadieente xràtjù",
  "block.minecraft.banner.gradient.lime": "Gradieente yùà",
  "block.minecraft.banner.gradient.magenta": "Gradieente játsè",
  "block.minecraft.banner.gradient.orange": "Garadieente thùnsán",
  "block.minecraft.banner.gradient.pink": "Garadieente tjuáꞌnde",
  "block.minecraft.banner.gradient.purple": "Gradieente játsè thié",
  "block.minecraft.banner.gradient.red": "Gradieente játsè",
  "block.minecraft.banner.gradient.white": "Gradieente rua",
  "block.minecraft.banner.gradient.yellow": "Gradieente sine",
  "block.minecraft.banner.gradient_up.black": "Garadieente thié ngaìn ruthe",
  "block.minecraft.banner.gradient_up.blue": "Garadieente yùà ngaìn ruthe",
  "block.minecraft.banner.gradient_up.brown": "Garadieente seen ngaìn ruthe",
  "block.minecraft.banner.gradient_up.cyan": "Garadieente yùà ngajní ngaìn ruthe",
  "block.minecraft.banner.gradient_up.gray": "Garadieente xràtjù ngaìn ruthe",
  "block.minecraft.banner.gradient_up.green": "Garadieente yùà ngaìn ruthe",
  "block.minecraft.banner.gradient_up.light_blue": "Garadieente yùà ngaìn ruthe",
  "block.minecraft.banner.gradient_up.light_gray": "Garadieente xràtjù ngaìn ruthe",
  "block.minecraft.banner.gradient_up.lime": "Garadieente yùà ngaìn ruthe",
  "block.minecraft.banner.gradient_up.magenta": "Garadieente játsè ngaìn ruthe",
  "block.minecraft.banner.gradient_up.orange": "Garadieente thùnsán ngaìn ruthe",
  "block.minecraft.banner.gradient_up.pink": "Garadieente tjuáꞌnde ngaìn ruthe",
  "block.minecraft.banner.gradient_up.purple": "Garadieente játsè thié ngaìn ruthe",
  "block.minecraft.banner.gradient_up.red": "Garadieente játsè ngaìn ruthe",
  "block.minecraft.banner.gradient_up.white": "Garadieente rua ngaìn ruthe",
  "block.minecraft.banner.gradient_up.yellow": "Garadieente sine ngaìn ruthe",
  "block.minecraft.banner.guster.black": "Chrinthu thié",
  "block.minecraft.banner.guster.blue": "Chrinthu yùà",
  "block.minecraft.banner.guster.brown": "Chrinthu seen",
  "block.minecraft.banner.guster.cyan": "Chrinthu yùà ngajní",
  "block.minecraft.banner.guster.gray": "Chrinthu xràtjù",
  "block.minecraft.banner.guster.green": "Chrinthu yùà",
  "block.minecraft.banner.guster.light_blue": "Chrinthu yùà",
  "block.minecraft.banner.guster.light_gray": "Chrinthu xràtjù",
  "block.minecraft.banner.guster.lime": "Chrinthu yùà",
  "block.minecraft.banner.guster.magenta": "Chrinthu játsè",
  "block.minecraft.banner.guster.orange": "Chrinthu thùnsán",
  "block.minecraft.banner.guster.pink": "Chrinthu tjuáꞌnde",
  "block.minecraft.banner.guster.purple": "Chrinthu játsè thié",
  "block.minecraft.banner.guster.red": "Chrinthu játsè",
  "block.minecraft.banner.guster.white": "Chrinthu rua",
  "block.minecraft.banner.guster.yellow": "Chrinthu sine",
  "block.minecraft.banner.half_horizontal.black": "Juatunchrijindunga thié",
  "block.minecraft.banner.half_horizontal.blue": "Juatunchrijindunga yùà",
  "block.minecraft.banner.half_horizontal.brown": "Juatunchrijindunga seen",
  "block.minecraft.banner.half_horizontal.cyan": "Juatunchrijindunga yùà ngajní",
  "block.minecraft.banner.half_horizontal.gray": "Juatunchrijindunga xràtjù",
  "block.minecraft.banner.half_horizontal.green": "Juatunchrijindunga yùà",
  "block.minecraft.banner.half_horizontal.light_blue": "Juatunchrijindunga yùà",
  "block.minecraft.banner.half_horizontal.light_gray": "Juatunchrijindunga xràtjù",
  "block.minecraft.banner.half_horizontal.lime": "Juatunchrijindunga yùà",
  "block.minecraft.banner.half_horizontal.magenta": "Juatunchrijindunga játsè",
  "block.minecraft.banner.half_horizontal.orange": "Juatunchrijindunga thùnsán",
  "block.minecraft.banner.half_horizontal.pink": "Juatunchrijindunga tjuáꞌnde",
  "block.minecraft.banner.half_horizontal.purple": "Juatunchrijindunga játsè thié",
  "block.minecraft.banner.half_horizontal.red": "Juatunchrijindunga játsè",
  "block.minecraft.banner.half_horizontal.white": "Juatunchrijindunga rua",
  "block.minecraft.banner.half_horizontal.yellow": "Juatunchrijindunga sine",
  "block.minecraft.banner.half_horizontal_bottom.black": "Juatunchrijindunga thié kè kjamangia",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Juatunchrijindunga yùà kè kjamangia",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Juatunchrijindunga seen kè kjamangia",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Juatunchrijindunga yùà ngajní kè kjamangia",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Juatunchrijindunga xràtjù kè kjamangia",
  "block.minecraft.banner.half_horizontal_bottom.green": "Juatunchrijindunga yùà kè kjamangia",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Juatunchrijindunga yùà kè kjamangia",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Juatunchrijindunga xràtjù kè kjamangia",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Juatunchrijindunga yùà kè kjamangia",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Juatunchrijindunga játsè kè kjamangia",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Juatunchrijindunga thùnsán kè kjamangia",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Juatunchrijindunga tjuáꞌnde kè kjamangia",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Juatunchrijindunga játsè thié kè kjamangia",
  "block.minecraft.banner.half_horizontal_bottom.red": "Juatunchrijindunga játsè kè kjamangia",
  "block.minecraft.banner.half_horizontal_bottom.white": "Juatunchrijindunga rua kè kjamangia",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Juatunchrijindunga sine kè kjamangia",
  "block.minecraft.banner.half_vertical.black": "Juachjeeya thié",
  "block.minecraft.banner.half_vertical.blue": "Juachjeeya yùà",
  "block.minecraft.banner.half_vertical.brown": "Juachjeeya seen",
  "block.minecraft.banner.half_vertical.cyan": "Juachjeeya yùà ngajní",
  "block.minecraft.banner.half_vertical.gray": "Juachjeeya xràtjù",
  "block.minecraft.banner.half_vertical.green": "Juachjeeya yùà",
  "block.minecraft.banner.half_vertical.light_blue": "Juachjeeya yùà",
  "block.minecraft.banner.half_vertical.light_gray": "Juachjeeya xràtjù",
  "block.minecraft.banner.half_vertical.lime": "Juachjeeya yùà",
  "block.minecraft.banner.half_vertical.magenta": "Juachjeeya játsè",
  "block.minecraft.banner.half_vertical.orange": "Juachjeeya thùnsán",
  "block.minecraft.banner.half_vertical.pink": "Juachjeeya tjuáꞌnde",
  "block.minecraft.banner.half_vertical.purple": "Juachjeeya játsè thié",
  "block.minecraft.banner.half_vertical.red": "Juachjeeya játsè",
  "block.minecraft.banner.half_vertical.white": "Juachjeeya rua",
  "block.minecraft.banner.half_vertical.yellow": "Juachjeeya sine",
  "block.minecraft.banner.half_vertical_right.black": "Juachjeeya thié kè kjamangia",
  "block.minecraft.banner.half_vertical_right.blue": "Juachjeeya yùà kè kjamangia",
  "block.minecraft.banner.half_vertical_right.brown": "Juachjeeya seen kè kjamangia",
  "block.minecraft.banner.half_vertical_right.cyan": "Juachjeeya yùà ngajní kè kjamangia",
  "block.minecraft.banner.half_vertical_right.gray": "Juachjeeya xràtjù kè kjamangia",
  "block.minecraft.banner.half_vertical_right.green": "Juachjeeya yùà kè kjamangia",
  "block.minecraft.banner.half_vertical_right.light_blue": "Juachjeeya yùà kè kjamangia",
  "block.minecraft.banner.half_vertical_right.light_gray": "Juachjeeya xràtjù kè kjamangia",
  "block.minecraft.banner.half_vertical_right.lime": "Juachjeeya yùà kè kjamangia",
  "block.minecraft.banner.half_vertical_right.magenta": "Juachjeeya játsè kè kjamangia",
  "block.minecraft.banner.half_vertical_right.orange": "Juachjeeya thùnsán kè kjamangia",
  "block.minecraft.banner.half_vertical_right.pink": "Juachjeeya tjuáꞌnde kè kjamangia",
  "block.minecraft.banner.half_vertical_right.purple": "Juachjeeya játsè thié kè kjamangia",
  "block.minecraft.banner.half_vertical_right.red": "Juachjeeya játsè kè kjamangia",
  "block.minecraft.banner.half_vertical_right.white": "Juachjeeya rua kè kjamangia",
  "block.minecraft.banner.half_vertical_right.yellow": "Juachjeeya sine kè kjamangia",
  "block.minecraft.banner.mojang.black": "Chjiꞌni thié",
  "block.minecraft.banner.mojang.blue": "Chjiꞌni yùà",
  "block.minecraft.banner.mojang.brown": "Chjiꞌni seen",
  "block.minecraft.banner.mojang.cyan": "Chjiꞌni yùà ngajní",
  "block.minecraft.banner.mojang.gray": "Chjiꞌni xràtjù",
  "block.minecraft.banner.mojang.green": "Chjiꞌni yùà",
  "block.minecraft.banner.mojang.light_blue": "Chjiꞌni yùà",
  "block.minecraft.banner.mojang.light_gray": "Chjiꞌni xràtjù",
  "block.minecraft.banner.mojang.lime": "Chjiꞌni yùà",
  "block.minecraft.banner.mojang.magenta": "Chjiꞌni játsè",
  "block.minecraft.banner.mojang.orange": "Chjiꞌni thùnsán",
  "block.minecraft.banner.mojang.pink": "Chjiꞌni tjuáꞌnde",
  "block.minecraft.banner.mojang.purple": "Chjiꞌni játsè thié",
  "block.minecraft.banner.mojang.red": "Chjiꞌni játsè",
  "block.minecraft.banner.mojang.white": "Chjiꞌni rua",
  "block.minecraft.banner.mojang.yellow": "Chjiꞌni sine",
  "block.minecraft.banner.piglin.black": "Ruꞌa kuxíígu thié",
  "block.minecraft.banner.piglin.blue": "Ruꞌa kuxíígu yùà",
  "block.minecraft.banner.piglin.brown": "Ruꞌa kuxíígu seen",
  "block.minecraft.banner.piglin.cyan": "Ruꞌa kuxíígu yùà ngajní",
  "block.minecraft.banner.piglin.gray": "Ruꞌa kuxíígu xràtjù",
  "block.minecraft.banner.piglin.green": "Ruꞌa kuxíígu yùà",
  "block.minecraft.banner.piglin.light_blue": "Ruꞌa kuxíígu yùà",
  "block.minecraft.banner.piglin.light_gray": "Ruꞌa kuxíígu xràtjù",
  "block.minecraft.banner.piglin.lime": "Ruꞌa kuxíígu yùà",
  "block.minecraft.banner.piglin.magenta": "Ruꞌa kuxíígu játsè",
  "block.minecraft.banner.piglin.orange": "Ruꞌa kuxíígu thùnsán",
  "block.minecraft.banner.piglin.pink": "Ruꞌa kuxíígu tjuáꞌnde",
  "block.minecraft.banner.piglin.purple": "Ruꞌa kuxíígu játsè thié",
  "block.minecraft.banner.piglin.red": "Ruꞌa kuxíígu játsè",
  "block.minecraft.banner.piglin.white": "Ruꞌa kuxíígu rua",
  "block.minecraft.banner.piglin.yellow": "Ruꞌa kuxíígu sine",
  "block.minecraft.banner.rhombus.black": "Losaanje thié",
  "block.minecraft.banner.rhombus.blue": "Losaanje yùà",
  "block.minecraft.banner.rhombus.brown": "Losaanje seen",
  "block.minecraft.banner.rhombus.cyan": "Losaanje yùà ngajní",
  "block.minecraft.banner.rhombus.gray": "Losaanje xràtjù",
  "block.minecraft.banner.rhombus.green": "Losaanje yùà",
  "block.minecraft.banner.rhombus.light_blue": "Losaanje yùà",
  "block.minecraft.banner.rhombus.light_gray": "Losaanje xràtjù",
  "block.minecraft.banner.rhombus.lime": "Losaanje yùà",
  "block.minecraft.banner.rhombus.magenta": "Losaanje játsè",
  "block.minecraft.banner.rhombus.orange": "Losaanje thùnsán",
  "block.minecraft.banner.rhombus.pink": "Losaanje tjuáꞌnde",
  "block.minecraft.banner.rhombus.purple": "Losaanje játsè thié",
  "block.minecraft.banner.rhombus.red": "Losaanje játsè",
  "block.minecraft.banner.rhombus.white": "Losaanje rua",
  "block.minecraft.banner.rhombus.yellow": "Losaanje sine",
  "block.minecraft.banner.skull.black": "Nthàjàà ni thié",
  "block.minecraft.banner.skull.blue": "Nthàjàà ni yùà",
  "block.minecraft.banner.skull.brown": "Nthàjàà ni seen",
  "block.minecraft.banner.skull.cyan": "Nthàjàà ni yùà ngajní",
  "block.minecraft.banner.skull.gray": "Nthàjàà ni xràtjù",
  "block.minecraft.banner.skull.green": "Nthàjàà ni yùà",
  "block.minecraft.banner.skull.light_blue": "Nthàjàà ni yùà",
  "block.minecraft.banner.skull.light_gray": "Nthàjàà ni xràtjù",
  "block.minecraft.banner.skull.lime": "Nthàjàà ni yùà",
  "block.minecraft.banner.skull.magenta": "Nthàjàà ni játsè",
  "block.minecraft.banner.skull.orange": "Nthàjàà ni thùnsán",
  "block.minecraft.banner.skull.pink": "Nthàjàà ni tjuáꞌnde",
  "block.minecraft.banner.skull.purple": "Nthàjàà ni játsè thié",
  "block.minecraft.banner.skull.red": "Nthàjàà ni játsè",
  "block.minecraft.banner.skull.white": "Nthàjàà ni rua",
  "block.minecraft.banner.skull.yellow": "Nthàjàà ni sine",
  "block.minecraft.banner.small_stripes.black": "Nchetun thié",
  "block.minecraft.banner.small_stripes.blue": "Nchetun yùà",
  "block.minecraft.banner.small_stripes.brown": "Nchetun seen",
  "block.minecraft.banner.small_stripes.cyan": "Nchetun yùà ngajní",
  "block.minecraft.banner.small_stripes.gray": "Nchetun xràtjù",
  "block.minecraft.banner.small_stripes.green": "Nchetun yùà",
  "block.minecraft.banner.small_stripes.light_blue": "Nchetun yùà",
  "block.minecraft.banner.small_stripes.light_gray": "Nchetun xràtjù",
  "block.minecraft.banner.small_stripes.lime": "Nchetun yùà",
  "block.minecraft.banner.small_stripes.magenta": "Nchetun játsè",
  "block.minecraft.banner.small_stripes.orange": "Nchetun thùnsán",
  "block.minecraft.banner.small_stripes.pink": "Nchetun tjuáꞌnde",
  "block.minecraft.banner.small_stripes.purple": "Nchetun játsè thié",
  "block.minecraft.banner.small_stripes.red": "Nchetun játsè",
  "block.minecraft.banner.small_stripes.white": "Nchetun rua",
  "block.minecraft.banner.small_stripes.yellow": "Nchetun sine",
  "block.minecraft.banner.square_bottom_left.black": "Eskiina jían thié ngaìn ruthe",
  "block.minecraft.banner.square_bottom_left.blue": "Eskiina jían yùà ngaìn ruthe",
  "block.minecraft.banner.square_bottom_left.brown": "Eskiina jían seen ngaìn ruthe",
  "block.minecraft.banner.square_bottom_left.cyan": "Eskiina jían yùà ngajní ngaìn ruthe",
  "block.minecraft.banner.square_bottom_left.gray": "Eskiina jían xràtjù ngaìn ruthe",
  "block.minecraft.banner.square_bottom_left.green": "Eskiina jían yùà ngaìn ruthe",
  "block.minecraft.banner.square_bottom_left.light_blue": "Eskiina jían yùà ngaìn ruthe",
  "block.minecraft.banner.square_bottom_left.light_gray": "Eskiina jían xràtjù ngaìn ruthe",
  "block.minecraft.banner.square_bottom_left.lime": "Eskiina jían yùà ngaìn ruthe",
  "block.minecraft.banner.square_bottom_left.magenta": "Eskiina jían játsè ngaìn ruthe",
  "block.minecraft.banner.square_bottom_left.orange": "Eskiina jían thùnsán ngaìn ruthe",
  "block.minecraft.banner.square_bottom_left.pink": "Eskiina jían tjuáꞌnde ngaìn ruthe",
  "block.minecraft.banner.square_bottom_left.purple": "Eskiina jían játsè thié ngaìn ruthe",
  "block.minecraft.banner.square_bottom_left.red": "Eskiina jían játsè ngaìn ruthe",
  "block.minecraft.banner.square_bottom_left.white": "Eskiina jían rua ngaìn ruthe",
  "block.minecraft.banner.square_bottom_left.yellow": "Eskiina jían sine ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.black": "Eskiina kjun thié ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.blue": "Eskiina kjun yùà ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.brown": "Eskiina kjun seen ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.cyan": "Eskiina kjun yùà ngajní ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.gray": "Eskiina kjun xràtjù ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.green": "Eskiina kjun yùà ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.light_blue": "Eskiina kjun yùà ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.light_gray": "Eskiina kjun xràtjù ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.lime": "Eskiina kjun yùà ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.magenta": "Eskiina kjun játsè ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.orange": "Eskiina kjun thùnsán ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.pink": "Eskiina kjun tjuáꞌnde ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.purple": "Eskiina kjun játsè thié ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.red": "Eskiina kjun játsè ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.white": "Eskiina kjun rua ngaìn ruthe",
  "block.minecraft.banner.square_bottom_right.yellow": "Eskiina kjun sine ngaìn ruthe",
  "block.minecraft.banner.square_top_left.black": "Eskiina jían thié ngaìn kun",
  "block.minecraft.banner.square_top_left.blue": "Eskiina jían yùà ngaìn kun",
  "block.minecraft.banner.square_top_left.brown": "Eskiina jían seen ngaìn kun",
  "block.minecraft.banner.square_top_left.cyan": "Eskiina jían yùà ngajní ngaìn kun",
  "block.minecraft.banner.square_top_left.gray": "Eskiina jían xràtjù ngaìn kun",
  "block.minecraft.banner.square_top_left.green": "Eskiina jían yùà ngaìn kun",
  "block.minecraft.banner.square_top_left.light_blue": "Eskiina jían yùà ngaìn kun",
  "block.minecraft.banner.square_top_left.light_gray": "Eskiina jían xràtjù ngaìn kun",
  "block.minecraft.banner.square_top_left.lime": "Eskiina jían yùà ngaìn kun",
  "block.minecraft.banner.square_top_left.magenta": "Eskiina jían játsè ngaìn kun",
  "block.minecraft.banner.square_top_left.orange": "Eskiina jían thùnsán ngaìn kun",
  "block.minecraft.banner.square_top_left.pink": "Eskiina jían tjuáꞌnde ngaìn kun",
  "block.minecraft.banner.square_top_left.purple": "Eskiina jían játsè thié ngaìn kun",
  "block.minecraft.banner.square_top_left.red": "Eskiina jían játsè ngaìn kun",
  "block.minecraft.banner.square_top_left.white": "Eskiina jían rua ngaìn kun",
  "block.minecraft.banner.square_top_left.yellow": "Eskiina jían sine ngaìn kun",
  "block.minecraft.banner.square_top_right.black": "Eskiina kjun thié ngaìn kun",
  "block.minecraft.banner.square_top_right.blue": "Eskiina kjun yùà ngaìn kun",
  "block.minecraft.banner.square_top_right.brown": "Eskiina kjun seen ngaìn kun",
  "block.minecraft.banner.square_top_right.cyan": "Eskiina kjun yùà ngajní ngaìn kun",
  "block.minecraft.banner.square_top_right.gray": "Eskiina kjun xràtjù ngaìn kun",
  "block.minecraft.banner.square_top_right.green": "Eskiina kjun yùà ngaìn kun",
  "block.minecraft.banner.square_top_right.light_blue": "Eskiina kjun yùà ngaìn kun",
  "block.minecraft.banner.square_top_right.light_gray": "Eskiina kjun xràtjù ngaìn kun",
  "block.minecraft.banner.square_top_right.lime": "Eskiina kjun yùà ngaìn kun",
  "block.minecraft.banner.square_top_right.magenta": "Eskiina kjun játsè ngaìn kun",
  "block.minecraft.banner.square_top_right.orange": "Eskiina kjun thùnsán ngaìn kun",
  "block.minecraft.banner.square_top_right.pink": "Eskiina kjun tjuáꞌnde ngaìn kun",
  "block.minecraft.banner.square_top_right.purple": "Eskiina kjun játsè thié ngaìn kun",
  "block.minecraft.banner.square_top_right.red": "Eskiina kjun játsè ngaìn kun",
  "block.minecraft.banner.square_top_right.white": "Eskiina kjun rua ngaìn kun",
  "block.minecraft.banner.square_top_right.yellow": "Eskiina kjun sine ngaìn kun",
  "block.minecraft.banner.straight_cross.black": "Krús thié",
  "block.minecraft.banner.straight_cross.blue": "Krús yùà",
  "block.minecraft.banner.straight_cross.brown": "Krús seen",
  "block.minecraft.banner.straight_cross.cyan": "Krús yùà ngajní",
  "block.minecraft.banner.straight_cross.gray": "Krús xràtjù",
  "block.minecraft.banner.straight_cross.green": "Krús yùà",
  "block.minecraft.banner.straight_cross.light_blue": "Krús yùà",
  "block.minecraft.banner.straight_cross.light_gray": "Krús xràtjù",
  "block.minecraft.banner.straight_cross.lime": "Krús yùà",
  "block.minecraft.banner.straight_cross.magenta": "Krús játsè",
  "block.minecraft.banner.straight_cross.orange": "Krús thùnsán",
  "block.minecraft.banner.straight_cross.pink": "Krús tjuáꞌnde",
  "block.minecraft.banner.straight_cross.purple": "Krús játsè thié",
  "block.minecraft.banner.straight_cross.red": "Krús játsè",
  "block.minecraft.banner.straight_cross.white": "Krús rua",
  "block.minecraft.banner.straight_cross.yellow": "Krús sine",
  "block.minecraft.banner.stripe_bottom.black": "Ruthe thié",
  "block.minecraft.banner.stripe_bottom.blue": "Ruthe yùà",
  "block.minecraft.banner.stripe_bottom.brown": "Ruthe seen",
  "block.minecraft.banner.stripe_bottom.cyan": "Ruthe yùà ngajní",
  "block.minecraft.banner.stripe_bottom.gray": "Ruthe xràtjù",
  "block.minecraft.banner.stripe_bottom.green": "Ruthe yùà",
  "block.minecraft.banner.stripe_bottom.light_blue": "Ruthe yùà",
  "block.minecraft.banner.stripe_bottom.light_gray": "Ruthe xràtjù",
  "block.minecraft.banner.stripe_bottom.lime": "Ruthe yùà",
  "block.minecraft.banner.stripe_bottom.magenta": "Ruthe játsè",
  "block.minecraft.banner.stripe_bottom.orange": "Ruthe thùnsán",
  "block.minecraft.banner.stripe_bottom.pink": "Ruthe tjuáꞌnde",
  "block.minecraft.banner.stripe_bottom.purple": "Ruthe játsè thié",
  "block.minecraft.banner.stripe_bottom.red": "Ruthe játsè",
  "block.minecraft.banner.stripe_bottom.white": "Ruthe rua",
  "block.minecraft.banner.stripe_bottom.yellow": "Ruthe sine",
  "block.minecraft.banner.stripe_center.black": "Tun thié",
  "block.minecraft.banner.stripe_center.blue": "Tun yùà",
  "block.minecraft.banner.stripe_center.brown": "Tun seen",
  "block.minecraft.banner.stripe_center.cyan": "Tun yùà ngajní",
  "block.minecraft.banner.stripe_center.gray": "Tun xràtjù",
  "block.minecraft.banner.stripe_center.green": "Tun yùà",
  "block.minecraft.banner.stripe_center.light_blue": "Tun yùà",
  "block.minecraft.banner.stripe_center.light_gray": "Tun xràtjù",
  "block.minecraft.banner.stripe_center.lime": "Tun yùà",
  "block.minecraft.banner.stripe_center.magenta": "Tun játsè",
  "block.minecraft.banner.stripe_center.orange": "Tun thùnsán",
  "block.minecraft.banner.stripe_center.pink": "Tun tjuáꞌnde",
  "block.minecraft.banner.stripe_center.purple": "Tun játsè thié",
  "block.minecraft.banner.stripe_center.red": "Tun játsè",
  "block.minecraft.banner.stripe_center.white": "Tun rua",
  "block.minecraft.banner.stripe_center.yellow": "Tun sine",
  "block.minecraft.banner.stripe_downleft.black": "Nthàsen thié",
  "block.minecraft.banner.stripe_downleft.blue": "Nthàsen yùà",
  "block.minecraft.banner.stripe_downleft.brown": "Nthàsen seen",
  "block.minecraft.banner.stripe_downleft.cyan": "Nthàsen yùà ngajní",
  "block.minecraft.banner.stripe_downleft.gray": "Nthàsen xràtjù",
  "block.minecraft.banner.stripe_downleft.green": "Nthàsen yùà",
  "block.minecraft.banner.stripe_downleft.light_blue": "Nthàsen yùà",
  "block.minecraft.banner.stripe_downleft.light_gray": "Nthàsen xràtjù",
  "block.minecraft.banner.stripe_downleft.lime": "Nthàsen yùà",
  "block.minecraft.banner.stripe_downleft.magenta": "Nthàsen játsè",
  "block.minecraft.banner.stripe_downleft.orange": "Nthàsen thùnsán",
  "block.minecraft.banner.stripe_downleft.pink": "Nthàsen tjuáꞌnde",
  "block.minecraft.banner.stripe_downleft.purple": "Nthàsen játsè thié",
  "block.minecraft.banner.stripe_downleft.red": "Nthàsen játsè",
  "block.minecraft.banner.stripe_downleft.white": "Nthàsen rua",
  "block.minecraft.banner.stripe_downleft.yellow": "Nthàsen sine",
  "block.minecraft.banner.stripe_downright.black": "Baanda thié",
  "block.minecraft.banner.stripe_downright.blue": "Baanda yùà",
  "block.minecraft.banner.stripe_downright.brown": "Baanda seen",
  "block.minecraft.banner.stripe_downright.cyan": "Baanda yùà ngajní",
  "block.minecraft.banner.stripe_downright.gray": "Baanda xràtjù",
  "block.minecraft.banner.stripe_downright.green": "Baanda yùà",
  "block.minecraft.banner.stripe_downright.light_blue": "Baanda yùà",
  "block.minecraft.banner.stripe_downright.light_gray": "Baanda xràtjù",
  "block.minecraft.banner.stripe_downright.lime": "Baanda yùà",
  "block.minecraft.banner.stripe_downright.magenta": "Baanda játsè",
  "block.minecraft.banner.stripe_downright.orange": "Baanda thùnsán",
  "block.minecraft.banner.stripe_downright.pink": "Baanda tjuáꞌnde",
  "block.minecraft.banner.stripe_downright.purple": "Baanda játsè thié",
  "block.minecraft.banner.stripe_downright.red": "Baanda játsè",
  "block.minecraft.banner.stripe_downright.white": "Baanda rua",
  "block.minecraft.banner.stripe_downright.yellow": "Baanda sine",
  "block.minecraft.banner.stripe_left.black": "Nthàà thié ngaìn kuenxín",
  "block.minecraft.banner.stripe_left.blue": "Nthàà yùà ngaìn kuenxín",
  "block.minecraft.banner.stripe_left.brown": "Nthàà seen ngaìn kuenxín",
  "block.minecraft.banner.stripe_left.cyan": "Nthàà yùà ngajní ngaìn kuenxín",
  "block.minecraft.banner.stripe_left.gray": "Nthàà xràtjù ngaìn kuenxín",
  "block.minecraft.banner.stripe_left.green": "Nthàà yùà ngaìn kuenxín",
  "block.minecraft.banner.stripe_left.light_blue": "Nthàà yùà ngaìn kuenxín",
  "block.minecraft.banner.stripe_left.light_gray": "Nthàà xràtjù ngaìn kuenxín",
  "block.minecraft.banner.stripe_left.lime": "Nthàà yùà ngaìn kuenxín",
  "block.minecraft.banner.stripe_left.magenta": "Nthàà játsè ngaìn kuenxín",
  "block.minecraft.banner.stripe_left.orange": "Nthàà thùnsán ngaìn kuenxín",
  "block.minecraft.banner.stripe_left.pink": "Nthàà tjuáꞌnde ngaìn kuenxín",
  "block.minecraft.banner.stripe_left.purple": "Nthàà játsè thié ngaìn kuenxín",
  "block.minecraft.banner.stripe_left.red": "Nthàà játsè ngaìn kuenxín",
  "block.minecraft.banner.stripe_left.white": "Nthàà rua ngaìn kuenxín",
  "block.minecraft.banner.stripe_left.yellow": "Nthàà sine ngaìn kuenxín",
  "block.minecraft.banner.stripe_middle.black": "Faaja thié",
  "block.minecraft.banner.stripe_middle.blue": "Faaja yùà",
  "block.minecraft.banner.stripe_middle.brown": "Faaja seen",
  "block.minecraft.banner.stripe_middle.cyan": "Faaja yùà ngajní",
  "block.minecraft.banner.stripe_middle.gray": "Faaja xràtjù",
  "block.minecraft.banner.stripe_middle.green": "Faaja yùà",
  "block.minecraft.banner.stripe_middle.light_blue": "Faaja yùà",
  "block.minecraft.banner.stripe_middle.light_gray": "Faaja xràtjù",
  "block.minecraft.banner.stripe_middle.lime": "Faaja yùà",
  "block.minecraft.banner.stripe_middle.magenta": "Faaja játsè",
  "block.minecraft.banner.stripe_middle.orange": "Faaja thùnsán",
  "block.minecraft.banner.stripe_middle.pink": "Faaja tjuáꞌnde",
  "block.minecraft.banner.stripe_middle.purple": "Faaja játsè thié",
  "block.minecraft.banner.stripe_middle.red": "Faaja játsè",
  "block.minecraft.banner.stripe_middle.white": "Faaja rua",
  "block.minecraft.banner.stripe_middle.yellow": "Faaja sine",
  "block.minecraft.banner.stripe_right.black": "Nthàà kjun thié",
  "block.minecraft.banner.stripe_right.blue": "Nthàà kjun yùà",
  "block.minecraft.banner.stripe_right.brown": "Nthàà kjun seen",
  "block.minecraft.banner.stripe_right.cyan": "Nthàà kjun yùà ngajní",
  "block.minecraft.banner.stripe_right.gray": "Nthàà kjun xràtjù",
  "block.minecraft.banner.stripe_right.green": "Nthàà kjun yùà",
  "block.minecraft.banner.stripe_right.light_blue": "Nthàà kjun yùà",
  "block.minecraft.banner.stripe_right.light_gray": "Nthàà kjun xràtjù",
  "block.minecraft.banner.stripe_right.lime": "Nthàà kjun yùà",
  "block.minecraft.banner.stripe_right.magenta": "Nthàà kjun játsè",
  "block.minecraft.banner.stripe_right.orange": "Nthàà kjun thùnsán",
  "block.minecraft.banner.stripe_right.pink": "Nthàà kjun tjuáꞌnde",
  "block.minecraft.banner.stripe_right.purple": "Nthàà kjun játsè thié",
  "block.minecraft.banner.stripe_right.red": "Nthàà kjun játsè",
  "block.minecraft.banner.stripe_right.white": "Nthàà kjun rua",
  "block.minecraft.banner.stripe_right.yellow": "Nthàà kjun sine",
  "block.minecraft.banner.stripe_top.black": "Kun thi thié",
  "block.minecraft.banner.stripe_top.blue": "Kun thi yùà",
  "block.minecraft.banner.stripe_top.brown": "Kun thi seen",
  "block.minecraft.banner.stripe_top.cyan": "Kun thi yùà ngajní",
  "block.minecraft.banner.stripe_top.gray": "Kun thi xràtjù",
  "block.minecraft.banner.stripe_top.green": "Kun thi yùà",
  "block.minecraft.banner.stripe_top.light_blue": "Kun thi yùà",
  "block.minecraft.banner.stripe_top.light_gray": "Kun thi xràtjù",
  "block.minecraft.banner.stripe_top.lime": "Kun thi yùà",
  "block.minecraft.banner.stripe_top.magenta": "Kun thi játsè",
  "block.minecraft.banner.stripe_top.orange": "Kun thi thùnsán",
  "block.minecraft.banner.stripe_top.pink": "Kun thi tjuáꞌnde",
  "block.minecraft.banner.stripe_top.purple": "Kun thi játsè thié",
  "block.minecraft.banner.stripe_top.red": "Kun thi játsè",
  "block.minecraft.banner.stripe_top.white": "Kun thi rua",
  "block.minecraft.banner.stripe_top.yellow": "Kun thi sine",
  "block.minecraft.banner.triangle_bottom.black": "Cheuron thié",
  "block.minecraft.banner.triangle_bottom.blue": "Cheuron yùà",
  "block.minecraft.banner.triangle_bottom.brown": "Cheuron seen",
  "block.minecraft.banner.triangle_bottom.cyan": "Cheuron yùà ngajní",
  "block.minecraft.banner.triangle_bottom.gray": "Cheuron xràtjù",
  "block.minecraft.banner.triangle_bottom.green": "Cheuron yùà",
  "block.minecraft.banner.triangle_bottom.light_blue": "Cheuron yùà",
  "block.minecraft.banner.triangle_bottom.light_gray": "Cheuron xràtjù",
  "block.minecraft.banner.triangle_bottom.lime": "Cheuron yùà",
  "block.minecraft.banner.triangle_bottom.magenta": "Cheuron játsè",
  "block.minecraft.banner.triangle_bottom.orange": "Cheuron thùnsán",
  "block.minecraft.banner.triangle_bottom.pink": "Cheuron tjuáꞌnde",
  "block.minecraft.banner.triangle_bottom.purple": "Cheuron játsè thié",
  "block.minecraft.banner.triangle_bottom.red": "Cheuron játsè",
  "block.minecraft.banner.triangle_bottom.white": "Cheuron rua",
  "block.minecraft.banner.triangle_bottom.yellow": "Cheuron sine",
  "block.minecraft.banner.triangle_top.black": "Cheuron thié kè kjamangia",
  "block.minecraft.banner.triangle_top.blue": "Cheuron yùà kè kjamangia",
  "block.minecraft.banner.triangle_top.brown": "Cheuron seen kè kjamangia",
  "block.minecraft.banner.triangle_top.cyan": "Cheuron yùà ngajní kè kjamangia",
  "block.minecraft.banner.triangle_top.gray": "Cheuron xràtjù kè kjamangia",
  "block.minecraft.banner.triangle_top.green": "Cheuron yùà kè kjamangia",
  "block.minecraft.banner.triangle_top.light_blue": "Cheuron yùà kè kjamangia",
  "block.minecraft.banner.triangle_top.light_gray": "Cheuron xràtjù kè kjamangia",
  "block.minecraft.banner.triangle_top.lime": "Cheuron yùà kè kjamangia",
  "block.minecraft.banner.triangle_top.magenta": "Cheuron játsè kè kjamangia",
  "block.minecraft.banner.triangle_top.orange": "Cheuron thùnsán kè kjamangia",
  "block.minecraft.banner.triangle_top.pink": "Cheuron tjuáꞌnde kè kjamangia",
  "block.minecraft.banner.triangle_top.purple": "Cheuron játsè thié kè kjamangia",
  "block.minecraft.banner.triangle_top.red": "Cheuron játsè kè kjamangia",
  "block.minecraft.banner.triangle_top.white": "Cheuron rua kè kjamangia",
  "block.minecraft.banner.triangle_top.yellow": "Cheuron sine kè kjamangia",
  "block.minecraft.banner.triangles_bottom.black": "Ruthe kuníxin nenu thié",
  "block.minecraft.banner.triangles_bottom.blue": "Ruthe kuníxin nenu yùà",
  "block.minecraft.banner.triangles_bottom.brown": "Ruthe kuníxin nenu seen",
  "block.minecraft.banner.triangles_bottom.cyan": "Ruthe kuníxin nenu yùà ngajní",
  "block.minecraft.banner.triangles_bottom.gray": "Ruthe kuníxin nenu xràtjù",
  "block.minecraft.banner.triangles_bottom.green": "Ruthe kuníxin nenu yùà",
  "block.minecraft.banner.triangles_bottom.light_blue": "Ruthe kuníxin nenu yùà",
  "block.minecraft.banner.triangles_bottom.light_gray": "Ruthe kuníxin nenu xràtjù",
  "block.minecraft.banner.triangles_bottom.lime": "Ruthe kuníxin nenu yùà",
  "block.minecraft.banner.triangles_bottom.magenta": "Ruthe kuníxin nenu játsè",
  "block.minecraft.banner.triangles_bottom.orange": "Ruthe kuníxin nenu thùnsán",
  "block.minecraft.banner.triangles_bottom.pink": "Ruthe kuníxin nenu tjuáꞌnde",
  "block.minecraft.banner.triangles_bottom.purple": "Ruthe kuníxin nenu játsè thié",
  "block.minecraft.banner.triangles_bottom.red": "Ruthe kuníxin nenu játsè",
  "block.minecraft.banner.triangles_bottom.white": "Ruthe kuníxin nenu rua",
  "block.minecraft.banner.triangles_bottom.yellow": "Ruthe kuníxin nenu sine",
  "block.minecraft.banner.triangles_top.black": "Kun thi kuníxin nenu thié",
  "block.minecraft.banner.triangles_top.blue": "Kun thi kuníxin nenu yùà",
  "block.minecraft.banner.triangles_top.brown": "Kun thi kuníxin nenu seen",
  "block.minecraft.banner.triangles_top.cyan": "Kun thi kuníxin nenu yùà ngajní",
  "block.minecraft.banner.triangles_top.gray": "Kun thi kuníxin nenu xràtjù",
  "block.minecraft.banner.triangles_top.green": "Kun thi kuníxin nenu yùà",
  "block.minecraft.banner.triangles_top.light_blue": "Kun thi kuníxin nenu yùà",
  "block.minecraft.banner.triangles_top.light_gray": "Kun thi kuníxin nenu xràtjù",
  "block.minecraft.banner.triangles_top.lime": "Kun thi kuníxin nenu yùà",
  "block.minecraft.banner.triangles_top.magenta": "Kun thi kuníxin nenu játsè",
  "block.minecraft.banner.triangles_top.orange": "Kun thi kuníxin nenu thùnsán",
  "block.minecraft.banner.triangles_top.pink": "Kun thi kuníxin nenu tjuáꞌnde",
  "block.minecraft.banner.triangles_top.purple": "Kun thi kuníxin nenu játsè thié",
  "block.minecraft.banner.triangles_top.red": "Kun thi kuníxin nenu játsè",
  "block.minecraft.banner.triangles_top.white": "Kun thi kuníxin nenu rua",
  "block.minecraft.banner.triangles_top.yellow": "Kun thi kuníxin nenu sine",
  "block.minecraft.barrel": "Kuñeete",
  "block.minecraft.barrier": "Barreera",
  "block.minecraft.basalt": "Basaalto",
  "block.minecraft.beacon": "Faaro",
  "block.minecraft.beacon.primary": "Saꞌú juachaxín",
  "block.minecraft.beacon.secondary": "Yuxín juachaxín",
  "block.minecraft.bed.no_sleep": "Jeꞌu nchaú sàrichrìn ngaaya thìe o nganduaꞌe chrìn chrinthu",
  "block.minecraft.bed.not_safe": "Chruꞌa sàrichrìn jàì: jíi kumoonstoro chìan",
  "block.minecraft.bed.obstructed": "Saun jíꞌì xranutaun",
  "block.minecraft.bed.occupied": "Saun jíꞌì jíchre",
  "block.minecraft.bed.too_far_away": "Chruꞌa sàrichrìn jàì: saun jíi ántu kjín",
  "block.minecraft.bedrock": "Xru saꞌú",
  "block.minecraft.bee_nest": "Katje",
  "block.minecraft.beehive": "Nchìà kutsjènda",
  "block.minecraft.beetroots": "Thùremolaacha",
  "block.minecraft.bell": "Chìà",
  "block.minecraft.big_dripleaf": "Kàdatsinxín jié",
  "block.minecraft.big_dripleaf_stem": "Nthaxijì kàdatsinxín jié",
  "block.minecraft.birch_button": "Boton nthàbetuula",
  "block.minecraft.birch_door": "Nthàdijexín nthàbetuula",
  "block.minecraft.birch_fence": "Chjàte nthàbetuula",
  "block.minecraft.birch_fence_gate": "Nthàdijexín chjàte nthàbetuula",
  "block.minecraft.birch_hanging_sign": "Nthàkjìxín nthàbetuula kè deriaꞌnda",
  "block.minecraft.birch_leaves": "Kà nthàbetuula",
  "block.minecraft.birch_log": "Nthàriuꞌu nthàbetuula",
  "block.minecraft.birch_planks": "Nthàchiso nthàbetuula",
  "block.minecraft.birch_pressure_plate": "Palaaka juangachje nthàbetuula",
  "block.minecraft.birch_sapling": "Nthàbetuula kè chriꞌin",
  "block.minecraft.birch_shelf": "Repiisa nthàbetuula",
  "block.minecraft.birch_sign": "Nthàkjìxín nthàbetuula",
  "block.minecraft.birch_slab": "Loosa nthàbetuula",
  "block.minecraft.birch_stairs": "Eskaleera nthàbetuula",
  "block.minecraft.birch_trapdoor": "Nthàdijexínchjàn nthàbetuula",
  "block.minecraft.birch_wall_hanging_sign": "Nthàkjìxín nthàbetuula kè deriaꞌnda ngaìn kuubo",
  "block.minecraft.birch_wall_sign": "Nthàkjìxín nthàbetuula ngaìn kuubo",
  "block.minecraft.birch_wood": "Nthàbetuula",
  "block.minecraft.black_banner": "Bandeera thié",
  "block.minecraft.black_bed": "Saun thié",
  "block.minecraft.black_candle": "Nchicha thié",
  "block.minecraft.black_candle_cake": "Pasteele kuníxin nchicha thié",
  "block.minecraft.black_carpet": "Tepeete thié",
  "block.minecraft.black_concrete": "Ormigon thié",
  "block.minecraft.black_concrete_powder": "Semeento thié",
  "block.minecraft.black_glazed_terracotta": "Asuleejo thié",
  "block.minecraft.black_shulker_box": "Kajón shulker thié",
  "block.minecraft.black_stained_glass": "Xruxrau thié",
  "block.minecraft.black_stained_glass_pane": "Paneele xruxrau thié",
  "block.minecraft.black_terracotta": "Nchètjau tsíchján thié",
  "block.minecraft.black_wool": "Chjun thié",
  "block.minecraft.blackstone": "Xruthié",
  "block.minecraft.blackstone_slab": "Loosa xruthié",
  "block.minecraft.blackstone_stairs": "Eskaleera xruthié",
  "block.minecraft.blackstone_wall": "Thjariuꞌù thié",
  "block.minecraft.blast_furnace": "Jié thja",
  "block.minecraft.blue_banner": "Bandeera yùà",
  "block.minecraft.blue_bed": "Saun yùà",
  "block.minecraft.blue_candle": "Nchicha yùà",
  "block.minecraft.blue_candle_cake": "Pasteele kuníxin nchicha yùà",
  "block.minecraft.blue_carpet": "Tepeete yùà",
  "block.minecraft.blue_concrete": "Ormigon yùà",
  "block.minecraft.blue_concrete_powder": "Semeento yùà",
  "block.minecraft.blue_glazed_terracotta": "Asuleejo yùà",
  "block.minecraft.blue_ice": "Chrintha yùà",
  "block.minecraft.blue_orchid": "Tsjùchà",
  "block.minecraft.blue_shulker_box": "Kajón shulker yùà",
  "block.minecraft.blue_stained_glass": "Xruxrau yùà",
  "block.minecraft.blue_stained_glass_pane": "Paneele xruxrau yùà",
  "block.minecraft.blue_terracotta": "Nchètjau tsíchján yùà",
  "block.minecraft.blue_wool": "Chjun yùà",
  "block.minecraft.bone_block": "Kuubo luru",
  "block.minecraft.bookshelf": "Nthàdàkèxín xrùun",
  "block.minecraft.brain_coral": "Kàndachaun thjele",
  "block.minecraft.brain_coral_block": "Kuubo kàndachaun thjele",
  "block.minecraft.brain_coral_fan": "Kugorgoonia thjele",
  "block.minecraft.brain_coral_wall_fan": "Kugorgoonia thjele ngaìn kuubo",
  "block.minecraft.brewing_stand": "Alkataara",
  "block.minecraft.brick_slab": "Loosa xrunùnthèchján",
  "block.minecraft.brick_stairs": "Eskaleera xrunùnthèchján",
  "block.minecraft.brick_wall": "Thjariuꞌù xrunùnthèchján",
  "block.minecraft.bricks": "Xrunùnthèchján",
  "block.minecraft.brown_banner": "Bandeera seen",
  "block.minecraft.brown_bed": "Saun seen",
  "block.minecraft.brown_candle": "Nchicha seen",
  "block.minecraft.brown_candle_cake": "Pasteele kuníxin nchicha seen",
  "block.minecraft.brown_carpet": "Tapeete seen",
  "block.minecraft.brown_concrete": "Ormigon seen",
  "block.minecraft.brown_concrete_powder": "Semeento seen",
  "block.minecraft.brown_glazed_terracotta": "Asuleejo seen",
  "block.minecraft.brown_mushroom": "Kuchrjuì seen",
  "block.minecraft.brown_mushroom_block": "Kuubo kuchrjuì seen",
  "block.minecraft.brown_shulker_box": "Kajón shulker seen",
  "block.minecraft.brown_stained_glass": "Xruxrau seen",
  "block.minecraft.brown_stained_glass_pane": "Paneele xruxrau seen",
  "block.minecraft.brown_terracotta": "Nchètjau tsíchján seen",
  "block.minecraft.brown_wool": "Chjun seen",
  "block.minecraft.bubble_column": "Nchetun burbuuja",
  "block.minecraft.bubble_coral": "Kàndachaun burbuuja",
  "block.minecraft.bubble_coral_block": "Kuubo kàndachaun burbuuja",
  "block.minecraft.bubble_coral_fan": "Kugorgoonia burbuuja",
  "block.minecraft.bubble_coral_wall_fan": "Kugorgoonia burbuuja ngaìn kuubo",
  "block.minecraft.budding_amethyst": "Xru thí chriꞌin amatiista",
  "block.minecraft.bush": "Nthàà",
  "block.minecraft.cactus": "Nthàà",
  "block.minecraft.cactus_flower": "Tsjù nthàà",
  "block.minecraft.cake": "Pasteele",
  "block.minecraft.calcite": "Kalsiita",
  "block.minecraft.calibrated_sculk_sensor": "Thí tunuꞌe Sculk ntheedu",
  "block.minecraft.campfire": "Giꞌi",
  "block.minecraft.candle": "Nchicha",
  "block.minecraft.candle_cake": "Pasteele kuníxin nchicha",
  "block.minecraft.carrots": "Thùsanaooria",
  "block.minecraft.cartography_table": "Nthàthentáxinxín maapa",
  "block.minecraft.carved_pumpkin": "Chu tsujin",
  "block.minecraft.cauldron": "Kaldeero",
  "block.minecraft.cave_air": "Chrinthu tjoꞌmá",
  "block.minecraft.cave_vines": "Nthàtùxrùxrjò tjoꞌmá",
  "block.minecraft.cave_vines_plant": "Nthàtùxrùxrjò tjoꞌmá",
  "block.minecraft.chain": "Chìànu",
  "block.minecraft.chain_command_block": "Kuubo juathetun chìànu",
  "block.minecraft.cherry_button": "Boton nthàsereeso",
  "block.minecraft.cherry_door": "Nthàdijexín nthàsereeso",
  "block.minecraft.cherry_fence": "Chjàte nthàsereeso",
  "block.minecraft.cherry_fence_gate": "Nthàdijexín chjàte nthàsereeso",
  "block.minecraft.cherry_hanging_sign": "Nthàkjìxín nthàsereeso kè deriaꞌnda",
  "block.minecraft.cherry_leaves": "Kà nthàsereeso",
  "block.minecraft.cherry_log": "Nthàriuꞌu nthàsereeso",
  "block.minecraft.cherry_planks": "Nthàchiso nthàsereeso",
  "block.minecraft.cherry_pressure_plate": "Palaaka juangachje nthàsereeso",
  "block.minecraft.cherry_sapling": "Nthàsereeso kè chriꞌin",
  "block.minecraft.cherry_shelf": "Repiisa nthàsereeso",
  "block.minecraft.cherry_sign": "Nthàkjìxín nthàsereeso",
  "block.minecraft.cherry_slab": "Loosa nthàsereeso",
  "block.minecraft.cherry_stairs": "Eskaleera nthàsereeso",
  "block.minecraft.cherry_trapdoor": "Nthàdijexín chjàte nthàsereeso",
  "block.minecraft.cherry_wall_hanging_sign": "Nthàkjìxín nthàsereeso kè deriaꞌnda ngaìn kuubo",
  "block.minecraft.cherry_wall_sign": "Nthàkjìxín nthàsereeso ngaìn kuubo",
  "block.minecraft.cherry_wood": "Nthàsereeso",
  "block.minecraft.chest": "Nthàkajón",
  "block.minecraft.chipped_anvil": "Yuunke kè chjejin",
  "block.minecraft.chiseled_bookshelf": "Estaante",
  "block.minecraft.chiseled_copper": "Koobere tsujin",
  "block.minecraft.chiseled_deepslate": "Xru naxin xeꞌe tsujin",
  "block.minecraft.chiseled_nether_bricks": "Xrunùnthèchján tsujin Nether",
  "block.minecraft.chiseled_polished_blackstone": "Xruthié ꞌndu tsujin",
  "block.minecraft.chiseled_quartz_block": "Kuaarso tsujin",
  "block.minecraft.chiseled_red_sandstone": "Xrunchise játsè tsujin",
  "block.minecraft.chiseled_resin_bricks": "Xrunùnthèchján chjìngù nthàà tsujin",
  "block.minecraft.chiseled_sandstone": "Xrunchise tsujin",
  "block.minecraft.chiseled_stone_bricks": "Xrunùnthèchján tsujin",
  "block.minecraft.chiseled_tuff": "Tooba tsujin",
  "block.minecraft.chiseled_tuff_bricks": "Xrunùnthèchján tooba tsujin",
  "block.minecraft.chorus_flower": "Tsjù kàkooro",
  "block.minecraft.chorus_plant": "Kàkooro",
  "block.minecraft.clay": "Nchètjè",
  "block.minecraft.closed_eyeblossom": "Kàjmakun kè dijee",
  "block.minecraft.coal_block": "Kuubo nchùnì",
  "block.minecraft.coal_ore": "Meena nchùnì",
  "block.minecraft.coarse_dirt": "Jìnchè chúngó",
  "block.minecraft.cobbled_deepslate": "Xru naxin xeꞌe tsujin",
  "block.minecraft.cobbled_deepslate_slab": "Loosa xru naxin xeꞌe tsujin",
  "block.minecraft.cobbled_deepslate_stairs": "Eskaleera xru naxin xeꞌe tsujin",
  "block.minecraft.cobbled_deepslate_wall": "Thjariuꞌù xru naxin xeꞌe tsujin",
  "block.minecraft.cobblestone": "Xru tsujin",
  "block.minecraft.cobblestone_slab": "Loosa xru tsujin",
  "block.minecraft.cobblestone_stairs": "Eskaleera xru tsujin",
  "block.minecraft.cobblestone_wall": "Thjariuꞌù xru tsujin",
  "block.minecraft.cobweb": "Xajua",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Kuubo juathetun",
  "block.minecraft.comparator": "Thí nchekaninxín redstone",
  "block.minecraft.composter": "Nthànchechjianxín nchèxee",
  "block.minecraft.conduit": "Thí tjitaón nthiꞌá",
  "block.minecraft.copper_bars": "Nthàchìà koobere",
  "block.minecraft.copper_block": "Kuubo koobere",
  "block.minecraft.copper_bulb": "Fooko koobere",
  "block.minecraft.copper_chain": "Chìànu koobere",
  "block.minecraft.copper_chest": "Kajón koobere",
  "block.minecraft.copper_door": "Nthàdijexín koobere",
  "block.minecraft.copper_golem_statue": "Estaatua goolen koobere",
  "block.minecraft.copper_grate": "Rejiiya koobere",
  "block.minecraft.copper_lantern": "Lamixin koobere",
  "block.minecraft.copper_ore": "Meena koobere",
  "block.minecraft.copper_torch": "Nthàxrùꞌì koobere",
  "block.minecraft.copper_trapdoor": "Nthàdijexínchjàn koobere",
  "block.minecraft.copper_wall_torch": "Nthàxrùꞌì koobere ngaìn kuubo",
  "block.minecraft.cornflower": "Kàsiaano",
  "block.minecraft.cracked_deepslate_bricks": "Xrunùnthèchján naxin xeꞌe ndakuaí",
  "block.minecraft.cracked_deepslate_tiles": "Asuleejo xru naxin xeꞌe ndakuaí",
  "block.minecraft.cracked_nether_bricks": "Xrunùnthèchján ndakuaí Nether",
  "block.minecraft.cracked_polished_blackstone_bricks": "Xrunùnthèchján thié tsujin ndakuaí",
  "block.minecraft.cracked_stone_bricks": "Xrunùnthèchján ndakuaí",
  "block.minecraft.crafter": "Nthànchechjianxín",
  "block.minecraft.crafting_table": "Nthànchexín xra",
  "block.minecraft.creaking_heart": "Anséèn kunthàsen",
  "block.minecraft.creeper_head": "Jàà creeper",
  "block.minecraft.creeper_wall_head": "Jàà creeper ngaìn kuubo",
  "block.minecraft.crimson_button": "Boton játsè",
  "block.minecraft.crimson_door": "Nthàdijexín játsè",
  "block.minecraft.crimson_fence": "Chjàte játsè",
  "block.minecraft.crimson_fence_gate": "Nthàdijexín chjàte játsè",
  "block.minecraft.crimson_fungus": "Kuchrjuì játsè",
  "block.minecraft.crimson_hanging_sign": "Nthàkjìxín játsè kè deriaꞌnda",
  "block.minecraft.crimson_hyphae": "Iifa játsè",
  "block.minecraft.crimson_nylium": "Niilio játsè",
  "block.minecraft.crimson_planks": "Nthàchiso játsè",
  "block.minecraft.crimson_pressure_plate": "Palaaka juangachje játsè",
  "block.minecraft.crimson_roots": "Nuꞌe játsè",
  "block.minecraft.crimson_shelf": "Repiisa játsè",
  "block.minecraft.crimson_sign": "Nthàkjìxín játsè",
  "block.minecraft.crimson_slab": "Loosa játsè",
  "block.minecraft.crimson_stairs": "Eskaleera játsè",
  "block.minecraft.crimson_stem": "Nthàxijì játsè",
  "block.minecraft.crimson_trapdoor": "Nthàdijexínchjàn játsè",
  "block.minecraft.crimson_wall_hanging_sign": "Nthàkjìxín játsè kè deriaꞌnda ngaìn kuubo",
  "block.minecraft.crimson_wall_sign": "Nthàkjìxín játsè ngaìn kuubo",
  "block.minecraft.crying_obsidian": "Obsidiaana tsjánga",
  "block.minecraft.cut_copper": "Koobere kè chrijin",
  "block.minecraft.cut_copper_slab": "Loosa koobere kè chrijin",
  "block.minecraft.cut_copper_stairs": "Eskaleera koobere kè chrijin",
  "block.minecraft.cut_red_sandstone": "Xrunchise játsè kè chrijin",
  "block.minecraft.cut_red_sandstone_slab": "Loosa xrunchise játsè kè chrijin",
  "block.minecraft.cut_sandstone": "Xrunchise kè chrijin",
  "block.minecraft.cut_sandstone_slab": "Loosa xrunchise kè chrijin",
  "block.minecraft.cyan_banner": "Bandeera yùà ngajní",
  "block.minecraft.cyan_bed": "Saun yùà ngajní",
  "block.minecraft.cyan_candle": "Nchicha yùà ngajní",
  "block.minecraft.cyan_candle_cake": "Pasteele kuníxin nchicha yùà ngajní",
  "block.minecraft.cyan_carpet": "Tapeete yùà ngajní",
  "block.minecraft.cyan_concrete": "Ormigon yùà ngajní",
  "block.minecraft.cyan_concrete_powder": "Semeento yùà ngajní",
  "block.minecraft.cyan_glazed_terracotta": "Asuleejo yùà ngajní",
  "block.minecraft.cyan_shulker_box": "Kajón shulker yùà ngajní",
  "block.minecraft.cyan_stained_glass": "Xruxrau yùà ngajní",
  "block.minecraft.cyan_stained_glass_pane": "Paneele xruxrau yùà ngajní",
  "block.minecraft.cyan_terracotta": "Nchètjau tsíchján yùà ngajní",
  "block.minecraft.cyan_wool": "Chjun yùà ngajní",
  "block.minecraft.damaged_anvil": "Yuunke kè xentaun",
  "block.minecraft.dandelion": "Kàchikooria",
  "block.minecraft.dark_oak_button": "Boton nthàthjau naxin xeꞌe",
  "block.minecraft.dark_oak_door": "Nthàdijexín nthàthjau naxin xeꞌe",
  "block.minecraft.dark_oak_fence": "Chjàte nthàthjau naxin xeꞌe",
  "block.minecraft.dark_oak_fence_gate": "Nthàdijexín chjàte nthàthjau naxin xeꞌe",
  "block.minecraft.dark_oak_hanging_sign": "Nthàkjìxín nthàthjau naxin xeꞌe kè deriaꞌnda",
  "block.minecraft.dark_oak_leaves": "Kà nthàthjau naxin xeꞌe",
  "block.minecraft.dark_oak_log": "Nthàriuꞌu nthàthjau naxin xeꞌe",
  "block.minecraft.dark_oak_planks": "Nthàchiso nthàthjau naxin xeꞌe",
  "block.minecraft.dark_oak_pressure_plate": "Palaaka juangachje nthàthjau naxin xeꞌe",
  "block.minecraft.dark_oak_sapling": "Nthàthjau naxin xeꞌe kè chriꞌin",
  "block.minecraft.dark_oak_shelf": "Repiisa nthàthjau naxin xeꞌe",
  "block.minecraft.dark_oak_sign": "Nthàkjìxín nthàthjau naxin xeꞌe",
  "block.minecraft.dark_oak_slab": "Loosa nthàthjau naxin xeꞌe",
  "block.minecraft.dark_oak_stairs": "Eskaleera nthàthjau naxin xeꞌe",
  "block.minecraft.dark_oak_trapdoor": "Nthàdijexínchjàn nthàthjau naxin xeꞌe",
  "block.minecraft.dark_oak_wall_hanging_sign": "Nthàkjìxín nthàthjau naxin xeꞌe kè deriaꞌnda ngaìn kuubo",
  "block.minecraft.dark_oak_wall_sign": "Nthàkjìxín nthàthjau naxin xeꞌe ngaìn kuubo",
  "block.minecraft.dark_oak_wood": "Nthàthjau naxin xeꞌe",
  "block.minecraft.dark_prismarine": "Pirismariina naxin xeꞌe",
  "block.minecraft.dark_prismarine_slab": "Loosa pirismariina naxin xeꞌe",
  "block.minecraft.dark_prismarine_stairs": "Eskaleera pirismariina naxin xeꞌe",
  "block.minecraft.daylight_detector": "Thí tunuꞌe xrùꞌì nchaꞌun",
  "block.minecraft.dead_brain_coral": "Kàndachaun thjele kè beꞌen",
  "block.minecraft.dead_brain_coral_block": "Kuubo kàndachaun thjele kè beꞌen",
  "block.minecraft.dead_brain_coral_fan": "Kugorgoonia thjele kè beꞌen",
  "block.minecraft.dead_brain_coral_wall_fan": "Kugorgoonia thjele kè beꞌen ngaìn kuubo",
  "block.minecraft.dead_bubble_coral": "Kàndachaun burbuuja kè beꞌen",
  "block.minecraft.dead_bubble_coral_block": "Kuubo kàndachaun burbuuja kè beꞌen",
  "block.minecraft.dead_bubble_coral_fan": "Kugorgoonia burbuuja kè beꞌen",
  "block.minecraft.dead_bubble_coral_wall_fan": "Kugorgoonia burbuuja ngaìn kuubo kè beꞌen",
  "block.minecraft.dead_bush": "Nthàà xemá",
  "block.minecraft.dead_fire_coral": "Kàndachaun xrùꞌì kè beꞌen",
  "block.minecraft.dead_fire_coral_block": "Kuubo kàndachaun xrùꞌì kè beꞌen",
  "block.minecraft.dead_fire_coral_fan": "Kugorgoonia xrùꞌì kè beꞌen",
  "block.minecraft.dead_fire_coral_wall_fan": "Kugorgoonia xrùꞌì kè beꞌen ngaìn kuubo",
  "block.minecraft.dead_horn_coral": "Kàndachaun nthàà kè beꞌen",
  "block.minecraft.dead_horn_coral_block": "Kuubo kàndachaun nthàà kè beꞌen",
  "block.minecraft.dead_horn_coral_fan": "Kugorgoonia nthàà kè beꞌen",
  "block.minecraft.dead_horn_coral_wall_fan": "Kugorgoonia nthàà kè beꞌen ngaìn kuubo",
  "block.minecraft.dead_tube_coral": "Kàndachaun tuubo kè beꞌen",
  "block.minecraft.dead_tube_coral_block": "Kuubo kàndachaun tuubo kè beꞌen",
  "block.minecraft.dead_tube_coral_fan": "Kugorgoonia tuubo kè beꞌen",
  "block.minecraft.dead_tube_coral_wall_fan": "Kugorgoonia tuubo kè beꞌen ngaìn kuubo",
  "block.minecraft.decorated_pot": "Chiixra",
  "block.minecraft.deepslate": "Xru naxin xeꞌe",
  "block.minecraft.deepslate_brick_slab": "Loosa xrunùnthèchján naxin xeꞌe",
  "block.minecraft.deepslate_brick_stairs": "Eskaleera xrunùnthèchján naxin xeꞌe",
  "block.minecraft.deepslate_brick_wall": "Thjariuꞌù xrunùnthèchján naxin xeꞌe",
  "block.minecraft.deepslate_bricks": "Xrunùnthèchján naxin xeꞌe",
  "block.minecraft.deepslate_coal_ore": "Meena nchùnì ngaìn xru naxin xeꞌe",
  "block.minecraft.deepslate_copper_ore": "Meena koobere ngaìn xru naxin xeꞌe",
  "block.minecraft.deepslate_diamond_ore": "Meena diamaante ngaìn xru naxin xeꞌe",
  "block.minecraft.deepslate_emerald_ore": "Meena esmeraalda ngaìn xru naxin xeꞌe",
  "block.minecraft.deepslate_gold_ore": "Meena tumisine ngaìn xru naxin xeꞌe",
  "block.minecraft.deepslate_iron_ore": "Meena chìà ngaìn xru naxin xeꞌe",
  "block.minecraft.deepslate_lapis_ore": "Meena lapislaasuli ngaìn xru naxin xeꞌe",
  "block.minecraft.deepslate_redstone_ore": "Meena redstone ngaìn xru naxin xeꞌe",
  "block.minecraft.deepslate_tile_slab": "Loosa asuleejo xru naxin xeꞌe",
  "block.minecraft.deepslate_tile_stairs": "Eskaleera asuleejo xru naxin xeꞌe",
  "block.minecraft.deepslate_tile_wall": "Thjariuꞌù asuleejo xru naxin xeꞌe",
  "block.minecraft.deepslate_tiles": "Asuleejo xru naxin xeꞌe",
  "block.minecraft.detector_rail": "Nthàchìà kè dithja",
  "block.minecraft.diamond_block": "Kuubo diamaante",
  "block.minecraft.diamond_ore": "Meena diamaante",
  "block.minecraft.diorite": "Dioriita",
  "block.minecraft.diorite_slab": "Loosa dioriita",
  "block.minecraft.diorite_stairs": "Eskaleera dioriita",
  "block.minecraft.diorite_wall": "Thjariuꞌù dioriita",
  "block.minecraft.dirt": "Jìnchè",
  "block.minecraft.dirt_path": "Nthiꞌá jìnchè",
  "block.minecraft.dispenser": "Nthàdajunxín",
  "block.minecraft.dragon_egg": "Juja kudaragon",
  "block.minecraft.dragon_head": "Jàà kudaragon",
  "block.minecraft.dragon_wall_head": "Jàà kudaragon ngaìn kuubo",
  "block.minecraft.dried_ghast": "Ghast xemá",
  "block.minecraft.dried_kelp_block": "Kuubo katan xemá",
  "block.minecraft.dripstone_block": "Kuubo kaliisa",
  "block.minecraft.dropper": "Nthàtanchrjandaxín",
  "block.minecraft.emerald_block": "Kuubo esmeraalda",
  "block.minecraft.emerald_ore": "Meena esmeraalda",
  "block.minecraft.enchanting_table": "Nthàthinthekjan",
  "block.minecraft.end_gateway": "Thí dixinxín ni ngaìn End",
  "block.minecraft.end_portal": "Portaale ngaìn End",
  "block.minecraft.end_portal_frame": "Maarko portaale ngaìn End",
  "block.minecraft.end_rod": "Nthàà End",
  "block.minecraft.end_stone": "Xru End",
  "block.minecraft.end_stone_brick_slab": "Loosa xrunùnthèchján End",
  "block.minecraft.end_stone_brick_stairs": "Eskaleera xrunùnthèchján End",
  "block.minecraft.end_stone_brick_wall": "Thjariuꞌù xrunùnthèchján End",
  "block.minecraft.end_stone_bricks": "Xrunùnthèchján End",
  "block.minecraft.ender_chest": "Nthàkajón ender",
  "block.minecraft.exposed_chiseled_copper": "Koobere tsujin kè xraagu ndújà",
  "block.minecraft.exposed_copper": "Koobere kè xraagu ndújà",
  "block.minecraft.exposed_copper_bars": "Nthàchìà koobere kè xraagu ndújà",
  "block.minecraft.exposed_copper_bulb": "Fooko koobere kè xraagu ndújà",
  "block.minecraft.exposed_copper_chain": "Chìànu koobere kè xraagu ndújà",
  "block.minecraft.exposed_copper_chest": "Kajón koobere kè xraagu ndújà",
  "block.minecraft.exposed_copper_door": "Nthàdijexín koobere kè xraagu ndújà",
  "block.minecraft.exposed_copper_golem_statue": "Estaatua goolen koobere kè xraagu ndújà",
  "block.minecraft.exposed_copper_grate": "Rejiiya koobere kè xraagu ndújà",
  "block.minecraft.exposed_copper_lantern": "Lamixin koobere kè xraagu ndújà",
  "block.minecraft.exposed_copper_trapdoor": "Nthàdijexínchjàn koobere kè xraagu ndújà",
  "block.minecraft.exposed_cut_copper": "Koobere kè chrijin kù xraagu ndújà",
  "block.minecraft.exposed_cut_copper_slab": "Loosa koobere kè chrijin kù xraagu ndújà",
  "block.minecraft.exposed_cut_copper_stairs": "Eskaleera koobere kè chrijin kù xraagu ndújà",
  "block.minecraft.exposed_lightning_rod": "Nthàtaxín raayo kè xraagu ndújà",
  "block.minecraft.farmland": "Jìnchè nchegángíxín",
  "block.minecraft.fern": "Kàeleecho",
  "block.minecraft.fire": "Xrùꞌì",
  "block.minecraft.fire_coral": "Kàndachaun xrùꞌì",
  "block.minecraft.fire_coral_block": "Kuubo kàndachaun xrùꞌì",
  "block.minecraft.fire_coral_fan": "Kugorgoonia xrùꞌì",
  "block.minecraft.fire_coral_wall_fan": "Kugorgoonia xrùꞌì ngaìn kuubo",
  "block.minecraft.firefly_bush": "Nthàà kuníxin kuthaxrùꞌì",
  "block.minecraft.fletching_table": "Nthànchechjianxín chijnu",
  "block.minecraft.flower_pot": "Maseeta",
  "block.minecraft.flowering_azalea": "Nthàrosadeelfa kè xrujin",
  "block.minecraft.flowering_azalea_leaves": "Kà nthàrosadeelfa kè xrujin",
  "block.minecraft.frogspawn": "Juja kurana",
  "block.minecraft.frosted_ice": "Chrintha",
  "block.minecraft.furnace": "Thja",
  "block.minecraft.gilded_blackstone": "Xruthié kè tungiixin",
  "block.minecraft.glass": "Xruxrau",
  "block.minecraft.glass_pane": "Paneele xruxrau",
  "block.minecraft.glow_lichen": "Liken kè tungiixin",
  "block.minecraft.glowstone": "Xruchiixru",
  "block.minecraft.gold_block": "Kuubo tumisine",
  "block.minecraft.gold_ore": "Meena tumisine",
  "block.minecraft.golden_dandelion": "Kàchikooria sine",
  "block.minecraft.granite": "Garaniito",
  "block.minecraft.granite_slab": "Loosa garaniito",
  "block.minecraft.granite_stairs": "Eskaleera garaniito",
  "block.minecraft.granite_wall": "Thjariuꞌù garaniito",
  "block.minecraft.grass": "Kàchjì",
  "block.minecraft.grass_block": "Kuubo kàchjì",
  "block.minecraft.gravel": "Xrùxruá",
  "block.minecraft.gray_banner": "Bandeera xràtjù",
  "block.minecraft.gray_bed": "Saun xràtjù",
  "block.minecraft.gray_candle": "Nchicha xràtjù",
  "block.minecraft.gray_candle_cake": "Pasteele kuníxin nchicha xràtjù",
  "block.minecraft.gray_carpet": "Tapeete xràtjù",
  "block.minecraft.gray_concrete": "Ormigon xràtjù",
  "block.minecraft.gray_concrete_powder": "Semeento xràtjù",
  "block.minecraft.gray_glazed_terracotta": "Asuleejo xràtjù",
  "block.minecraft.gray_shulker_box": "Kajón shulker xràtjù",
  "block.minecraft.gray_stained_glass": "Xruxrau xràtjù",
  "block.minecraft.gray_stained_glass_pane": "Paneele xruxrau xràtjù",
  "block.minecraft.gray_terracotta": "Nchètjau tsíchján xràtjù",
  "block.minecraft.gray_wool": "Chjun xràtjù",
  "block.minecraft.green_banner": "Bandeera yùà",
  "block.minecraft.green_bed": "Saun yùà",
  "block.minecraft.green_candle": "Nchicha yùà",
  "block.minecraft.green_candle_cake": "Pasteele kuníxin nchicha yùà",
  "block.minecraft.green_carpet": "Tapeete yùà",
  "block.minecraft.green_concrete": "Ormigon yùà",
  "block.minecraft.green_concrete_powder": "Semeento yùà",
  "block.minecraft.green_glazed_terracotta": "Asuleejo yùà",
  "block.minecraft.green_shulker_box": "Kajón shulker yùà",
  "block.minecraft.green_stained_glass": "Xruxrau yùà",
  "block.minecraft.green_stained_glass_pane": "Paneele xruxrau yùà",
  "block.minecraft.green_terracotta": "Nchètjau tsíchján yùà",
  "block.minecraft.green_wool": "Chjun yùà",
  "block.minecraft.grindstone": "Xru ncheyáuxín",
  "block.minecraft.hanging_roots": "Nuꞌe kè deriaꞌnda",
  "block.minecraft.hay_block": "Kuubo kàchji",
  "block.minecraft.heavy_core": "Ansen ye",
  "block.minecraft.heavy_weighted_pressure_plate": "Palaaka juangachje íxin tsjé juadathechuꞌa",
  "block.minecraft.honey_block": "Kuubo tsjèn",
  "block.minecraft.honeycomb_block": "Kuubo katje",
  "block.minecraft.hopper": "Toolba",
  "block.minecraft.horn_coral": "Kàndachaun nthàà",
  "block.minecraft.horn_coral_block": "Kuubo kàndachaun nthàà",
  "block.minecraft.horn_coral_fan": "Kugorgoonia nthàà",
  "block.minecraft.horn_coral_wall_fan": "Kugorgoonia nthàà ngaìn kuubo",
  "block.minecraft.ice": "Chrintha",
  "block.minecraft.infested_chiseled_stone_bricks": "Xrunùnthèchján tsujin kuníxin kuxíígu",
  "block.minecraft.infested_cobblestone": "Xru tsujin kuníxin kuxíígu",
  "block.minecraft.infested_cracked_stone_bricks": "Xrunùnthèchján ndakuaí kuníxin kuxíígu",
  "block.minecraft.infested_deepslate": "Xru naxin xeꞌe kuníxin kuxíígu",
  "block.minecraft.infested_mossy_stone_bricks": "Xrunùnthèchján ndatju kuníxin kuxíígu",
  "block.minecraft.infested_stone": "Xru kuníxin kuxíígu",
  "block.minecraft.infested_stone_bricks": "Xrunùnthèchján kuníxin kuxíígu",
  "block.minecraft.iron_bars": "Nthàchìà",
  "block.minecraft.iron_block": "Kuubo chìà",
  "block.minecraft.iron_chain": "Chìànu",
  "block.minecraft.iron_door": "Nthàdijexín chìà",
  "block.minecraft.iron_ore": "Meena chìà",
  "block.minecraft.iron_trapdoor": "Nthàdijexínchjàn chìà",
  "block.minecraft.jack_o_lantern": "Chu kiai",
  "block.minecraft.jigsaw": "Kuubo tangí",
  "block.minecraft.jukebox": "Nthàdíngaxín diisko",
  "block.minecraft.jungle_button": "Boton nthàjié tjau",
  "block.minecraft.jungle_door": "Nthàdijexín nthàjié tjau",
  "block.minecraft.jungle_fence": "Chjàte nthàjié tjau",
  "block.minecraft.jungle_fence_gate": "Nthàdijexín chjàte nthàjié tjau",
  "block.minecraft.jungle_hanging_sign": "Nthàkjìxín nthàjié tjau kè deriaꞌnda",
  "block.minecraft.jungle_leaves": "Kà nthàjié tjau",
  "block.minecraft.jungle_log": "Nthàriuꞌu nthàjié tjau",
  "block.minecraft.jungle_planks": "Nthàchiso nthàjié tjau",
  "block.minecraft.jungle_pressure_plate": "Palaaka juangachje nthàjié tjau",
  "block.minecraft.jungle_sapling": "Nthàjié tjau kè chriꞌin",
  "block.minecraft.jungle_shelf": "Repiisa nthàjié tjau",
  "block.minecraft.jungle_sign": "Nthàkjìxín nthàjié tjau",
  "block.minecraft.jungle_slab": "Loosa nthàjié tjau",
  "block.minecraft.jungle_stairs": "Eskaleera nthàjié tjau",
  "block.minecraft.jungle_trapdoor": "Nthàdijexínchjàn nthàjié tjau",
  "block.minecraft.jungle_wall_hanging_sign": "Nthàkjìxín nthàjié tjau kè deriaꞌnda ngaìn kuubo",
  "block.minecraft.jungle_wall_sign": "Nthàkjìxín nthàjié tjau ngaìn kuubo",
  "block.minecraft.jungle_wood": "Nthàjié tjau",
  "block.minecraft.kelp": "Katan",
  "block.minecraft.kelp_plant": "Nthàxijì katan",
  "block.minecraft.ladder": "Nthàtanixín",
  "block.minecraft.lantern": "Lamixin",
  "block.minecraft.lapis_block": "Kuubo lapislaasuli",
  "block.minecraft.lapis_ore": "Meena lapislaasuli",
  "block.minecraft.large_amethyst_bud": "Amatiista jié kè chriꞌin",
  "block.minecraft.large_fern": "Kàeleecho nuí",
  "block.minecraft.lava": "Ndaxrùꞌì",
  "block.minecraft.lava_cauldron": "Kaldeero kuníxin ndaxrùꞌì",
  "block.minecraft.leaf_litter": "Kà xemá",
  "block.minecraft.lectern": "Sopoorte",
  "block.minecraft.lever": "Palaanka",
  "block.minecraft.light": "Xrùꞌì",
  "block.minecraft.light_blue_banner": "Bandeera yùà",
  "block.minecraft.light_blue_bed": "Saun yùà",
  "block.minecraft.light_blue_candle": "Nchicha yùà",
  "block.minecraft.light_blue_candle_cake": "Pasteele kuníxin nchicha yùà",
  "block.minecraft.light_blue_carpet": "Tapeete yùà",
  "block.minecraft.light_blue_concrete": "Ormigon yùà",
  "block.minecraft.light_blue_concrete_powder": "Semeento yùà",
  "block.minecraft.light_blue_glazed_terracotta": "Asuleejo yùà",
  "block.minecraft.light_blue_shulker_box": "Kajón shulker yùà",
  "block.minecraft.light_blue_stained_glass": "Xruxrau yùà",
  "block.minecraft.light_blue_stained_glass_pane": "Paneele xruxrau yùà",
  "block.minecraft.light_blue_terracotta": "Nchètjau tsíchján yùà",
  "block.minecraft.light_blue_wool": "Chjun yùà",
  "block.minecraft.light_gray_banner": "Bandeera xràtjù",
  "block.minecraft.light_gray_bed": "Saun xràtjù",
  "block.minecraft.light_gray_candle": "Nchicha xràtjù",
  "block.minecraft.light_gray_candle_cake": "Pasteele kuníxin nchicha xràtjù",
  "block.minecraft.light_gray_carpet": "Tapeete xràtjù",
  "block.minecraft.light_gray_concrete": "Ormigon xràtjù",
  "block.minecraft.light_gray_concrete_powder": "Semeento",
  "block.minecraft.light_gray_glazed_terracotta": "Asuleejo xràtjù",
  "block.minecraft.light_gray_shulker_box": "Kajón shulker xràtjù",
  "block.minecraft.light_gray_stained_glass": "Xruxrau xràtjù",
  "block.minecraft.light_gray_stained_glass_pane": "Paneele xruxrau xràtjù",
  "block.minecraft.light_gray_terracotta": "Nchètjau tsíchján xràtjù",
  "block.minecraft.light_gray_wool": "Chjun xràtjù",
  "block.minecraft.light_weighted_pressure_plate": "Palaaka juangachje íxin nchín juadathechuꞌa",
  "block.minecraft.lightning_rod": "Nthàtaxín raayo",
  "block.minecraft.lilac": "Kàliila",
  "block.minecraft.lily_of_the_valley": "Kàliirio chjaaga",
  "block.minecraft.lily_pad": "Kàtsjù jíngataún jinda",
  "block.minecraft.lime_banner": "Bandeera yùà",
  "block.minecraft.lime_bed": "Saun yùà",
  "block.minecraft.lime_candle": "Nchicha yùà",
  "block.minecraft.lime_candle_cake": "Pasteele kuníxin nchicha yùà",
  "block.minecraft.lime_carpet": "Tepeete yùà",
  "block.minecraft.lime_concrete": "Ormigon yùà",
  "block.minecraft.lime_concrete_powder": "Semeento yùà",
  "block.minecraft.lime_glazed_terracotta": "Asuleejo yùà",
  "block.minecraft.lime_shulker_box": "Kajón shulker yùà",
  "block.minecraft.lime_stained_glass": "Xruxrau yùà",
  "block.minecraft.lime_stained_glass_pane": "Paneele xruxrau yùà",
  "block.minecraft.lime_terracotta": "Nchètjau tsíchján yùà",
  "block.minecraft.lime_wool": "Chjun yùà",
  "block.minecraft.lodestone": "Maknetiita",
  "block.minecraft.loom": "Chau",
  "block.minecraft.magenta_banner": "Bandeera játsè",
  "block.minecraft.magenta_bed": "Saun játsè",
  "block.minecraft.magenta_candle": "Nchicha játsè",
  "block.minecraft.magenta_candle_cake": "Pasteele kuníxin nchicha játsè",
  "block.minecraft.magenta_carpet": "Tapeete játsè",
  "block.minecraft.magenta_concrete": "Ormigon játsè",
  "block.minecraft.magenta_concrete_powder": "Semeento játsè",
  "block.minecraft.magenta_glazed_terracotta": "Asuleejo játsè",
  "block.minecraft.magenta_shulker_box": "Kajón shulker játsè",
  "block.minecraft.magenta_stained_glass": "Xruxrau játsè",
  "block.minecraft.magenta_stained_glass_pane": "Paneele xruxrau játsè",
  "block.minecraft.magenta_terracotta": "Nchètjau tsíchján játsè",
  "block.minecraft.magenta_wool": "Chjun játsè",
  "block.minecraft.magma_block": "Kuubo nchèxrùꞌì",
  "block.minecraft.mangrove_button": "Boton nthàsau",
  "block.minecraft.mangrove_door": "Nthàdijexín nthàsau",
  "block.minecraft.mangrove_fence": "Chjàte nthàsau",
  "block.minecraft.mangrove_fence_gate": "Nthàdijexín chjàte nthàsau",
  "block.minecraft.mangrove_hanging_sign": "Nthàkjìxín nthàsau kè deriaꞌnda",
  "block.minecraft.mangrove_leaves": "Kà nthàsau",
  "block.minecraft.mangrove_log": "Nthàriuꞌu nthàsau",
  "block.minecraft.mangrove_planks": "Nthàchiso nthàsau",
  "block.minecraft.mangrove_pressure_plate": "Palaaka juangachje nthàsau",
  "block.minecraft.mangrove_propagule": "Thuꞌa nthàsau",
  "block.minecraft.mangrove_roots": "Nuꞌe nthàsau",
  "block.minecraft.mangrove_shelf": "Repiisa nthàsau",
  "block.minecraft.mangrove_sign": "Nthàkjìxín nthàsau",
  "block.minecraft.mangrove_slab": "Loosa nthàsau",
  "block.minecraft.mangrove_stairs": "Eskaleera nthàsau",
  "block.minecraft.mangrove_trapdoor": "Nthàdijexínchjàn nthàsau",
  "block.minecraft.mangrove_wall_hanging_sign": "Nthàkjìxín nthàsau kè deriaꞌnda ngaìn kuubo",
  "block.minecraft.mangrove_wall_sign": "Nthàkjìxín nthàsau ngaìn kuubo",
  "block.minecraft.mangrove_wood": "Nthàsau",
  "block.minecraft.medium_amethyst_bud": "Amatiista jínì kè chriꞌin",
  "block.minecraft.melon": "Thùsandia",
  "block.minecraft.melon_stem": "Nthàxijì thùsandia",
  "block.minecraft.moss_block": "Kuubo ndatju",
  "block.minecraft.moss_carpet": "Tapeete ndatju",
  "block.minecraft.mossy_cobblestone": "Xru tsujin ndatju",
  "block.minecraft.mossy_cobblestone_slab": "Loosa xru tsujin ndatju",
  "block.minecraft.mossy_cobblestone_stairs": "Eskaleera xru tsujin ndatju",
  "block.minecraft.mossy_cobblestone_wall": "Thjariuꞌù xru tsujin ndatju",
  "block.minecraft.mossy_stone_brick_slab": "Loosa xrunùnthèchján ndatju",
  "block.minecraft.mossy_stone_brick_stairs": "Eskaleera xrunùnthèchján ndatju",
  "block.minecraft.mossy_stone_brick_wall": "Thjariuꞌù xrunùnthèchján ndatju",
  "block.minecraft.mossy_stone_bricks": "Xrunùnthèchján ndatju",
  "block.minecraft.moving_piston": "Piston kè thingi",
  "block.minecraft.mud": "Nchètjaꞌu",
  "block.minecraft.mud_brick_slab": "Loosa jìnchè chitaꞌo",
  "block.minecraft.mud_brick_stairs": "Eskaleera jìnchè chitaꞌo",
  "block.minecraft.mud_brick_wall": "Thjariuꞌù jìnchè chitaꞌo",
  "block.minecraft.mud_bricks": "Xrunùnthèchján jìnchè chitaꞌo",
  "block.minecraft.muddy_mangrove_roots": "Nuꞌe nthàsau kithja",
  "block.minecraft.mushroom_stem": "Nthàxijì kuchrjuì",
  "block.minecraft.mycelium": "Miseelio",
  "block.minecraft.nether_brick_fence": "Chjàte xrunùnthèchján Nether",
  "block.minecraft.nether_brick_slab": "Loosa xrunùnthèchján Nether",
  "block.minecraft.nether_brick_stairs": "Eskaleera xrunùnthèchján Nether",
  "block.minecraft.nether_brick_wall": "Thjariuꞌù xrunùnthèchján Nether",
  "block.minecraft.nether_bricks": "Xrunùnthèchján Nether",
  "block.minecraft.nether_gold_ore": "Meena tumisine Nether",
  "block.minecraft.nether_portal": "Portaale ngaìn Nether",
  "block.minecraft.nether_quartz_ore": "Meena kuaarso Nether",
  "block.minecraft.nether_sprouts": "Kàchji Nether",
  "block.minecraft.nether_wart": "Kàkuthuneꞌe Nether",
  "block.minecraft.nether_wart_block": "Kuubo kàkuthuneꞌe Nether",
  "block.minecraft.netherite_block": "Kuubo netheriita",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Kuubo súun",
  "block.minecraft.oak_button": "Boton nthàthjau",
  "block.minecraft.oak_door": "Nthàdijexín nthàthjau",
  "block.minecraft.oak_fence": "Chjàte nthàthjau",
  "block.minecraft.oak_fence_gate": "Nthàdijexín chjàte nthàthjau",
  "block.minecraft.oak_hanging_sign": "Nthàkjìxín nthàthjau kè deriaꞌnda",
  "block.minecraft.oak_leaves": "Kà nthàthjau",
  "block.minecraft.oak_log": "Nthàriuꞌu nthàthjau",
  "block.minecraft.oak_planks": "Nthàchiso nthàthjau",
  "block.minecraft.oak_pressure_plate": "Palaaka juangachje nthàthjau",
  "block.minecraft.oak_sapling": "Nthàthjau kè chriꞌin",
  "block.minecraft.oak_shelf": "Repiisa nthàthjau",
  "block.minecraft.oak_sign": "Nthàkjìxín nthàthjau",
  "block.minecraft.oak_slab": "Loosa nthàthjau",
  "block.minecraft.oak_stairs": "Eskaleera nthàthjau",
  "block.minecraft.oak_trapdoor": "Nthàdijexínchjàn nthàthjau",
  "block.minecraft.oak_wall_hanging_sign": "Nthàkjìxín nthàthjau kè deriaꞌnda ngaìn kuubo",
  "block.minecraft.oak_wall_sign": "Nthàkjìxín nthàthjau ngaìn kuubo",
  "block.minecraft.oak_wood": "Nthàthjau",
  "block.minecraft.observer": "Nthàdikunxín",
  "block.minecraft.obsidian": "Obsidiaana",
  "block.minecraft.ochre_froglight": "Xrùꞌì kurana sine",
  "block.minecraft.ominous_banner": "Bandeera ujekua",
  "block.minecraft.open_eyeblossom": "Kàjmakun kè xiree",
  "block.minecraft.orange_banner": "Bandeera thùnsán",
  "block.minecraft.orange_bed": "Saun thùnsán",
  "block.minecraft.orange_candle": "Nchicha thùnsán",
  "block.minecraft.orange_candle_cake": "Pasteele kuníxin nchicha thùnsán",
  "block.minecraft.orange_carpet": "Tapeete thùnsán",
  "block.minecraft.orange_concrete": "Ormigon thùnsán",
  "block.minecraft.orange_concrete_powder": "Semeento thùnsán",
  "block.minecraft.orange_glazed_terracotta": "Asuleejo thùnsán",
  "block.minecraft.orange_shulker_box": "Kajón shulker thùnsán",
  "block.minecraft.orange_stained_glass": "Xruxrau thùnsán",
  "block.minecraft.orange_stained_glass_pane": "Paneele xruxrau thùnsán",
  "block.minecraft.orange_terracotta": "Nchètjau tsíchján thùnsán",
  "block.minecraft.orange_tulip": "Kàtulipan thùnsán",
  "block.minecraft.orange_wool": "Chjun thùnsán",
  "block.minecraft.oxeye_daisy": "Kàmargariita",
  "block.minecraft.oxidized_chiseled_copper": "Koobere tsujin tsíkúchjìsen",
  "block.minecraft.oxidized_copper": "Koobere tsíkúchjìsen",
  "block.minecraft.oxidized_copper_bars": "Nthàchìà koobere tsíkúchjìsen",
  "block.minecraft.oxidized_copper_bulb": "Fooko koobere tsíkúchjìsen",
  "block.minecraft.oxidized_copper_chain": "Chìànu koobere tsíkúchjìsen",
  "block.minecraft.oxidized_copper_chest": "Kajón koobere tsíkúchjìsen",
  "block.minecraft.oxidized_copper_door": "Nthàdijexín koobere tsíkúchjìsen",
  "block.minecraft.oxidized_copper_golem_statue": "Estaatua goolen koobere tsíkúchjìsen",
  "block.minecraft.oxidized_copper_grate": "Rejiiya koobere tsíkúchjìsen",
  "block.minecraft.oxidized_copper_lantern": "Lamixin koobere tsíkúchjìsen",
  "block.minecraft.oxidized_copper_trapdoor": "Nthàdijexínchjàn koobere tsíkúchjìsen",
  "block.minecraft.oxidized_cut_copper": "Koobere tsíkúchjìsen kè chrijin",
  "block.minecraft.oxidized_cut_copper_slab": "Loosa koobere tsíkúchjìsen kè chrijin",
  "block.minecraft.oxidized_cut_copper_stairs": "Eskaleera koobere tsíkúchjìsen kè chrijin",
  "block.minecraft.oxidized_lightning_rod": "Nthàtaxín raayo tsíkúchjìsen",
  "block.minecraft.packed_ice": "Chrintha ntheedu",
  "block.minecraft.packed_mud": "Jìnchè chitaꞌo",
  "block.minecraft.pale_hanging_moss": "Kàlaama seen kè deriaꞌnda",
  "block.minecraft.pale_moss_block": "Kuubo ndátju seen",
  "block.minecraft.pale_moss_carpet": "Tapeete ndátju seen",
  "block.minecraft.pale_oak_button": "Boton nthàthjau seen",
  "block.minecraft.pale_oak_door": "Nthàdijexín nthàthjau seen",
  "block.minecraft.pale_oak_fence": "Chjàte nthàthjau seen",
  "block.minecraft.pale_oak_fence_gate": "Nthàdijexín chjàte nthàthjau seen",
  "block.minecraft.pale_oak_hanging_sign": "Nthàkjìxín nthàthjau seen kè deriaꞌnda",
  "block.minecraft.pale_oak_leaves": "Kà nthàthjau seen",
  "block.minecraft.pale_oak_log": "Nthàriuꞌu nthàthjau seen",
  "block.minecraft.pale_oak_planks": "Nthàchiso nthàthjau seen",
  "block.minecraft.pale_oak_pressure_plate": "Palaaka juangachje nthàthjau seen",
  "block.minecraft.pale_oak_sapling": "Nthàthjau seen kè chriꞌin",
  "block.minecraft.pale_oak_shelf": "Repiisa nthàthjau seen",
  "block.minecraft.pale_oak_sign": "Nthàkjìxín nthàthjau seen",
  "block.minecraft.pale_oak_slab": "Loosa nthàthjau seen",
  "block.minecraft.pale_oak_stairs": "Eskaleera nthàthjau seen",
  "block.minecraft.pale_oak_trapdoor": "Nthàdijexínchjàn nthàthjau seen",
  "block.minecraft.pale_oak_wall_hanging_sign": "Nthàkjìxín nthàthjau seen kè deriaꞌnda ngaìn kuubo",
  "block.minecraft.pale_oak_wall_sign": "Nthàkjìxín nthàthjau seen ngaìn kuubo",
  "block.minecraft.pale_oak_wood": "Nthàthjau seen",
  "block.minecraft.pearlescent_froglight": "Xrùꞌì kurana játsè thié",
  "block.minecraft.peony": "Kàpeonia",
  "block.minecraft.petrified_oak_slab": "Loosa nthàthjau cha",
  "block.minecraft.piglin_head": "Jàà piglin",
  "block.minecraft.piglin_wall_head": "Jàà piglin ngaìn kuubo",
  "block.minecraft.pink_banner": "Bandeera tjuáꞌnde",
  "block.minecraft.pink_bed": "Saun tjuáꞌnde",
  "block.minecraft.pink_candle": "Nchicha tjuáꞌnde",
  "block.minecraft.pink_candle_cake": "Pasteele kuníxin nchicha tjuáꞌnde",
  "block.minecraft.pink_carpet": "Tepeete tjuáꞌnde",
  "block.minecraft.pink_concrete": "Ormigon tjuáꞌnde",
  "block.minecraft.pink_concrete_powder": "Semeento tjuáꞌnde",
  "block.minecraft.pink_glazed_terracotta": "Asuleejo tjuáꞌnde",
  "block.minecraft.pink_petals": "Ka tsjù tjuáꞌnde",
  "block.minecraft.pink_shulker_box": "Kajón shulker tjuáꞌnde",
  "block.minecraft.pink_stained_glass": "Xruxrau tjuáꞌnde",
  "block.minecraft.pink_stained_glass_pane": "Paneele xruxrau tjuáꞌnde",
  "block.minecraft.pink_terracotta": "Nchètjau tsíchján tjuáꞌnde",
  "block.minecraft.pink_tulip": "Kàtulipan tjuáꞌnde",
  "block.minecraft.pink_wool": "Chjun tjuáꞌnde",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Jàà piston",
  "block.minecraft.pitcher_crop": "Juanchegani kàchiixra",
  "block.minecraft.pitcher_plant": "Kàchiixra",
  "block.minecraft.player_head": "Jàà xí/nchrítsuntaun",
  "block.minecraft.player_head.named": "Jàà %s",
  "block.minecraft.player_wall_head": "Jàà xí/nchrítsuntaun ngaìn kuubo",
  "block.minecraft.podzol": "Jìnchè ujekua",
  "block.minecraft.pointed_dripstone": "Kaliisa yau",
  "block.minecraft.polished_andesite": "Andesiita ꞌndu",
  "block.minecraft.polished_andesite_slab": "Loosa andesiita ꞌndu",
  "block.minecraft.polished_andesite_stairs": "Eskaleera andesiita ꞌndu",
  "block.minecraft.polished_basalt": "Basaalto ꞌndu",
  "block.minecraft.polished_blackstone": "Xruthié ꞌndu",
  "block.minecraft.polished_blackstone_brick_slab": "Loosa xrunùnthèchján thié ꞌndu",
  "block.minecraft.polished_blackstone_brick_stairs": "Eskaleera xrunùnthèchján thié ꞌndu",
  "block.minecraft.polished_blackstone_brick_wall": "Thjariuꞌù xrunùnthèchján thié ꞌndu",
  "block.minecraft.polished_blackstone_bricks": "Xrunùnthèchján thié ꞌndu",
  "block.minecraft.polished_blackstone_button": "Boton xruthié ꞌndu",
  "block.minecraft.polished_blackstone_pressure_plate": "Palaaka juangachje xruthié ꞌndu",
  "block.minecraft.polished_blackstone_slab": "Loosa xruthié ꞌndu",
  "block.minecraft.polished_blackstone_stairs": "Eskaleera xruthié ꞌndu",
  "block.minecraft.polished_blackstone_wall": "Thjariuꞌù xruthié ꞌndu",
  "block.minecraft.polished_deepslate": "Xru naxin xeꞌe ꞌndu",
  "block.minecraft.polished_deepslate_slab": "Loosa xru naxin xeꞌe ꞌndu",
  "block.minecraft.polished_deepslate_stairs": "Eskaleera xru naxin xeꞌe ꞌndu",
  "block.minecraft.polished_deepslate_wall": "Thjariuꞌù xru naxin xeꞌe ꞌndu",
  "block.minecraft.polished_diorite": "Dioriita ꞌndu",
  "block.minecraft.polished_diorite_slab": "Loosa dioriita ꞌndu",
  "block.minecraft.polished_diorite_stairs": "Eskaleera dioriita ꞌndu",
  "block.minecraft.polished_granite": "Garaniito ꞌndu",
  "block.minecraft.polished_granite_slab": "Loosa garaniito ꞌndu",
  "block.minecraft.polished_granite_stairs": "Eskaleera garaniito ꞌndu",
  "block.minecraft.polished_tuff": "Tooba ꞌndu",
  "block.minecraft.polished_tuff_slab": "Loosa tooba ꞌndu",
  "block.minecraft.polished_tuff_stairs": "Eskaleera tooba ꞌndu",
  "block.minecraft.polished_tuff_wall": "Thjariuꞌù tooba ꞌndu",
  "block.minecraft.poppy": "Kàtsjù játsè",
  "block.minecraft.potatoes": "Thùkjà",
  "block.minecraft.potted_acacia_sapling": "Maseeta kuníxin nthànchaꞌa kè chriꞌin",
  "block.minecraft.potted_allium": "Maseeta kuníxin tsjù thùaájo",
  "block.minecraft.potted_azalea_bush": "Maseeta kuníxin nthàrosadeelfa",
  "block.minecraft.potted_azure_bluet": "Maseeta kuníxin tsjù rua",
  "block.minecraft.potted_bamboo": "Maseeta kuníxin tjì jié",
  "block.minecraft.potted_birch_sapling": "Maseeta kuníxin nthàbetuula kè chriꞌin",
  "block.minecraft.potted_blue_orchid": "Maseeta kuníxin tsjùchà yùà",
  "block.minecraft.potted_brown_mushroom": "Maseeta kuníxin kuchrjuì seen",
  "block.minecraft.potted_cactus": "Maseeta kuníxin nthàà",
  "block.minecraft.potted_cherry_sapling": "Maseeta kuníxin nthàsereeso kè chriꞌin",
  "block.minecraft.potted_closed_eyeblossom": "Maseeta kuníxin kàjmakun kè dijee",
  "block.minecraft.potted_cornflower": "Maseeta kuníxin kàsiaano",
  "block.minecraft.potted_crimson_fungus": "Maseeta kuníxin kuchrjuì játsè",
  "block.minecraft.potted_crimson_roots": "Maseeta kuníxin nuꞌe játsè",
  "block.minecraft.potted_dandelion": "Maseeta kuníxin kàchikooria",
  "block.minecraft.potted_dark_oak_sapling": "Maseeta kuníxin nthàthjau naxin xeꞌe kè chriꞌin",
  "block.minecraft.potted_dead_bush": "Maseeta kuníxin nthàà xemá",
  "block.minecraft.potted_fern": "Maseeta kuníxin kàeleecho",
  "block.minecraft.potted_flowering_azalea_bush": "Maseeta kuníxin nthàrosadeelfa kè xrujin",
  "block.minecraft.potted_golden_dandelion": "Maseeta kuníxin kàchikooria sine",
  "block.minecraft.potted_jungle_sapling": "Maseeta kuníxin nthàjié tjau kè chriꞌin",
  "block.minecraft.potted_lily_of_the_valley": "Maseeta kuníxin kàliirio chjaaga",
  "block.minecraft.potted_mangrove_propagule": "Maseeta kuníxin thuꞌa nthàsau",
  "block.minecraft.potted_oak_sapling": "Maseeta kuníxin nthàthjau kè chriꞌin",
  "block.minecraft.potted_open_eyeblossom": "Maseeta kuníxin kàjmakun kè xiree",
  "block.minecraft.potted_orange_tulip": "Maseeta kuníxin kàtulipan thùnsán",
  "block.minecraft.potted_oxeye_daisy": "Maseeta kuníxin kàmargariita",
  "block.minecraft.potted_pale_oak_sapling": "Maseeta kuníxin nthàthjau seen kè chriꞌin",
  "block.minecraft.potted_pink_tulip": "Maseeta kuníxin kàtulipan tjuáꞌnde",
  "block.minecraft.potted_poppy": "Maseeta kuníxin kàtsjù játsè",
  "block.minecraft.potted_red_mushroom": "Maseeta kuníxin kuchrjuì játsè",
  "block.minecraft.potted_red_tulip": "Maseeta kuníxin kàtulipan játsè",
  "block.minecraft.potted_spruce_sapling": "Maseeta kuníxin nthànchicha kè chriꞌin",
  "block.minecraft.potted_torchflower": "Maseeta kuníxin kàxrùꞌì",
  "block.minecraft.potted_warped_fungus": "Maseeta kuníxin kuchrjuì xraduꞌu",
  "block.minecraft.potted_warped_roots": "Maseeta kuníxin nuꞌe xraduꞌu",
  "block.minecraft.potted_white_tulip": "Maseeta kuníxin kàtulipan rua",
  "block.minecraft.potted_wither_rose": "Maseeta kuníxin kàroosa Wither",
  "block.minecraft.powder_snow": "Chrintha xrunda",
  "block.minecraft.powder_snow_cauldron": "Kaldeero kuníxin chrintha xrunda",
  "block.minecraft.powered_rail": "Nthàchìà kè nchegathu",
  "block.minecraft.prismarine": "Pirismariina",
  "block.minecraft.prismarine_brick_slab": "Loosa xrunùnthèchján pirismariina",
  "block.minecraft.prismarine_brick_stairs": "Eskaleera xrunùnthèchján pirismariina",
  "block.minecraft.prismarine_bricks": "Xrunùnthèchján pirismariina",
  "block.minecraft.prismarine_slab": "Loosa pirismariina",
  "block.minecraft.prismarine_stairs": "Eskaleera pirismariina",
  "block.minecraft.prismarine_wall": "Thjariuꞌù pirismariina",
  "block.minecraft.pumpkin": "Chu",
  "block.minecraft.pumpkin_stem": "Nthaxijì chu",
  "block.minecraft.purple_banner": "Bandeera játsè thié",
  "block.minecraft.purple_bed": "Saun játsè thié",
  "block.minecraft.purple_candle": "Nchicha játsè thié",
  "block.minecraft.purple_candle_cake": "Pasteele kuníxin nchicha játsè thié",
  "block.minecraft.purple_carpet": "Tapeete játsè thié",
  "block.minecraft.purple_concrete": "Ormigon játsè thié",
  "block.minecraft.purple_concrete_powder": "Semeento játsè thié",
  "block.minecraft.purple_glazed_terracotta": "Asuleejo játsè thié",
  "block.minecraft.purple_shulker_box": "Kajón shulker játsè thié",
  "block.minecraft.purple_stained_glass": "Xruxrau játsè thié",
  "block.minecraft.purple_stained_glass_pane": "Paneele xruxrau játsè thié",
  "block.minecraft.purple_terracotta": "Nchètjau tsíchján játsè thié",
  "block.minecraft.purple_wool": "Chjun játsè thié",
  "block.minecraft.purpur_block": "Purpur",
  "block.minecraft.purpur_pillar": "Pooste purpur",
  "block.minecraft.purpur_slab": "Loosa purpur",
  "block.minecraft.purpur_stairs": "Eskaleera purpur",
  "block.minecraft.quartz_block": "Kuaarso",
  "block.minecraft.quartz_bricks": "Xrunùnthèchján kuaarso",
  "block.minecraft.quartz_pillar": "Pooste kuaarso",
  "block.minecraft.quartz_slab": "Loosa kuaarso",
  "block.minecraft.quartz_stairs": "Eskaleera kuaarso",
  "block.minecraft.rail": "Nthàchìà",
  "block.minecraft.raw_copper_block": "Kuubo koobere cha",
  "block.minecraft.raw_gold_block": "Kuubo tumisine cha",
  "block.minecraft.raw_iron_block": "Kuubo chìà cha",
  "block.minecraft.red_banner": "Bandeera játsè",
  "block.minecraft.red_bed": "Saun játsè",
  "block.minecraft.red_candle": "Nchicha játsè",
  "block.minecraft.red_candle_cake": "Pasteele kuníxin nchicha játsè",
  "block.minecraft.red_carpet": "Tapeete játsè",
  "block.minecraft.red_concrete": "Ormigon játsè",
  "block.minecraft.red_concrete_powder": "Semeento játsè",
  "block.minecraft.red_glazed_terracotta": "Asuleejo játsè",
  "block.minecraft.red_mushroom": "Kuchrjuì játsè",
  "block.minecraft.red_mushroom_block": "Kuubo kuchrjuì játsè",
  "block.minecraft.red_nether_brick_slab": "Loosa xrunùnthèchján játsè Nether",
  "block.minecraft.red_nether_brick_stairs": "Eskaleera xrunùnthèchján játsè Nether",
  "block.minecraft.red_nether_brick_wall": "Thjariuꞌù xrunùnthèchján játsè Nether",
  "block.minecraft.red_nether_bricks": "Xrunùnthèchján játsè Nether",
  "block.minecraft.red_sand": "Nchise játsè",
  "block.minecraft.red_sandstone": "Xrunchise játsè",
  "block.minecraft.red_sandstone_slab": "Loosa xrunchise játsè",
  "block.minecraft.red_sandstone_stairs": "Eskaleera xrunchise játsè",
  "block.minecraft.red_sandstone_wall": "Thjariuꞌù xrunchise játsè",
  "block.minecraft.red_shulker_box": "Kajón shulker játsè",
  "block.minecraft.red_stained_glass": "Xruxrau játsè",
  "block.minecraft.red_stained_glass_pane": "Paneele xruxrau játsè",
  "block.minecraft.red_terracotta": "Nchètjau tsíchján játsè",
  "block.minecraft.red_tulip": "Kàtulipan játsè",
  "block.minecraft.red_wool": "Chjun játsè",
  "block.minecraft.redstone_block": "Kuubo redstone",
  "block.minecraft.redstone_lamp": "Lamixin redstone",
  "block.minecraft.redstone_ore": "Meena redstone",
  "block.minecraft.redstone_torch": "Nthàxrùꞌì redstone",
  "block.minecraft.redstone_wall_torch": "Nthàxrùꞌì redstone ngaìn kuubo",
  "block.minecraft.redstone_wire": "Tsjachìà redstone",
  "block.minecraft.reinforced_deepslate": "Xru naxin xeꞌe cha",
  "block.minecraft.repeater": "Thí kjanthexiꞌin redstone",
  "block.minecraft.repeating_command_block": "Kuubo juathetun juathexin inaá",
  "block.minecraft.resin_block": "Kuubo chjìngù nthàà",
  "block.minecraft.resin_brick_slab": "Loosa xrunùnthèchján chjìngù nthàà",
  "block.minecraft.resin_brick_stairs": "Eskaleera xrunùnthèchján chjìngù nthàà",
  "block.minecraft.resin_brick_wall": "Thjariuꞌù xrunùnthèchján chjìngù nthàà",
  "block.minecraft.resin_bricks": "Xrùnùnthèchján chjìngù nthàà",
  "block.minecraft.resin_clump": "Chjìngù nthàà",
  "block.minecraft.respawn_anchor": "Thí tununxin ni",
  "block.minecraft.rooted_dirt": "Jìnchè kuníxin nuꞌe",
  "block.minecraft.rose_bush": "Nthàroosa",
  "block.minecraft.sand": "Nchise",
  "block.minecraft.sandstone": "Xrunchise",
  "block.minecraft.sandstone_slab": "Loosa xrunchise",
  "block.minecraft.sandstone_stairs": "Eskaleera xrunchise",
  "block.minecraft.sandstone_wall": "Thjariuꞌù xrunchise",
  "block.minecraft.scaffolding": "Andaamio",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Thí dikàù sculk",
  "block.minecraft.sculk_sensor": "Thí tunuꞌe sculk",
  "block.minecraft.sculk_shrieker": "Thí túyau sculk",
  "block.minecraft.sculk_vein": "Tsja sculk",
  "block.minecraft.sea_lantern": "Lamixin ndachaun",
  "block.minecraft.sea_pickle": "Kupepiino",
  "block.minecraft.seagrass": "Kàchjìnda",
  "block.minecraft.set_spawn": "Bàkèꞌè thí tsunuxin ni",
  "block.minecraft.short_dry_grass": "Kàchjì xemá nchiín",
  "block.minecraft.short_grass": "Kàchjì nchiín",
  "block.minecraft.shroomlight": "Kuchrjuì tungiixin",
  "block.minecraft.shulker_box": "Kajón shulker",
  "block.minecraft.skeleton_skull": "Nthàjàà xídeꞌen jintha",
  "block.minecraft.skeleton_wall_skull": "Nthàjàà xídeꞌen jintha ngaìn kuubo",
  "block.minecraft.slime_block": "Kuubo chjìtjùn",
  "block.minecraft.small_amethyst_bud": "Amatiista nchiín kè chriꞌin",
  "block.minecraft.small_dripleaf": "Kàdatsinxín nchiín",
  "block.minecraft.smithing_table": "Nthànchechjianxín chìà",
  "block.minecraft.smoker": "Nthàncheyasuxín jiꞌnchin",
  "block.minecraft.smooth_basalt": "Basaalto ꞌndu",
  "block.minecraft.smooth_quartz": "Kuubo kuaarso ꞌndu",
  "block.minecraft.smooth_quartz_slab": "Loosa kuaarso ꞌndu",
  "block.minecraft.smooth_quartz_stairs": "Eskaleera kuaarso ꞌndu",
  "block.minecraft.smooth_red_sandstone": "Xrunchise játsè ꞌndu",
  "block.minecraft.smooth_red_sandstone_slab": "Loosa xrunchise játsè ꞌndu",
  "block.minecraft.smooth_red_sandstone_stairs": "Eskaleera xrunchise játsè ꞌndu",
  "block.minecraft.smooth_sandstone": "Xrunchise ꞌndu",
  "block.minecraft.smooth_sandstone_slab": "Loosa xrunchise ꞌndu",
  "block.minecraft.smooth_sandstone_stairs": "Eskaleera xrunchise ꞌndu",
  "block.minecraft.smooth_stone": "Xru ꞌndu",
  "block.minecraft.smooth_stone_slab": "Loosa xru ꞌndu",
  "block.minecraft.sniffer_egg": "Juja kuthuchìnthjun",
  "block.minecraft.snow": "Chrintha",
  "block.minecraft.snow_block": "Kuubo chrintha",
  "block.minecraft.soul_campfire": "Giꞌi anséèn ni",
  "block.minecraft.soul_fire": "Xrùꞌì anséèn ni",
  "block.minecraft.soul_lantern": "Lamixin anséèn ni",
  "block.minecraft.soul_sand": "Nchise anséèn ni",
  "block.minecraft.soul_soil": "Jìnchè anséèn ni",
  "block.minecraft.soul_torch": "Nthàxrùꞌì anséèn ni",
  "block.minecraft.soul_wall_torch": "Nthàxrùꞌì anséèn ni ngaìn kuubo",
  "block.minecraft.spawn.not_valid": "Chundaꞌa saun o jíchreꞌa thí tununxin ni, o jeꞌe xranutaun",
  "block.minecraft.spawner": "Thí xraguxín kumoostoro",
  "block.minecraft.spawner.desc1": "Nchegunda naá juja juatununxin:",
  "block.minecraft.spawner.desc2": "Dàkèꞌè tiipo kuxíígu",
  "block.minecraft.sponge": "Espoonja",
  "block.minecraft.spore_blossom": "Tsjù espoora",
  "block.minecraft.spruce_button": "Boton nthànchicha",
  "block.minecraft.spruce_door": "Nthàdijexín nthànchicha",
  "block.minecraft.spruce_fence": "Chjàte nthànchicha",
  "block.minecraft.spruce_fence_gate": "Nthàdijexín chjàte nthànchicha",
  "block.minecraft.spruce_hanging_sign": "Nthàkjìxín nthànchicha kè deriaꞌnda",
  "block.minecraft.spruce_leaves": "Kà nthànchicha",
  "block.minecraft.spruce_log": "Nthàriuꞌu nthànchicha",
  "block.minecraft.spruce_planks": "Nthàchiso nthànchicha",
  "block.minecraft.spruce_pressure_plate": "Palaaka juangachje nthànchicha",
  "block.minecraft.spruce_sapling": "Nthànchicha kè chriꞌin",
  "block.minecraft.spruce_shelf": "Repiisa nthànchicha",
  "block.minecraft.spruce_sign": "Nthàkjìxín nthànchicha",
  "block.minecraft.spruce_slab": "Loosa nthànchicha",
  "block.minecraft.spruce_stairs": "Eskaleera nthànchicha",
  "block.minecraft.spruce_trapdoor": "Nthàdijexínchjàn nthànchicha",
  "block.minecraft.spruce_wall_hanging_sign": "Nthàkjìxín nthànchicha kè deriaꞌnda ngaìn kuubo",
  "block.minecraft.spruce_wall_sign": "Nthàkjìxín nthànchicha ngaìn kuubo",
  "block.minecraft.spruce_wood": "Nthànchicha",
  "block.minecraft.sticky_piston": "Piston se",
  "block.minecraft.stone": "Xru",
  "block.minecraft.stone_brick_slab": "Loosa xrunùnthèchján",
  "block.minecraft.stone_brick_stairs": "Eskaleera xrunùnthèchján",
  "block.minecraft.stone_brick_wall": "Thjariuꞌù xrunùnthèchján",
  "block.minecraft.stone_bricks": "Xrunùnthèchján",
  "block.minecraft.stone_button": "Boton xru",
  "block.minecraft.stone_pressure_plate": "Palaaka juangachje xru",
  "block.minecraft.stone_slab": "Loosa xru",
  "block.minecraft.stone_stairs": "Eskaleera xru",
  "block.minecraft.stonecutter": "Thí taade xru",
  "block.minecraft.stripped_acacia_log": "Nthàriuꞌu nthànchaꞌa naꞌí kuníxin rua",
  "block.minecraft.stripped_acacia_wood": "Nthànchaꞌa naꞌí kuníxin rua",
  "block.minecraft.stripped_bamboo_block": "Kuubo tjì jié thuluchu",
  "block.minecraft.stripped_birch_log": "Nthàriuꞌu nthàbetuula naꞌí kuníxin rua",
  "block.minecraft.stripped_birch_wood": "Nthàbetuula naꞌí kuníxin rua",
  "block.minecraft.stripped_cherry_log": "Nthàriuꞌu nthàsereeso naꞌí kuníxin rua",
  "block.minecraft.stripped_cherry_wood": "Nthàsereeso naꞌí kuníxin rua",
  "block.minecraft.stripped_crimson_hyphae": "Iifa játsè naꞌí kuníxin rua",
  "block.minecraft.stripped_crimson_stem": "Nthàxijì játsè naꞌí kuníxin rua",
  "block.minecraft.stripped_dark_oak_log": "Nthàriuꞌu nthàthjau naxin xeꞌe naꞌí kuníxin rua",
  "block.minecraft.stripped_dark_oak_wood": "Nthàthjau naxin xeꞌe naꞌí kuníxin rua",
  "block.minecraft.stripped_jungle_log": "Nthàriuꞌu nthàjié tjau naꞌí kuníxin rua",
  "block.minecraft.stripped_jungle_wood": "Nthàjié tjau naꞌí kuníxin rua",
  "block.minecraft.stripped_mangrove_log": "Nthàriuꞌu nthàsau naꞌí kuníxin rua",
  "block.minecraft.stripped_mangrove_wood": "Nthàsau naꞌí kuníxin rua",
  "block.minecraft.stripped_oak_log": "Nthàriuꞌu nthàthjau naꞌí kuníxin rua",
  "block.minecraft.stripped_oak_wood": "Nthàthjau naꞌí kuníxin rua",
  "block.minecraft.stripped_pale_oak_log": "Nthàriuꞌu nthàthjau seen naꞌí kuníxin rua",
  "block.minecraft.stripped_pale_oak_wood": "Nthàthjau seen naꞌí kuníxin rua",
  "block.minecraft.stripped_spruce_log": "Nthàriuꞌu nthànchicha naꞌí kuníxin rua",
  "block.minecraft.stripped_spruce_wood": "Nthànchicha naꞌí kuníxin rua",
  "block.minecraft.stripped_warped_hyphae": "Iifa xraduꞌu naꞌí kuníxin rua",
  "block.minecraft.stripped_warped_stem": "Nthàxijì xraduꞌu naꞌí kuníxin rua",
  "block.minecraft.structure_block": "Kuubo juathethe",
  "block.minecraft.structure_void": "Chrinthu juathethe",
  "block.minecraft.sugar_cane": "Nthàxijì tsjen",
  "block.minecraft.sunflower": "Kànchaꞌun",
  "block.minecraft.suspicious_gravel": "Xrùxruá ujekua",
  "block.minecraft.suspicious_sand": "Nchise ujekua",
  "block.minecraft.sweet_berry_bush": "Nthàbaaya",
  "block.minecraft.tall_dry_grass": "Kàchjì xemá nuí",
  "block.minecraft.tall_grass": "Kàchjì nuí",
  "block.minecraft.tall_seagrass": "Kàchjìnda nuí",
  "block.minecraft.target": "Diaana",
  "block.minecraft.terracotta": "Nchètjau tsíchján",
  "block.minecraft.test_block": "Kuubo thjengayaxinxín",
  "block.minecraft.test_instance_block": "Kuubo xraguxín juathjengayaxin",
  "block.minecraft.tinted_glass": "Xruxrau naxin xeꞌe",
  "block.minecraft.tnt": "Dinamiita",
  "block.minecraft.tnt.disabled": "Juatunchrítùn dinamiita danga",
  "block.minecraft.torch": "Nthàxrùꞌì",
  "block.minecraft.torchflower": "Kàxrùꞌì",
  "block.minecraft.torchflower_crop": "Juanchegani kàxrùꞌì",
  "block.minecraft.trapped_chest": "Nthàkajón ncheyexín",
  "block.minecraft.trial_spawner": "Thí xraguxín chijni",
  "block.minecraft.tripwire": "Xuchjiꞌan nchekaunxín",
  "block.minecraft.tripwire_hook": "Gaancho xuchjiꞌan",
  "block.minecraft.tube_coral": "Kàndachaun tuubo",
  "block.minecraft.tube_coral_block": "Kuubo kàndachaun tuubo",
  "block.minecraft.tube_coral_fan": "Kugorgoonia tuubo",
  "block.minecraft.tube_coral_wall_fan": "Kugorgoonia tuubo kè beꞌen",
  "block.minecraft.tuff": "Tooba",
  "block.minecraft.tuff_brick_slab": "Loosa xrunùnthèchján tooba",
  "block.minecraft.tuff_brick_stairs": "Eskaleera xrunùnthèchján tooba",
  "block.minecraft.tuff_brick_wall": "Thjariuꞌù xrunùnthèchján tooba",
  "block.minecraft.tuff_bricks": "Xrunùnthèchján tooba",
  "block.minecraft.tuff_slab": "Loosa tooba",
  "block.minecraft.tuff_stairs": "Eskaleera tooba",
  "block.minecraft.tuff_wall": "Thjariuꞌù tooba",
  "block.minecraft.turtle_egg": "Juja kunchènthà",
  "block.minecraft.twisting_vines": "Nthàtùxrùxrjò xraduꞌu",
  "block.minecraft.twisting_vines_plant": "Nthàtùxrùxrjò xraduꞌu",
  "block.minecraft.vault": "Arkon",
  "block.minecraft.verdant_froglight": "Xrùꞌì kurana yùà",
  "block.minecraft.vine": "Nthàtùxrùxrjò",
  "block.minecraft.void_air": "Chrinthu xruꞌin",
  "block.minecraft.wall_torch": "Nthàxrùꞌì ngaìn kuubo",
  "block.minecraft.warped_button": "Boton xraduꞌu",
  "block.minecraft.warped_door": "Nthàdijexín xraduꞌu",
  "block.minecraft.warped_fence": "Chjàte xraduꞌu",
  "block.minecraft.warped_fence_gate": "Nthàdijexín chjàte xraduꞌu",
  "block.minecraft.warped_fungus": "Kuchrjuì xraduꞌu",
  "block.minecraft.warped_hanging_sign": "Nthàkjìxín xraduꞌu kè deriaꞌnda",
  "block.minecraft.warped_hyphae": "Iifa xraduꞌu",
  "block.minecraft.warped_nylium": "Niilio xraduꞌu",
  "block.minecraft.warped_planks": "Nthàchiso xraduꞌu",
  "block.minecraft.warped_pressure_plate": "Palaaka juangachje xraduꞌu",
  "block.minecraft.warped_roots": "Nuꞌe xraduꞌu",
  "block.minecraft.warped_shelf": "Repiisa xraduꞌu",
  "block.minecraft.warped_sign": "Nthàkjìxín xraduꞌu",
  "block.minecraft.warped_slab": "Loosa xraduꞌu",
  "block.minecraft.warped_stairs": "Eskaleera xraduꞌu",
  "block.minecraft.warped_stem": "Nthàxijì xraduꞌu",
  "block.minecraft.warped_trapdoor": "Nthàdijexínchjàn xraduꞌu",
  "block.minecraft.warped_wall_hanging_sign": "Nthàkjìxín xraduꞌu kè deriaꞌnda ngaìn kuubo",
  "block.minecraft.warped_wall_sign": "Nthàkjìxín xraduꞌu ngaìn kuubo",
  "block.minecraft.warped_wart_block": "Kuubo kàkuthuneꞌe xraduꞌu",
  "block.minecraft.water": "Jinda",
  "block.minecraft.water_cauldron": "Kaldeero kuníxin jinda",
  "block.minecraft.waxed_chiseled_copper": "Koobere tsujin kuníxin chjìngù",
  "block.minecraft.waxed_copper_bars": "Nthàchìà koobere kuníxin chjìngù",
  "block.minecraft.waxed_copper_block": "Kuubo koobere kuníxin chjìngù",
  "block.minecraft.waxed_copper_bulb": "Fooko koobere kuníxin chjìngù",
  "block.minecraft.waxed_copper_chain": "Chìànu koobere kuníxin chjìngù",
  "block.minecraft.waxed_copper_chest": "Kajón koobere kuníxin chjìngù",
  "block.minecraft.waxed_copper_door": "Nthàdijexín koobere kuníxin chjìngù",
  "block.minecraft.waxed_copper_golem_statue": "Estaatua goolen koobere kuníxin chjìngù",
  "block.minecraft.waxed_copper_grate": "Rejiiya koobere kuníxin chjìngù",
  "block.minecraft.waxed_copper_lantern": "Lamixin koobere kuníxin chjìngù",
  "block.minecraft.waxed_copper_trapdoor": "Nthàdijexínchjàn koobere kuníxin chjìngù",
  "block.minecraft.waxed_cut_copper": "Koobere kuníxin chjìngù kè chrijin",
  "block.minecraft.waxed_cut_copper_slab": "Loosa koobere kuníxin chjìngù kè chrijin",
  "block.minecraft.waxed_cut_copper_stairs": "Eskaleera koobere kuníxin chjìngù kè chrijin",
  "block.minecraft.waxed_exposed_chiseled_copper": "Koobere tsujin kuníxin chjìngù kè xraagu ndújà",
  "block.minecraft.waxed_exposed_copper": "Koobere kuníxin chjìngù kè xraagu ndújà",
  "block.minecraft.waxed_exposed_copper_bars": "Nthàchìà koobere kuníxin chjìngù kè xraagu ndújà",
  "block.minecraft.waxed_exposed_copper_bulb": "Fooko koobere kuníxin chjìngù kè xraagu ndújà",
  "block.minecraft.waxed_exposed_copper_chain": "Chìànu koobere kuníxin chjìngù kè xraagu ndújà",
  "block.minecraft.waxed_exposed_copper_chest": "Kajón koobere kuníxin chjìngù kè xraagu ndújà",
  "block.minecraft.waxed_exposed_copper_door": "Nthàdijexín koobere kuníxin chjìngù kè xraagu ndújà",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Estaatua goolen koobere kuníxin chjìngù kè xraagu ndújà",
  "block.minecraft.waxed_exposed_copper_grate": "Rejiiya koobere kuníxin chjìngù kè xraagu ndújà",
  "block.minecraft.waxed_exposed_copper_lantern": "Lamixin koobere kuníxin chjìngù kè xraagu ndújà",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Nthàdijexínchjàn koobere kuníxin chjìngù kè xraagu ndújà",
  "block.minecraft.waxed_exposed_cut_copper": "Koobere kuníxin chjìngù kè chrijin kù xraagu ndújà",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Loosa koobere kuníxin chjìngù kè chrijin kù xraagu ndújà",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Eskaleera koobere kuníxin chjìngù kè chrijin kù xraagu ndújà",
  "block.minecraft.waxed_exposed_lightning_rod": "Nthàtaxín raayo kuníxin chjìngù kè xraagu ndújà",
  "block.minecraft.waxed_lightning_rod": "Nthàtaxín raayo kuníxin chjìngù",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Koobere tsujin tsíkúchjìsen kuníxin chjìngù",
  "block.minecraft.waxed_oxidized_copper": "Koobere tsíkúchjìsen kuníxin chjìngù",
  "block.minecraft.waxed_oxidized_copper_bars": "Nthàchìà koobere tsíkúchjìsen kuníxin chjìngù",
  "block.minecraft.waxed_oxidized_copper_bulb": "Fooko koobere tsíkúchjìsen kuníxin chjìngù",
  "block.minecraft.waxed_oxidized_copper_chain": "Chìànu koobere tsíkúchjìsen kuníxin chjìngù",
  "block.minecraft.waxed_oxidized_copper_chest": "Kajón koobere tsíkúchjìsen kuníxin chjìngù",
  "block.minecraft.waxed_oxidized_copper_door": "Nthàdijexín koobere tsíkúchjìsen kuníxin chjìngù",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Estaatua goolen koobere tsíkúchjìsen kuníxin chjìngù",
  "block.minecraft.waxed_oxidized_copper_grate": "Rejiiya koobere tsíkúchjìsen kuníxin chjìngù",
  "block.minecraft.waxed_oxidized_copper_lantern": "Lamixin koobere tsíkúchjìsen kuníxin chjìngù",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Nthàdijexínchjàn koobere tsíkúchjìsen kuníxin chjìngù",
  "block.minecraft.waxed_oxidized_cut_copper": "Koobere tsíkúchjìsen kuníxin chjìngù kè chrijin",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Loosa koobere tsíkúchjìsen kuníxin chjìngù kè chrijin",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Eskaleera koobere tsíkúchjìsen kuníxin chjìngù kè chrijin",
  "block.minecraft.waxed_oxidized_lightning_rod": "Nthàtaxín raayo tsíkúchjìsen kuníxin chjìngù",
  "block.minecraft.waxed_weathered_chiseled_copper": "Koobere tsujin nthaxii kuníxin chjìngù",
  "block.minecraft.waxed_weathered_copper": "Koobere nthaxii kuníxin chjìngù",
  "block.minecraft.waxed_weathered_copper_bars": "Nthàchìà koobere nthaxii kuníxin chjìngù",
  "block.minecraft.waxed_weathered_copper_bulb": "Fooko koobere nthaxii kuníxin chjìngù",
  "block.minecraft.waxed_weathered_copper_chain": "Chìànu koobere nthaxii kuníxin chjìngù",
  "block.minecraft.waxed_weathered_copper_chest": "Kajón koobere nthaxii kuníxin chjìngù",
  "block.minecraft.waxed_weathered_copper_door": "Nthàdijexín koobere nthaxii kuníxin chjìngù",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Estaatua goolen koobere nthaxii kuníxin chjìngù",
  "block.minecraft.waxed_weathered_copper_grate": "Rejiiya koobere nthaxii kuníxin chjìngù",
  "block.minecraft.waxed_weathered_copper_lantern": "Lamixin koobere nthaxii kuníxin chjìngù",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Nthàdijexínchjàn koobere nthaxii kuníxin chjìngù",
  "block.minecraft.waxed_weathered_cut_copper": "Koobere nthaxii kuníxin chjìngù kè chrijin",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Loosa koobere nthaxii kuníxin chjìngù kè chrijin",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Eskaleera koobere nthaxii kuníxin chjìngù kè chrijin",
  "block.minecraft.waxed_weathered_lightning_rod": "Nthàtaxín raayo nthaxii kuníxin chjìngù",
  "block.minecraft.weathered_chiseled_copper": "Koobere tsujin nthaxii",
  "block.minecraft.weathered_copper": "Koobere nthaxii",
  "block.minecraft.weathered_copper_bars": "Nthàchìà koobere nthaxii",
  "block.minecraft.weathered_copper_bulb": "Fooko koobere nthaxii",
  "block.minecraft.weathered_copper_chain": "Chìànu koobere nthaxii",
  "block.minecraft.weathered_copper_chest": "Kajón koobere nthaxii",
  "block.minecraft.weathered_copper_door": "Nthàdijexín koobere nthaxii",
  "block.minecraft.weathered_copper_golem_statue": "Estaatua goolen koobere nthaxii",
  "block.minecraft.weathered_copper_grate": "Rejiiya koobere nthaxii",
  "block.minecraft.weathered_copper_lantern": "Lamixin koobere nthaxii",
  "block.minecraft.weathered_copper_trapdoor": "Nthàdijexínchjàn koobere nthaxii",
  "block.minecraft.weathered_cut_copper": "Koobere nthaxii kè chrijin",
  "block.minecraft.weathered_cut_copper_slab": "Loosa koobere nthaxii kè chrijin",
  "block.minecraft.weathered_cut_copper_stairs": "Eskaleera koobere nthaxii kè chrijin",
  "block.minecraft.weathered_lightning_rod": "Nthàtaxín raayo nthaxii",
  "block.minecraft.weeping_vines": "Nthàtùxrùxrjò tsjánga",
  "block.minecraft.weeping_vines_plant": "Nthàtùxrùxrjò kè tsjánga",
  "block.minecraft.wet_sponge": "Espoonja tjau",
  "block.minecraft.wheat": "Juanchegani jìnù najni",
  "block.minecraft.white_banner": "Bandeera rua",
  "block.minecraft.white_bed": "Saun rua",
  "block.minecraft.white_candle": "Nchicha rua",
  "block.minecraft.white_candle_cake": "Pasteele kuníxin nchicha rua",
  "block.minecraft.white_carpet": "Tepeete rua",
  "block.minecraft.white_concrete": "Ormigon rua",
  "block.minecraft.white_concrete_powder": "Semeento rua",
  "block.minecraft.white_glazed_terracotta": "Asuleejo rua",
  "block.minecraft.white_shulker_box": "Kajón shulker rua",
  "block.minecraft.white_stained_glass": "Xruxrau rua",
  "block.minecraft.white_stained_glass_pane": "Paneele xruxrau rua",
  "block.minecraft.white_terracotta": "Nchètjau tsíchján rua",
  "block.minecraft.white_tulip": "Kàtulipan rua",
  "block.minecraft.white_wool": "Chjun rua",
  "block.minecraft.wildflowers": "Tsjù nthàjié",
  "block.minecraft.wither_rose": "Kàroosa Wither",
  "block.minecraft.wither_skeleton_skull": "Nthàjàà Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Nthàjàà Wither ngaìn kuubo",
  "block.minecraft.yellow_banner": "Bandeera sine",
  "block.minecraft.yellow_bed": "Saun sine",
  "block.minecraft.yellow_candle": "Nchicha sine",
  "block.minecraft.yellow_candle_cake": "Pasteele kuníxin nchicha sine",
  "block.minecraft.yellow_carpet": "Tapeete sine",
  "block.minecraft.yellow_concrete": "Ormigon sine",
  "block.minecraft.yellow_concrete_powder": "Semeento sine",
  "block.minecraft.yellow_glazed_terracotta": "Asuleejo sine",
  "block.minecraft.yellow_shulker_box": "Kajón shulker sine",
  "block.minecraft.yellow_stained_glass": "Xruxrau sine",
  "block.minecraft.yellow_stained_glass_pane": "Paneele xruxrau sine",
  "block.minecraft.yellow_terracotta": "Nchètjau tsíchján sine",
  "block.minecraft.yellow_wool": "Chjun sine",
  "block.minecraft.zombie_head": "Jàà xíniꞌi",
  "block.minecraft.zombie_wall_head": "Jàà xíniꞌi ngaìn kuubo",
  "item.minecraft.acacia_boat": "Nthàboote nthànchaꞌa",
  "item.minecraft.acacia_chest_boat": "Nthàboote nthànchaꞌa kuníxin nthàkajón",
  "item.minecraft.allay_spawn_egg": "Juja xraguxín xànthengijna",
  "item.minecraft.amethyst_shard": "Thuꞌa amatiista",
  "item.minecraft.angler_pottery_shard": "Thuꞌa seraamika xítsaa kuchee",
  "item.minecraft.angler_pottery_sherd": "Thuꞌa seraamika xítsaa kuchee",
  "item.minecraft.apple": "Thùsuꞌin najni",
  "item.minecraft.archer_pottery_shard": "Thuꞌa seraamika xídenxunxín chijnu",
  "item.minecraft.archer_pottery_sherd": "Thuꞌa seraamika xídenxunxín chijnu",
  "item.minecraft.armadillo_scute": "Xuli kuarmadiyo",
  "item.minecraft.armadillo_spawn_egg": "Juja xraguxín kuarmadiyo",
  "item.minecraft.armor_stand": "Nthàdingaa armaduura",
  "item.minecraft.arms_up_pottery_shard": "Thuꞌa seraamika sàꞌùn",
  "item.minecraft.arms_up_pottery_sherd": "Thuꞌa seraamika sàꞌùn",
  "item.minecraft.arrow": "Chijnu",
  "item.minecraft.axolotl_bucket": "Kubeeta kuníxin kunthuinda",
  "item.minecraft.axolotl_spawn_egg": "Juja xraguxín kunthuinda",
  "item.minecraft.baked_potato": "Thùkjà tsíchján",
  "item.minecraft.bamboo_chest_raft": "Boote tjì jié kuníxin nthàkajón",
  "item.minecraft.bamboo_raft": "Boote tjì jié",
  "item.minecraft.bat_spawn_egg": "Juja xraguxín kuníngo",
  "item.minecraft.bee_spawn_egg": "Juja xraguxín kutsjènda",
  "item.minecraft.beef": "Nthàù kuxinthàa yùa",
  "item.minecraft.beetroot": "Thùremolaacha",
  "item.minecraft.beetroot_seeds": "Tsee thùremolaacha",
  "item.minecraft.beetroot_soup": "Ndàxrà thùremolaacha",
  "item.minecraft.birch_boat": "Nthàboote nthàbetuula",
  "item.minecraft.birch_chest_boat": "Nthàboote nthàbetuula kuníxin nthàkajón",
  "item.minecraft.black_bundle": "Tsaxechjàn thié",
  "item.minecraft.black_dye": "Ndathengaxín thié",
  "item.minecraft.black_harness": "Arneese thié",
  "item.minecraft.blade_pottery_shard": "Thuꞌa seraamika nthàespaada",
  "item.minecraft.blade_pottery_sherd": "Thuꞌa seraamika nthàespaada",
  "item.minecraft.blaze_powder": "Jìnchè kuxrùꞌì",
  "item.minecraft.blaze_rod": "Nthàsen kuxrùꞌì",
  "item.minecraft.blaze_spawn_egg": "Juja xraguxín kuxrùꞌì",
  "item.minecraft.blue_bundle": "Tsaxechjàn yùà",
  "item.minecraft.blue_dye": "Ndathengaxín yùà",
  "item.minecraft.blue_egg": "Juja yùà",
  "item.minecraft.blue_harness": "Arneese yùà",
  "item.minecraft.bogged_spawn_egg": "Juja xraguxín xítúnkithja",
  "item.minecraft.bolt_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Juatsujin raayo",
  "item.minecraft.bone": "Nthaluru",
  "item.minecraft.bone_meal": "Nthaluru xrunda",
  "item.minecraft.book": "Xrùun",
  "item.minecraft.bordure_indented_banner_pattern": "Chjiꞌni nenu ngandeꞌe thi",
  "item.minecraft.bow": "Nthàtjaxín chijnu",
  "item.minecraft.bowl": "Tason",
  "item.minecraft.bread": "Nìùthja",
  "item.minecraft.breeze_rod": "Nthàsen kuthuchrinthu",
  "item.minecraft.breeze_spawn_egg": "Juja xraguxín kuthuchrinthu",
  "item.minecraft.brewer_pottery_shard": "Thuꞌa seraamika xruan",
  "item.minecraft.brewer_pottery_sherd": "Thuꞌa seraamika xruan",
  "item.minecraft.brewing_stand": "Alkataara",
  "item.minecraft.brick": "Xrunùnthèchján",
  "item.minecraft.brown_bundle": "Tsaxechjàn seen",
  "item.minecraft.brown_dye": "Ndathengaxín seen",
  "item.minecraft.brown_egg": "Juja seen",
  "item.minecraft.brown_harness": "Arneese seen",
  "item.minecraft.brush": "Xíche",
  "item.minecraft.bucket": "Kubeeta",
  "item.minecraft.bundle": "Tsaxechjàn",
  "item.minecraft.bundle.empty": "Tsíkinthji",
  "item.minecraft.bundle.empty.description": "Nchaú tsenchjiꞌan kanxín objeeto jejee",
  "item.minecraft.bundle.full": "Chre",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Thuꞌa seraamika xrùꞌì",
  "item.minecraft.burn_pottery_sherd": "Thuꞌa seraamika xrùꞌì",
  "item.minecraft.camel_husk_spawn_egg": "Juja xraguxín kudoromedaario xemá",
  "item.minecraft.camel_spawn_egg": "Juja xraguxín kudoromedaario",
  "item.minecraft.carrot": "Thùsanaooria",
  "item.minecraft.carrot_on_a_stick": "Nthàà kuníxin thùsanaooria",
  "item.minecraft.cat_spawn_egg": "Juja xraguxín kumíchin",
  "item.minecraft.cauldron": "Kaldeero",
  "item.minecraft.cave_spider_spawn_egg": "Juja xraguxín kuthuchje tjoꞌmá",
  "item.minecraft.chainmail_boots": "Therua nunchaꞌa chìà",
  "item.minecraft.chainmail_chestplate": "Koraasa nunchaꞌa chìà",
  "item.minecraft.chainmail_helmet": "Juchu nunchaꞌa chìà",
  "item.minecraft.chainmail_leggings": "Jichaꞌu kacha nunchaꞌa chìà",
  "item.minecraft.charcoal": "Nchùnì",
  "item.minecraft.cherry_boat": "Nthàboote nthàsereeso",
  "item.minecraft.cherry_chest_boat": "Nthàboote nthàsereeso kuníxin nthàkajón",
  "item.minecraft.chest_minecart": "Nthàbagon kuníxin nthàkajón",
  "item.minecraft.chicken": "Nthàù kuchiá yùà",
  "item.minecraft.chicken_spawn_egg": "Juja xraguxín kuchiá",
  "item.minecraft.chorus_fruit": "Thùkooro",
  "item.minecraft.clay_ball": "Thulu nchètjè",
  "item.minecraft.clock": "Nthàthekinxín orá",
  "item.minecraft.coal": "Nchùnì",
  "item.minecraft.coast_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Juatsujin kun ndachaun",
  "item.minecraft.cocoa_beans": "Kakao",
  "item.minecraft.cod": "Kubakalao yùà",
  "item.minecraft.cod_bucket": "Kubeeta kuníxin kubakalao",
  "item.minecraft.cod_spawn_egg": "Juja xraguxín kubakalao",
  "item.minecraft.command_block_minecart": "Nthàbagon kuníxin kuubo juathetun",
  "item.minecraft.compass": "Buruujula",
  "item.minecraft.cooked_beef": "Nthàù tsíchján",
  "item.minecraft.cooked_chicken": "Nthàù kuchiá tsíchján",
  "item.minecraft.cooked_cod": "Kubakalao tsíchján",
  "item.minecraft.cooked_mutton": "Nthàù kuthúchjùn tsíchján",
  "item.minecraft.cooked_porkchop": "Nthàù kukuchi tsíchján",
  "item.minecraft.cooked_rabbit": "Nthàù kuláanu tsíchján",
  "item.minecraft.cooked_salmon": "Kusalmon tsíchján",
  "item.minecraft.cookie": "Gayeeta",
  "item.minecraft.copper_axe": "Nthàtadexín koobere",
  "item.minecraft.copper_boots": "Therua koobere",
  "item.minecraft.copper_chestplate": "Koraasa koobere",
  "item.minecraft.copper_golem_spawn_egg": "Juja xraguxín goolen koobere",
  "item.minecraft.copper_helmet": "Juchu koobere",
  "item.minecraft.copper_hoe": "Nthàtaunxín koobere",
  "item.minecraft.copper_horse_armor": "Armaduura koobere íxin kunxin",
  "item.minecraft.copper_ingot": "Lingoote koobere",
  "item.minecraft.copper_leggings": "Jichaꞌu kacha koobere",
  "item.minecraft.copper_nautilus_armor": "Armaduura koobere íxin kunautiilo",
  "item.minecraft.copper_nugget": "Pepiita koobere",
  "item.minecraft.copper_pickaxe": "Nthàpiiko koobere",
  "item.minecraft.copper_shovel": "Nthàpalá koobere",
  "item.minecraft.copper_spear": "Nthàthinchrjaxín koobere",
  "item.minecraft.copper_sword": "Nthàespaada koobere",
  "item.minecraft.cow_spawn_egg": "Juja xraguxín kuxinthàà",
  "item.minecraft.creaking_spawn_egg": "Juja xraguxín kunthàsen",
  "item.minecraft.creeper_banner_pattern": "Chjiꞌni bandeera",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Chjiꞌni creeper",
  "item.minecraft.creeper_spawn_egg": "Juja xraguxín creeper",
  "item.minecraft.crossbow": "Bayeesta",
  "item.minecraft.crossbow.projectile": "Baala:",
  "item.minecraft.crossbow.projectile.multiple": "Baala: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Baala: %s",
  "item.minecraft.cyan_bundle": "Tsaxechjàn yùà ngajní",
  "item.minecraft.cyan_dye": "Ndathengaxín yùà",
  "item.minecraft.cyan_harness": "Arneese yùà ngajní",
  "item.minecraft.danger_pottery_shard": "Thuꞌa seraamika juaxraun",
  "item.minecraft.danger_pottery_sherd": "Thuꞌa seraamika juaxraun",
  "item.minecraft.dark_oak_boat": "Nthàboote nthàthjau naxin xeꞌe",
  "item.minecraft.dark_oak_chest_boat": "Nthàboote nthàthjau naxin xeꞌe kuníxin nthàkajón",
  "item.minecraft.debug_stick": "Nthàncheruaxín",
  "item.minecraft.debug_stick.empty": "%s chúndaꞌa perteneensia",
  "item.minecraft.debug_stick.select": "binchieꞌe ''%s'' (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" ngaìn %s",
  "item.minecraft.diamond": "Diamaante",
  "item.minecraft.diamond_axe": "Nthàtadexín diamaante",
  "item.minecraft.diamond_boots": "Therua diamaante",
  "item.minecraft.diamond_chestplate": "Koraasa diamaante",
  "item.minecraft.diamond_helmet": "Juchu diamaante",
  "item.minecraft.diamond_hoe": "Nthàtaunxín diamaante",
  "item.minecraft.diamond_horse_armor": "Armaduura diamaante íxin kunxin",
  "item.minecraft.diamond_leggings": "Jichaꞌu kacha diamaante",
  "item.minecraft.diamond_nautilus_armor": "Armaduura diamaante íxin kunautiilo",
  "item.minecraft.diamond_pickaxe": "Nthàpiiko diamaante",
  "item.minecraft.diamond_shovel": "Nthàpalá diamaante",
  "item.minecraft.diamond_spear": "Nthàthinchrjaxín diamaante",
  "item.minecraft.diamond_sword": "Nthàespaada diamaante",
  "item.minecraft.disc_fragment_5": "Thuꞌa diisko",
  "item.minecraft.disc_fragment_5.desc": "Diisko: 5",
  "item.minecraft.dolphin_spawn_egg": "Juja xraguxín kudelfin",
  "item.minecraft.donkey_spawn_egg": "Juja xraguxín kulúchù",
  "item.minecraft.dragon_breath": "Chrinthu ruꞌa kudaragon",
  "item.minecraft.dried_kelp": "Katan xemá",
  "item.minecraft.drowned_spawn_egg": "Juja xraguxín xíniꞌi tjau",
  "item.minecraft.dune_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Juatsujin duuna",
  "item.minecraft.echo_shard": "Thuꞌa juatjundayeꞌe",
  "item.minecraft.egg": "Juja",
  "item.minecraft.elder_guardian_spawn_egg": "Juja xraguxín ndùchenthà",
  "item.minecraft.elytra": "Nenechaan End",
  "item.minecraft.emerald": "Esmeraalda",
  "item.minecraft.enchanted_book": "Xrùun tsíkinthekjan",
  "item.minecraft.enchanted_golden_apple": "Thùsuꞌin najni tumisine tsíkinthekjan",
  "item.minecraft.end_crystal": "Xrusènthà End",
  "item.minecraft.ender_dragon_spawn_egg": "Juja xraguxín kudaragon",
  "item.minecraft.ender_eye": "Kun ender",
  "item.minecraft.ender_pearl": "Peerla ender",
  "item.minecraft.enderman_spawn_egg": "Juja xraguxín enderman",
  "item.minecraft.endermite_spawn_egg": "Juja xraguxín endermite",
  "item.minecraft.evoker_spawn_egg": "Juja xraguxín xídáyee kuxíígu",
  "item.minecraft.experience_bottle": "Xruxrau kuníxin eksperieensia",
  "item.minecraft.explorer_pottery_shard": "Thuꞌa seraamika xíchrji",
  "item.minecraft.explorer_pottery_sherd": "Thuꞌa seraamika xíchrji",
  "item.minecraft.eye_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Juatsujin kun ni",
  "item.minecraft.feather": "Nene",
  "item.minecraft.fermented_spider_eye": "Kun kuthuchje tsíchján",
  "item.minecraft.field_masoned_banner_pattern": "Chjiꞌni masonaado",
  "item.minecraft.filled_map": "Maapa",
  "item.minecraft.fire_charge": "Juathedue xrùꞌì",
  "item.minecraft.firework_rocket": "Nthàtjàxín kueete",
  "item.minecraft.firework_rocket.flight": "Juatunchrjéèn juatjaganga:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Jìnchè kueete",
  "item.minecraft.firework_star.black": "Thié",
  "item.minecraft.firework_star.blue": "Yùà",
  "item.minecraft.firework_star.brown": "Seen",
  "item.minecraft.firework_star.custom_color": "Jee",
  "item.minecraft.firework_star.cyan": "Yùà ngajní",
  "item.minecraft.firework_star.fade_to": "Kjamanga",
  "item.minecraft.firework_star.flicker": "Chiixru",
  "item.minecraft.firework_star.gray": "Xràtjù",
  "item.minecraft.firework_star.green": "Yùà",
  "item.minecraft.firework_star.light_blue": "Yùà",
  "item.minecraft.firework_star.light_gray": "Xràtjù",
  "item.minecraft.firework_star.lime": "Yùà",
  "item.minecraft.firework_star.magenta": "Játsè",
  "item.minecraft.firework_star.orange": "Thùnsán",
  "item.minecraft.firework_star.pink": "Tjuáꞌnde",
  "item.minecraft.firework_star.purple": "Játsè thié",
  "item.minecraft.firework_star.red": "Játsè",
  "item.minecraft.firework_star.shape": "Chùnxínꞌa foorma",
  "item.minecraft.firework_star.shape.burst": "Juatunthuni",
  "item.minecraft.firework_star.shape.creeper": "Ínchin creeper",
  "item.minecraft.firework_star.shape.large_ball": "Thulu jié",
  "item.minecraft.firework_star.shape.small_ball": "Thulu nchiín",
  "item.minecraft.firework_star.shape.star": "Ínchin kunutse",
  "item.minecraft.firework_star.trail": "Kuníxin chjiꞌni",
  "item.minecraft.firework_star.white": "Rua",
  "item.minecraft.firework_star.yellow": "Sine",
  "item.minecraft.fishing_rod": "Nthàtsaxín",
  "item.minecraft.flint": "Xrunthàxrù",
  "item.minecraft.flint_and_steel": "Xru nchekaunxín",
  "item.minecraft.flow_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Juatsujin espiira",
  "item.minecraft.flow_banner_pattern": "Chjiꞌni bandeera",
  "item.minecraft.flow_banner_pattern.desc": "Espiira",
  "item.minecraft.flow_banner_pattern.new": "Chjiꞌni espiira",
  "item.minecraft.flow_pottery_sherd": "Thuꞌa seraamika espiira",
  "item.minecraft.flower_banner_pattern": "Chjiꞌni bandeera",
  "item.minecraft.flower_banner_pattern.desc": "Tsjù",
  "item.minecraft.flower_banner_pattern.new": "Chjiꞌni tsjù",
  "item.minecraft.flower_pot": "Maseeta",
  "item.minecraft.fox_spawn_egg": "Juja xraguxín kunthakjan",
  "item.minecraft.friend_pottery_shard": "Thuꞌa seraamika dechjan",
  "item.minecraft.friend_pottery_sherd": "Thuꞌa seraamika dechjan",
  "item.minecraft.frog_spawn_egg": "Juja xraguxín kurana",
  "item.minecraft.furnace_minecart": "Nthàbagon kuníxin thja",
  "item.minecraft.ghast_spawn_egg": "Juja xraguxín ghast",
  "item.minecraft.ghast_tear": "Ndakun ghast",
  "item.minecraft.glass_bottle": "Xruxrau",
  "item.minecraft.glistering_melon_slice": "Thuꞌa thùsandia kè tungiixin",
  "item.minecraft.globe_banner_pattern": "Chjiꞌni bandeera",
  "item.minecraft.globe_banner_pattern.desc": "Nùnthè",
  "item.minecraft.globe_banner_pattern.new": "Chjiꞌni nùnthè",
  "item.minecraft.glow_berries": "Thùbaaya tungiixin",
  "item.minecraft.glow_ink_sac": "Tsaxechjàn kuníxin ndajnì kè tungiixin",
  "item.minecraft.glow_item_frame": "Nthàtjangixín kè tungiixin",
  "item.minecraft.glow_squid_spawn_egg": "Juja xraguxín kuthuchjenda jié tungiixin",
  "item.minecraft.glowstone_dust": "Xruchiixru xrunda",
  "item.minecraft.goat_horn": "Nthèꞌè kuxrajnu",
  "item.minecraft.goat_spawn_egg": "Juja xraguxín kuxrajnu",
  "item.minecraft.gold_ingot": "Lingoote tumisine",
  "item.minecraft.gold_nugget": "Pepiita tumisine",
  "item.minecraft.golden_apple": "Thùsuꞌin najni tumisine",
  "item.minecraft.golden_axe": "Nthàtadexín tumisine",
  "item.minecraft.golden_boots": "Therua tumisine",
  "item.minecraft.golden_carrot": "Thùsanaooria tumisine",
  "item.minecraft.golden_chestplate": "Koraasa tumisine",
  "item.minecraft.golden_helmet": "Juchu tumisine",
  "item.minecraft.golden_hoe": "Nthàtaunxín tumisine",
  "item.minecraft.golden_horse_armor": "Armaduura tumisine íxin kunxin",
  "item.minecraft.golden_leggings": "Jichaꞌu kacha tumisine",
  "item.minecraft.golden_nautilus_armor": "Armaduura tumisine íxin kunautiilo",
  "item.minecraft.golden_pickaxe": "Nthàpiiko tumisine",
  "item.minecraft.golden_shovel": "Nthàpalá tumisine",
  "item.minecraft.golden_spear": "Nthàthinchrjaxín tumisine",
  "item.minecraft.golden_sword": "Nthàespaada tumisine",
  "item.minecraft.gray_bundle": "Tsaxechjàn xràtjù",
  "item.minecraft.gray_dye": "Ndathengaxín xràtjù",
  "item.minecraft.gray_harness": "Arneese xràtjù",
  "item.minecraft.green_bundle": "Tsaxechjàn yùà",
  "item.minecraft.green_dye": "Ndathengaxín yùà",
  "item.minecraft.green_harness": "Arneese yùà",
  "item.minecraft.guardian_spawn_egg": "Juja xraguxín kuchenthà",
  "item.minecraft.gunpowder": "Jìnchè xrùꞌì",
  "item.minecraft.guster_banner_pattern": "Chjiꞌni bandeera",
  "item.minecraft.guster_banner_pattern.desc": "Chrinthu",
  "item.minecraft.guster_banner_pattern.new": "Chjiꞌni chrinthu",
  "item.minecraft.guster_pottery_sherd": "Thuꞌa seraamika chrinthu",
  "item.minecraft.happy_ghast_spawn_egg": "Juja xraguxín ghast kè chée",
  "item.minecraft.harness": "Arneese",
  "item.minecraft.heart_of_the_sea": "Anséèn ndachaun",
  "item.minecraft.heart_pottery_shard": "Thuꞌa seraamika anséèn ni",
  "item.minecraft.heart_pottery_sherd": "Thuꞌa seraamika anséèn ni",
  "item.minecraft.heartbreak_pottery_shard": "Thuꞌa seraamika anséèn ni ndakuaí",
  "item.minecraft.heartbreak_pottery_sherd": "Thuꞌa seraamika anséèn ni ndakuaí",
  "item.minecraft.hoglin_spawn_egg": "Juja xraguxín hoglin",
  "item.minecraft.honey_bottle": "Xruxrau kuníxin tsjen",
  "item.minecraft.honeycomb": "Katje kutsjènda",
  "item.minecraft.hopper_minecart": "Nthàbagon kuníxin toolba",
  "item.minecraft.horse_spawn_egg": "Juja xraguxín kunxin",
  "item.minecraft.host_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.host_armor_trim_smithing_template.new": "Juatsujin xídáyee chùjni",
  "item.minecraft.howl_pottery_shard": "Thuꞌa seraamika juatsjánga",
  "item.minecraft.howl_pottery_sherd": "Thuꞌa seraamika juatsjánga",
  "item.minecraft.husk_spawn_egg": "Juja xraguxín xíniꞌi xemá",
  "item.minecraft.ink_sac": "Tsaxechjàn kuníxin ndajnì",
  "item.minecraft.iron_axe": "Nthàtadexín chìà",
  "item.minecraft.iron_boots": "Therua chìà",
  "item.minecraft.iron_chestplate": "Koraasa chìà",
  "item.minecraft.iron_golem_spawn_egg": "Juja xraguxín goolen chìà",
  "item.minecraft.iron_helmet": "Juchu chìà",
  "item.minecraft.iron_hoe": "Nthàtaunxín chìà",
  "item.minecraft.iron_horse_armor": "Armaduura chìà íxin kunxin",
  "item.minecraft.iron_ingot": "Lingoote chìà",
  "item.minecraft.iron_leggings": "Jichaꞌu kacha chìà",
  "item.minecraft.iron_nautilus_armor": "Armaduura chìà íxin kunautiilo",
  "item.minecraft.iron_nugget": "Pepiita chìà",
  "item.minecraft.iron_pickaxe": "Nthàpiiko chìà",
  "item.minecraft.iron_shovel": "Nthàpalá chìà",
  "item.minecraft.iron_spear": "Nthàthinchrjaxín chìà",
  "item.minecraft.iron_sword": "Nthàespaada chìà",
  "item.minecraft.item_frame": "Nthàtjangixín",
  "item.minecraft.jungle_boat": "Nthàboote nthàjié tjau",
  "item.minecraft.jungle_chest_boat": "Nthàboote nthàjié tjau kuníxin nthàkajón",
  "item.minecraft.knowledge_book": "Xrùun najni",
  "item.minecraft.lapis_lazuli": "Lapislaasuli",
  "item.minecraft.lava_bucket": "Kubeeta kuníxin ndaxrùꞌì",
  "item.minecraft.lead": "Jinu",
  "item.minecraft.leather": "Rua",
  "item.minecraft.leather_boots": "Therua rua",
  "item.minecraft.leather_chestplate": "Tuunika rua",
  "item.minecraft.leather_helmet": "Juchu rua",
  "item.minecraft.leather_horse_armor": "Armaduura rua íxin kunxin",
  "item.minecraft.leather_leggings": "Jichaꞌu kacha rua",
  "item.minecraft.light_blue_bundle": "Tsaxechjàn yùà",
  "item.minecraft.light_blue_dye": "Ndathengaxín yùà",
  "item.minecraft.light_blue_harness": "Arneese yùà",
  "item.minecraft.light_gray_bundle": "Tsaxechjàn xràtjù",
  "item.minecraft.light_gray_dye": "Ndathengaxín xràtjù",
  "item.minecraft.light_gray_harness": "Arneese xràtjù",
  "item.minecraft.lime_bundle": "Tsaxechjàn yùà",
  "item.minecraft.lime_dye": "Ndathengaxín yùà",
  "item.minecraft.lime_harness": "Arneese yùà",
  "item.minecraft.lingering_potion": "Xruan kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.awkward": "Xruan jee kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.empty": "Xruan kè túnchrjéꞌen kè chruꞌa tsúnchjian",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Xruan juathexin ngaìn xrùꞌì kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.harming": "Xruan nchenixín kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.healing": "Xruan nchexingamexín kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.infested": "Xruan infestasioon kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.invisibility": "Xruan juaditjaan kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.leaping": "Xruan juachrínkà kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.levitation": "Xruan juatjaganga kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.luck": "Xruan sueerte kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.mundane": "Xruan ujekua kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.night_vision": "Xruan juadikun naxin xeꞌe kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.oozing": "Xruan chìtjùn kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.poison": "Xruan dexunxín kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.regeneration": "Xruan juaxingama kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.slow_falling": "Xruan juakjamangi yau kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.slowness": "Xruan yauxín kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.strength": "Xruan tsangaxín kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.swiftness": "Xruan ntheduxín kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.thick": "Xruan kjinté kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.turtle_master": "Xruéèn Tjaagu xrùun Kunchènthà kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.water": "Xruxrau kuníxin jinda kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.water_breathing": "Xruan chrinthu ngaìn jinda kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.weakness": "Xruan juachrjén kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.weaving": "Xruan juatjaun kè túnchrjéꞌen",
  "item.minecraft.lingering_potion.effect.wind_charged": "Xruan chrinthu kè túnchrjéꞌen",
  "item.minecraft.llama_spawn_egg": "Juja xraguxín kuyaama",
  "item.minecraft.lodestone_compass": "Buruujula kuníxin maknetiita",
  "item.minecraft.mace": "Nthàmaaso",
  "item.minecraft.magenta_bundle": "Tsaxechjàn játsè",
  "item.minecraft.magenta_dye": "Ndathengaxín játsè",
  "item.minecraft.magenta_harness": "Arneese játsè",
  "item.minecraft.magma_cream": "Chìtjùen kuthuchjìtjùn xrùꞌì",
  "item.minecraft.magma_cube_spawn_egg": "Juja xraguxín kuthuchjìtjùn xrùꞌì",
  "item.minecraft.mangrove_boat": "Nthàboote nthàsau",
  "item.minecraft.mangrove_chest_boat": "Nthàboote nthàsau kuníxin nthàkajón",
  "item.minecraft.map": "Maapa rua",
  "item.minecraft.melon_seeds": "Tsee thùsandia",
  "item.minecraft.melon_slice": "Thuꞌa thùsandia",
  "item.minecraft.milk_bucket": "Kubeeta kuníxin tsjìn",
  "item.minecraft.minecart": "Nthàbagon",
  "item.minecraft.miner_pottery_shard": "Thuꞌa seraamika xínge",
  "item.minecraft.miner_pottery_sherd": "Thuꞌa seraamika xínge",
  "item.minecraft.mojang_banner_pattern": "Chjiꞌni bandeera",
  "item.minecraft.mojang_banner_pattern.desc": "Keꞌe",
  "item.minecraft.mojang_banner_pattern.new": "Chjiꞌni keꞌe",
  "item.minecraft.mooshroom_spawn_egg": "Juja xraguxín mooshroom",
  "item.minecraft.mourner_pottery_shard": "Thuꞌa seraamika xídechiin",
  "item.minecraft.mourner_pottery_sherd": "Thuꞌa seraamika xídechiin",
  "item.minecraft.mule_spawn_egg": "Juja xraguxín kuruji",
  "item.minecraft.mushroom_stew": "Ndàxrà kuchrjuì",
  "item.minecraft.music_disc_11": "Diisko",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Diisko",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Diisko",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Diisko",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Diisko",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Diisko",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Diisko",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Diisko",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Diisko",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Diisko",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Diisko",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Diisko",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Diisko",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Diisko",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Diisko",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Diisko",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Diisko",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Diisko",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Diisko",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Diisko",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Diisko",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Nthàù kuthúchjùn yùà",
  "item.minecraft.name_tag": "Etikeeta",
  "item.minecraft.nautilus_shell": "Juchu kunautiilo",
  "item.minecraft.nautilus_spawn_egg": "Juja xraguxín kunautiilo",
  "item.minecraft.nether_brick": "Xrunùnthèchján Nether",
  "item.minecraft.nether_star": "Kunutse Nether",
  "item.minecraft.nether_wart": "Kàthuneꞌe Nether",
  "item.minecraft.netherite_axe": "Nthàtadexín netheriita",
  "item.minecraft.netherite_boots": "Therua netheriita",
  "item.minecraft.netherite_chestplate": "Koraasa netheriita",
  "item.minecraft.netherite_helmet": "Juchu netheriita",
  "item.minecraft.netherite_hoe": "Nthàtaunxín netheriita",
  "item.minecraft.netherite_horse_armor": "Armaduura netheriita íxin kunxin",
  "item.minecraft.netherite_ingot": "Lingoote netheriita",
  "item.minecraft.netherite_leggings": "Jichaꞌu kacha netheriita",
  "item.minecraft.netherite_nautilus_armor": "Armaduura netheriita íxin kunautiilo",
  "item.minecraft.netherite_pickaxe": "Nthàpiiko netheriita",
  "item.minecraft.netherite_scrap": "Thuꞌa netheriita",
  "item.minecraft.netherite_shovel": "Nthàpalá netheriita",
  "item.minecraft.netherite_spear": "Nthàthinchrjaxín netheriita",
  "item.minecraft.netherite_sword": "Nthàespaada netheriita",
  "item.minecraft.netherite_upgrade_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Juanchejían netheriita",
  "item.minecraft.oak_boat": "Nthàboote nthàthjau",
  "item.minecraft.oak_chest_boat": "Nthàboote nthàthjau kuníxin nthàkajón",
  "item.minecraft.ocelot_spawn_egg": "Juja xraguxín kutigrechjàn",
  "item.minecraft.ominous_bottle": "Xruxrau ujekua",
  "item.minecraft.ominous_trial_key": "Yaabe chijni ujekua",
  "item.minecraft.orange_bundle": "Tsaxechjàn thùnsán",
  "item.minecraft.orange_dye": "Ndathengaxín thùnsán",
  "item.minecraft.orange_harness": "Arneese thùnsán",
  "item.minecraft.painting": "Chjiꞌni tsíkenga",
  "item.minecraft.pale_oak_boat": "Nthàboote nthàthjau seen",
  "item.minecraft.pale_oak_chest_boat": "Nthàboote nthàthjau seen kuníxin nthàkajón",
  "item.minecraft.panda_spawn_egg": "Juja xraguxín kupaanda",
  "item.minecraft.paper": "Xrùun",
  "item.minecraft.parched_spawn_egg": "Juja xraguxín xídeꞌen jinda",
  "item.minecraft.parrot_spawn_egg": "Juja xraguxín kulooro",
  "item.minecraft.phantom_membrane": "Tejiido kuníngo jié",
  "item.minecraft.phantom_spawn_egg": "Juja xraguxín kuníngo jié",
  "item.minecraft.pig_spawn_egg": "Juja xraguxín kukuchi",
  "item.minecraft.piglin_banner_pattern": "Chjiꞌni bandeera",
  "item.minecraft.piglin_banner_pattern.desc": "Ruꞌa kuxíígu",
  "item.minecraft.piglin_banner_pattern.new": "Chjiꞌni ruꞌa kuxíígu",
  "item.minecraft.piglin_brute_spawn_egg": "Juja xraguxín piglin chrinthu",
  "item.minecraft.piglin_spawn_egg": "Juja xraguxín piglin",
  "item.minecraft.pillager_spawn_egg": "Juja xraguxín cheꞌe",
  "item.minecraft.pink_bundle": "Tsaxechjàn tjuáꞌnde",
  "item.minecraft.pink_dye": "Ndathengaxín tjuáꞌnde",
  "item.minecraft.pink_harness": "Arneese tjuáꞌnde",
  "item.minecraft.pitcher_plant": "Kàchiixra",
  "item.minecraft.pitcher_pod": "Espiiga kàchiixra",
  "item.minecraft.plenty_pottery_shard": "Thuꞌa seraamika tsjéxín",
  "item.minecraft.plenty_pottery_sherd": "Thuꞌa seraamika tsjéxín",
  "item.minecraft.poisonous_potato": "Thùkjà kuníxin xruan denxín ni",
  "item.minecraft.polar_bear_spawn_egg": "Juja xraguxín kuooso rua",
  "item.minecraft.popped_chorus_fruit": "Thùkooro tsíchján",
  "item.minecraft.porkchop": "Nthàù kukuchi yùà",
  "item.minecraft.potato": "Thùkjà",
  "item.minecraft.potion": "Xruan",
  "item.minecraft.potion.effect.awkward": "Xruan jee",
  "item.minecraft.potion.effect.empty": "Xruan kè chruꞌa tsúnchjian",
  "item.minecraft.potion.effect.fire_resistance": "Xruan juathexin ngaìn xrùꞌì",
  "item.minecraft.potion.effect.harming": "Xruan nchenixín",
  "item.minecraft.potion.effect.healing": "Xruan nchexingamexín",
  "item.minecraft.potion.effect.infested": "Xruan infestasioon",
  "item.minecraft.potion.effect.invisibility": "Xruan juaditjaan",
  "item.minecraft.potion.effect.leaping": "Xruan juachrínkà",
  "item.minecraft.potion.effect.levitation": "Xruan juatjaganga",
  "item.minecraft.potion.effect.luck": "Xruan sueerte",
  "item.minecraft.potion.effect.mundane": "Xruan ujekua",
  "item.minecraft.potion.effect.night_vision": "Xruan juadikun naxin xeꞌe",
  "item.minecraft.potion.effect.oozing": "Xruan chjìtjùn",
  "item.minecraft.potion.effect.poison": "Xruan denxín ni",
  "item.minecraft.potion.effect.regeneration": "Xruan juaxingama",
  "item.minecraft.potion.effect.slow_falling": "Xruan juakjamangi yau",
  "item.minecraft.potion.effect.slowness": "Xruan yauxín",
  "item.minecraft.potion.effect.strength": "Xruan tsangaxín",
  "item.minecraft.potion.effect.swiftness": "Xruan ntheduxín",
  "item.minecraft.potion.effect.thick": "Xruan kjinté",
  "item.minecraft.potion.effect.turtle_master": "Xruéèn Tjaagu xrùun Kunchènthà",
  "item.minecraft.potion.effect.water": "Xruxrau kuníxin jinda",
  "item.minecraft.potion.effect.water_breathing": "Xruan chrinthu ngaìn jinda",
  "item.minecraft.potion.effect.weakness": "Xruan juachrjén",
  "item.minecraft.potion.effect.weaving": "Xruan juatjaun",
  "item.minecraft.potion.effect.wind_charged": "Xruan chrinthu",
  "item.minecraft.pottery_shard_archer": "Thuꞌa seraamika xídenxunxín chijnu",
  "item.minecraft.pottery_shard_arms_up": "Thuꞌa seraamika sàꞌùn",
  "item.minecraft.pottery_shard_prize": "Thuꞌa seraamika tesooro",
  "item.minecraft.pottery_shard_skull": "Thuꞌa seraamika nthàjàà ni",
  "item.minecraft.powder_snow_bucket": "Kubeeta kuníxin chrintha xrunda",
  "item.minecraft.prismarine_crystals": "Xrusènthà pirismariina",
  "item.minecraft.prismarine_shard": "Thuꞌa pirismariina",
  "item.minecraft.prize_pottery_shard": "Thuꞌa seraamika tesooro",
  "item.minecraft.prize_pottery_sherd": "Thuꞌa seraamika tesooro",
  "item.minecraft.pufferfish": "Kuchenchaꞌa",
  "item.minecraft.pufferfish_bucket": "Kubeeta kuníxin kuchenchaꞌa",
  "item.minecraft.pufferfish_spawn_egg": "Juja xraguxín kuchenchaꞌa",
  "item.minecraft.pumpkin_pie": "Pasteele chu",
  "item.minecraft.pumpkin_seeds": "Tsee chu",
  "item.minecraft.purple_bundle": "Tsaxechjàn játsè thié",
  "item.minecraft.purple_dye": "Ndathengaxín játsè thié",
  "item.minecraft.purple_harness": "Arneese játsè thié",
  "item.minecraft.quartz": "Kuaarso Nether",
  "item.minecraft.rabbit": "Nthàù kuláanu yùà",
  "item.minecraft.rabbit_foot": "Ruthéè kuláanu",
  "item.minecraft.rabbit_hide": "Rua kuláanu",
  "item.minecraft.rabbit_spawn_egg": "Juja xraguxín kuláanu",
  "item.minecraft.rabbit_stew": "Ndàxrà kuláanu",
  "item.minecraft.raiser_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Juatsujin juanchekani",
  "item.minecraft.ravager_spawn_egg": "Juja xraguxín kuxinthàcha",
  "item.minecraft.raw_copper": "Koobere",
  "item.minecraft.raw_gold": "Tumisine",
  "item.minecraft.raw_iron": "Chìà",
  "item.minecraft.recovery_compass": "Buruujula juatusúji",
  "item.minecraft.red_bundle": "Tsaxechjàn játsè",
  "item.minecraft.red_dye": "Ndathengaxín játsè",
  "item.minecraft.red_harness": "Arneese játsè",
  "item.minecraft.redstone": "Redstone xrunda",
  "item.minecraft.resin_brick": "Xrùnùnthèchján chjìngù nthàà",
  "item.minecraft.resin_clump": "Chjìngù nthàà",
  "item.minecraft.rib_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Juatsujin nthànthànkuin ni",
  "item.minecraft.rotten_flesh": "Nthàù kè xengeꞌe",
  "item.minecraft.saddle": "Xintaun",
  "item.minecraft.salmon": "Kusalmon yùà",
  "item.minecraft.salmon_bucket": "Kubeeta kuníxin kusalmon",
  "item.minecraft.salmon_spawn_egg": "Juja xraguxín kusalmon",
  "item.minecraft.scrape_pottery_sherd": "Thuꞌa seraamika juatajema",
  "item.minecraft.scute": "Xuli",
  "item.minecraft.sentry_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Juatsujin xídayakuꞌen rajna",
  "item.minecraft.shaper_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Juatsujin xíchjéè foorma",
  "item.minecraft.sheaf_pottery_shard": "Thuꞌa seraamika jìnù najni",
  "item.minecraft.sheaf_pottery_sherd": "Thuꞌa seraamika jìnù najni",
  "item.minecraft.shears": "Tijerá",
  "item.minecraft.sheep_spawn_egg": "Juja xraguxín kuthuchjun",
  "item.minecraft.shelter_pottery_shard": "Thuꞌa seraamika refuujio",
  "item.minecraft.shelter_pottery_sherd": "Thuꞌa seraamika refuujio",
  "item.minecraft.shield": "Nthàeskuudo",
  "item.minecraft.shield.black": "Nthàeskuudo thié",
  "item.minecraft.shield.blue": "Nthàeskuudo yùà",
  "item.minecraft.shield.brown": "Nthàeskuudo seen",
  "item.minecraft.shield.cyan": "Nthàeskuudo yùà ngajní",
  "item.minecraft.shield.gray": "Nthàeskuudo xràtjù",
  "item.minecraft.shield.green": "Nthàeskuudo yùà",
  "item.minecraft.shield.light_blue": "Nthàeskuudo yùà",
  "item.minecraft.shield.light_gray": "Nthàeskuudo xràtjù",
  "item.minecraft.shield.lime": "Nthàeskuudo yùà",
  "item.minecraft.shield.magenta": "Nthàeskuudo játsè",
  "item.minecraft.shield.orange": "Nthàeskuudo thùnsán",
  "item.minecraft.shield.pink": "Nthàeskuudo tjuáꞌnde",
  "item.minecraft.shield.purple": "Nthàeskuudo játsè thié",
  "item.minecraft.shield.red": "Nthàeskuudo játsè",
  "item.minecraft.shield.white": "Nthàeskuudo rua",
  "item.minecraft.shield.yellow": "Nthàeskuudo sine",
  "item.minecraft.shulker_shell": "Juchu shulker",
  "item.minecraft.shulker_spawn_egg": "Juja xraguxín shulker",
  "item.minecraft.sign": "Nthàkjìxín",
  "item.minecraft.silence_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Juatsujin juajiau",
  "item.minecraft.silverfish_spawn_egg": "Juja xraguxín kuchexru",
  "item.minecraft.skeleton_horse_spawn_egg": "Juja xraguxín kunxin lantha",
  "item.minecraft.skeleton_spawn_egg": "Juja xraguxín xídeꞌen jintha",
  "item.minecraft.skull_banner_pattern": "Chjiꞌni bandeera",
  "item.minecraft.skull_banner_pattern.desc": "Nthàjàà ni",
  "item.minecraft.skull_banner_pattern.new": "Chjiꞌni nthàjàà ni",
  "item.minecraft.skull_pottery_shard": "Thuꞌa seraamika nthàjàà ni",
  "item.minecraft.skull_pottery_sherd": "Thuꞌa seraamika nthàjàà ni",
  "item.minecraft.slime_ball": "Thulu chjìtùn",
  "item.minecraft.slime_spawn_egg": "Juja xraguxín kuthuchjìtjùn",
  "item.minecraft.smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.smithing_template.applies_to": "Dunda íxin:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Dakee naá lingoote o xrusènthà",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armaduura",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Dakee naá thuꞌa armaduura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingoote kù xrusènthà",
  "item.minecraft.smithing_template.ingredients": "Thí túnchjianxín:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Dakee naá lingoote netheriita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Ekipamieento diamaante",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Dakee naá armaduura, nthàdenxunxín o nthàà diamaante",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingoote netheriita",
  "item.minecraft.smithing_template.upgrade": "Chjiꞌni: ",
  "item.minecraft.sniffer_spawn_egg": "Juja xraguxín kuthuchìnthjun",
  "item.minecraft.snort_pottery_shard": "Thuꞌa seraamika kuthuchìnthjun",
  "item.minecraft.snort_pottery_sherd": "Thuꞌa seraamika kuthuchìnthjun",
  "item.minecraft.snout_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Juatsujin ruꞌa kuxíígu",
  "item.minecraft.snow_golem_spawn_egg": "Juja xraguxín goolen chrintha",
  "item.minecraft.snowball": "Thulu chrintha",
  "item.minecraft.spectral_arrow": "Chijnu chiixru",
  "item.minecraft.spider_eye": "Kun kuthuchje",
  "item.minecraft.spider_spawn_egg": "Juja xraguxín kuthuchje",
  "item.minecraft.spire_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Juatsujin nthàchìà",
  "item.minecraft.splash_potion": "Xruan kè tjuà ni",
  "item.minecraft.splash_potion.effect.awkward": "Xruan jee kè tjuà ni",
  "item.minecraft.splash_potion.effect.empty": "Xruan kè tjuà ni kù chruꞌa tsúnchjian",
  "item.minecraft.splash_potion.effect.fire_resistance": "Xruan juathexin ngaìn xrùꞌì kè tjuà ni",
  "item.minecraft.splash_potion.effect.harming": "Xruan nchenixín kè tjuà ni",
  "item.minecraft.splash_potion.effect.healing": "Xruan nchexingamexín kè tjuà ni",
  "item.minecraft.splash_potion.effect.infested": "Xruan infestasioon kè tjuà ni",
  "item.minecraft.splash_potion.effect.invisibility": "Xruan juaditjaan kè tjuà ni",
  "item.minecraft.splash_potion.effect.leaping": "Xruan juachrínkà kè tjuà ni",
  "item.minecraft.splash_potion.effect.levitation": "Xruan juatjaganga kè tjuà ni",
  "item.minecraft.splash_potion.effect.luck": "Xruan sueerte kè tjuà ni",
  "item.minecraft.splash_potion.effect.mundane": "Xruan ujekua kè tjuà ni",
  "item.minecraft.splash_potion.effect.night_vision": "Xruan juadikun naxin xeꞌe kè tjuà ni",
  "item.minecraft.splash_potion.effect.oozing": "Xruan chjìtjùn kè tjuà ni",
  "item.minecraft.splash_potion.effect.poison": "Xruan chjìtjùn kè tjuà ni",
  "item.minecraft.splash_potion.effect.regeneration": "Xruan juaxingama kè tjuà ni",
  "item.minecraft.splash_potion.effect.slow_falling": "Xruan juakjamangi yau kè tjuà ni",
  "item.minecraft.splash_potion.effect.slowness": "Xruan yauxín kè tjuà ni",
  "item.minecraft.splash_potion.effect.strength": "Xruan tsangaxín kè tjuà ni",
  "item.minecraft.splash_potion.effect.swiftness": "Xruan ntheduxín kè tjuà ni",
  "item.minecraft.splash_potion.effect.thick": "Xruan kjinté kè tjuà ni",
  "item.minecraft.splash_potion.effect.turtle_master": "Xruéèn Tjaagu xrùun Kunchènthà kè tjuà ni",
  "item.minecraft.splash_potion.effect.water": "Xruxrau kuníxin jinda kè tjuà ni",
  "item.minecraft.splash_potion.effect.water_breathing": "Xruan chrinthu ngaìn jinda kè tjuà ni",
  "item.minecraft.splash_potion.effect.weakness": "Xruan juachrjén kè tjuà ni",
  "item.minecraft.splash_potion.effect.weaving": "Xruan juatjaun kè tjuà ni",
  "item.minecraft.splash_potion.effect.wind_charged": "Xruan chrinthu kè tjuà ni",
  "item.minecraft.spruce_boat": "Nthàboote nthànchicha",
  "item.minecraft.spruce_chest_boat": "Nthàboote nthànchicha kuníxin nthàkajón",
  "item.minecraft.spyglass": "Nthàdikunxín",
  "item.minecraft.squid_spawn_egg": "Juja xraguxín kuthuchjenda jié",
  "item.minecraft.stick": "Nthàà",
  "item.minecraft.stone_axe": "Nthàtadexín xru",
  "item.minecraft.stone_hoe": "Nthàtaunxín xru",
  "item.minecraft.stone_pickaxe": "Nthàpiiko xru",
  "item.minecraft.stone_shovel": "Nthàpalá xru",
  "item.minecraft.stone_spear": "Nthàthinchrjaxín xru",
  "item.minecraft.stone_sword": "Nthàespaada xru",
  "item.minecraft.stray_spawn_egg": "Juja xraguxín xíditjaan",
  "item.minecraft.strider_spawn_egg": "Juja xraguxín kuthuruthe",
  "item.minecraft.string": "Xuchjiꞌan",
  "item.minecraft.sugar": "Tsjen",
  "item.minecraft.suspicious_stew": "Ndàxrà jee",
  "item.minecraft.sweet_berries": "Thùbaaya",
  "item.minecraft.tadpole_bucket": "Kubeeta kuníxin xèꞌèn kurana",
  "item.minecraft.tadpole_spawn_egg": "Juja xraguxín xèꞌèn kurana",
  "item.minecraft.tide_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Juatsujin marea",
  "item.minecraft.tipped_arrow": "Chijnu kuníxin efeekto",
  "item.minecraft.tipped_arrow.effect.awkward": "Chijnu kuníxin efeekto",
  "item.minecraft.tipped_arrow.effect.empty": "Chijnu kuníxin efeekto kè chruꞌa tsúnchjian",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Chijnu juathexin ngaìn xrùꞌì",
  "item.minecraft.tipped_arrow.effect.harming": "Chijnu nchenixín",
  "item.minecraft.tipped_arrow.effect.healing": "Chijnu nchexingamexín",
  "item.minecraft.tipped_arrow.effect.infested": "Chijnu infestasioon",
  "item.minecraft.tipped_arrow.effect.invisibility": "Chijnu juaditjaan",
  "item.minecraft.tipped_arrow.effect.leaping": "Chijnu juachrínkà",
  "item.minecraft.tipped_arrow.effect.levitation": "Chijnu juatjaganga",
  "item.minecraft.tipped_arrow.effect.luck": "Chijnu sueerte",
  "item.minecraft.tipped_arrow.effect.mundane": "Chijnu kuníxin efeekto",
  "item.minecraft.tipped_arrow.effect.night_vision": "Chijnu juadikun naxin xeꞌe",
  "item.minecraft.tipped_arrow.effect.oozing": "Chijnu chjìtjùn",
  "item.minecraft.tipped_arrow.effect.poison": "Chijnu xruan denxín ni",
  "item.minecraft.tipped_arrow.effect.regeneration": "Chijnu juaxingama",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Chijnu juakjamangi yau",
  "item.minecraft.tipped_arrow.effect.slowness": "Chijnu yauxín",
  "item.minecraft.tipped_arrow.effect.strength": "Chijnu tsangaxín",
  "item.minecraft.tipped_arrow.effect.swiftness": "Chijnu ntheduxín",
  "item.minecraft.tipped_arrow.effect.thick": "Chijnu kuníxin efeekto",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Chijnúè Tjaagu xrùun Kunchènthà",
  "item.minecraft.tipped_arrow.effect.water": "Chijnu kè nchetjau",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Chijnu chrinthu ngaìn jinda",
  "item.minecraft.tipped_arrow.effect.weakness": "Chijnu juachrjén",
  "item.minecraft.tipped_arrow.effect.weaving": "Chijnu juatjaun",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Chijnu chrinthu",
  "item.minecraft.tnt_minecart": "Nthàbagon kuníxin dinamiita",
  "item.minecraft.torchflower_seeds": "Tsee kàxrùꞌì",
  "item.minecraft.totem_of_undying": "Tooten juachun",
  "item.minecraft.trader_llama_spawn_egg": "Juja xraguxín kuyaméè tachji",
  "item.minecraft.trial_key": "Yaabe chijni",
  "item.minecraft.trident": "Tirideente",
  "item.minecraft.tropical_fish": "Kuchee nthàjié tjau",
  "item.minecraft.tropical_fish_bucket": "Kubeeta kuníxin kuchee nthàjié tjau",
  "item.minecraft.tropical_fish_spawn_egg": "Juja xraguxín kuchee nthàjié tjau",
  "item.minecraft.turtle_helmet": "Juchu kunchènthà",
  "item.minecraft.turtle_scute": "Xuli kunchènthà",
  "item.minecraft.turtle_spawn_egg": "Juja xraguxín kunchènthà",
  "item.minecraft.vex_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Juatsujin chijni",
  "item.minecraft.vex_spawn_egg": "Juja xraguxín chijni",
  "item.minecraft.villager_spawn_egg": "Juja xraguxín chùjni rajna",
  "item.minecraft.vindicator_spawn_egg": "Juja xraguxín xíchru jiè",
  "item.minecraft.wandering_trader_spawn_egg": "Juja xraguxín tachji kè dachrji",
  "item.minecraft.ward_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Juatsujin xídayakuꞌen",
  "item.minecraft.warden_spawn_egg": "Juja xraguxín kuxinthàà jié",
  "item.minecraft.warped_fungus_on_a_stick": "Nthàà kuníxin kuchrjuì xraduꞌu",
  "item.minecraft.water_bucket": "Kubeeta kuníxin jinda",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Juatsujin xídikjee nthiꞌá",
  "item.minecraft.wheat": "Jìnù najni",
  "item.minecraft.wheat_seeds": "Tsee jìnù najni",
  "item.minecraft.white_bundle": "Tsaxechjàn rua",
  "item.minecraft.white_dye": "Ndathengaxín rua",
  "item.minecraft.white_harness": "Arneese rua",
  "item.minecraft.wild_armor_trim_smithing_template": "Chjiꞌni nchechjianxín chìà",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Juatsujin nthàjié",
  "item.minecraft.wind_charge": "Juathedue chrinthu",
  "item.minecraft.witch_spawn_egg": "Juja xraguxín nchríì jíanꞌa",
  "item.minecraft.wither_skeleton_spawn_egg": "Juja xraguxín xídeꞌen jintha Wither",
  "item.minecraft.wither_spawn_egg": "Juja xraguxín Wither",
  "item.minecraft.wolf_armor": "Armaduura íxin kukjèndà",
  "item.minecraft.wolf_spawn_egg": "Juja xraguxín kukjèndà",
  "item.minecraft.wooden_axe": "Nthàtadexín",
  "item.minecraft.wooden_hoe": "Nthàtaunxín",
  "item.minecraft.wooden_pickaxe": "Nthàpiiko",
  "item.minecraft.wooden_shovel": "Nthàpalá",
  "item.minecraft.wooden_spear": "Nthàthinchrjaxín",
  "item.minecraft.wooden_sword": "Nthàespaada",
  "item.minecraft.writable_book": "Xrùun kù nene kjìxín",
  "item.minecraft.written_book": "Xrùun kè detáxin",
  "item.minecraft.yellow_bundle": "Tsaxechjàn sine",
  "item.minecraft.yellow_dye": "Ndathengaxín sine",
  "item.minecraft.yellow_harness": "Arneese sine",
  "item.minecraft.zoglin_spawn_egg": "Juja xraguxín zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Juja xraguxín kunxin kè niꞌi ba",
  "item.minecraft.zombie_nautilus_spawn_egg": "Juja xraguxín kunautiilo kè niꞌi ba",
  "item.minecraft.zombie_spawn_egg": "Juja xraguxín xíniꞌi",
  "item.minecraft.zombie_villager_spawn_egg": "Juja xraguxín chùjni rajna kè niꞌi",
  "item.minecraft.zombified_piglin_spawn_egg": "Juja xraguxín piglin kè niꞌi"
}
export const pls = items; 
